import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { Link } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { MeasurementType, OrderDiscountType, OrderProductStatus, OrderStatus, CardType, CardAccountType, LanguageCode } from 'constants/enums';
import util from 'library/util';
import * as idb from 'config/db';
import { Barcode } from 'constants/enums';
import WithRouter from 'custom/withRouter';
import {
    saveOrder, voidItem, getOrder, cancelOrder, clearPOSError, updateDeviceIp, getPOS, finalizeOrder,
    posEmailReceipt, posSMSReceipt, setProductFilter, lockPinPassword, setPinUserToStore, getProductByBarcode, cleanProductDetail, getDeviceByIP, alpineIQCheckIn,
    getOldOpenOrders, cancelOpenOrders, cancelAllOpenOrders, cashInAmount, trackingDrawerOpen, getMonerisReceiptByOrderId, cancelOpenOnlineOrders, getOpenOnlineOrdersCount, getWordpressOrdersUpdate, cashFlowNotes,
    getManualWordpressOrdersUpdate, getInventoryFlag, getCombos, getSpringbigOffers, getSpringbigRewards, getSpringbigMemberPoints, alpineIQverifyWallet, alpineIQviewWallet, sendOrderToFulFillment,
    getPatientOrders, patientSpringBigNotifications, idOrderHistoryDialog, cleanOrderDetail, getSettings, getSellableProducts, updateRewardPoint, getOrderPatientReward, resetReward, clearAlpineIQ, saveOrderOffline,
    updatePackageReference, clearOfflineOrderError, voidOfflineItem, clearPriceMatchRows
} from 'actions/EntityActions';
import { initializeStorePOS, clearPOSCancellation, formInput, formError, addProductToPOSOder, clearFormInput, addComboProductToPOSOrder } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { buildURLScheme } from 'utils/IOSPrinting';
import { selectPOSCancellationCredentials, selectOpenOrdersCancellation, selectOpenOnlineOrdersCancellation } from 'selectors/entitySelector';
// Basic Components
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogConfirm from 'screens/components/basic/DialogConfirm';
import CustomButton from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import Avatar from 'screens/components/basic/Avatar';
import BadgeLabel from 'screens/components/basic/BadgeLabel';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components

// Child Components
import POSProduct from './POSProduct';
import POSPatient from './POSPatient';
import POSPayment from './POSPayment';
import POSPrintReceipt from './POSPrintReceipt';
import POSPrintLabel from './POSPrintLabel';
import POSOrderSummary from './POSOrderSummary';
import POSCashIn from './POSCashIn';
import POSCashOut from './POSCashOut';
import POSCashDrop from './POSCashDrop';
import POSRefundAmount from './POSRefundAmount';
import POSRecentOrdersDialog from './POSRecentOrdersDialog';
import POSCombos from './POSCombos';
import InventoryFlagDialog from './InventoryFlagDialog';
import PinScreen from '../../sales/pin/pinpadPassword';
import BarcodeReader from 'library/readBarcode';
import POSProductDetails from './POSProductDetails';
import POSAddMoreDialog from './POSAddMoreDialog';
import OnlineOrderSearch from 'screens/containers/ecommerce/onlineOrders/onlineOrderSearch';
import BuddiOrderSearch from 'screens/containers/ecommerce/buddiOrders/buddiOrderSearch';
import LeaflyOrderSearch from 'screens/containers/ecommerce/leaflyOrders/leaflyOrderSearch';
import POSCloseOpenOrders from './POSCloseOpenOrders';
import POSGiftCardinitialization from './giftcard/POSGiftCardinitialization';
import POSGiftCardInquiry from './giftcard/POSGiftCardInquiry';
import POSGiftCardActivation from './giftcard/POSGiftCardActivation';
import POSGiftCardDeactivation from './giftcard/POSGiftCardDeactivation';
import PaystoneGiftCardCheckBalance from './paystoneGiftcard/PaystoneGiftCardCheckBalance';
import PaystoneGiftCardActivation from './paystoneGiftcard/PaystoneGiftCardActivation';
import PaystoneGiftCardCancel from './paystoneGiftcard/PaystoneGiftCardCancel';
import BirchmountGiftCardCheckBalance from './birchmountGiftCard/BirchmountGiftCardCheckBalance';
import BirchmountGiftCardActivation from './birchmountGiftCard/BirchmountGiftCardActivation';
import BirchmountGiftCardCancel from './birchmountGiftCard/BirchmountGiftCardCancel';
import POSEmailReceiptDialog from './POSEmailReceiptDialog';
import POSSMSReceiptDialog from './POSSMSReceiptDialog';
import { stringToDecimalFormatter, numDaysBetween } from 'utils/helpers';
import POSVisitDiscountDialog from './POSVisitDiscountDialog';
import POSSpringbigOffersDialog from './POSSpringbigOffers';
import POSSpringbigRewardsDialog from './POSSpringbigRewards';
import POSAlpineIQRewardsDialog from './POSAlpineIQRewardsDialog';
import POSAssignMember from './POSAssignMember';
import DialogHeader from 'screens/components/basic/DialogHeader'
import PatientSave from '../../user/patient/PatientSave';
import POSVariableGiftCardDialog from './POSVariableGiftCardDialog';
import POSAccessorySaleDialog from './POSAccessorySaleDialog';
import { Button, Dialog, CircularProgress } from '@mui/material';
import POSProductListPage from './POSProductListPage';
import 'styles/sass/pos/POSPage.scss';
import { AddCircleOutlined } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import DoubleArrow from '@mui/icons-material/DoubleArrow';
import POSAddAsDutchieLeafly from './POSAddAsDutchie';
import POSMonerisTipDialog from './POSMonerisTipDialog';
import POSGiftCardPurchase from './giftcardPurchase/POSGiftCardPurchase';
import POSGiftCheckBalance from './giftcardPurchase/POSGiftCheckBalance';
import POSGiftCardAddToOrder from './giftcardPurchase/POSGiftCardAddToOrder';
import POSFirstNationIdCheckDialog from './POSFirstNationIdCheckDialog';
import POSOrderHistory from './POSOrderHistory';
import POSPatientSave from './POSPatientSave';
import imgDefault from 'images/imgDefault.jpg';
import RewardPoints from '../../user/patient/components/RewardPoints';
import POSProductSuggestion from './POSProductSuggestion';
import POSOpenDrawerPinDialog from '../pin/OpenDrawerPinDialog';
import ExcelUploadPOSOrder from 'screens/components/basic/ExcelUploadPOSOrder';
import SelectInputPOSLot from 'screens/components/basic/SelectInputPOSLot';
// import { useIdleTimer } from "react-idle-timer";
import IdleTimer from "react-idle-timer";

const customContentStyle = {
    width: '75%',
    maxWidth: 'none'
};

const addMemberStyle = {
    width: '100%',
    maxWidth: 'none'
};

const loadDialogStyle = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const loadDialogcustomContentStyle = {
    width: '145px',
    maxWidth: 'none'
};


class POSPage extends Component {
    constructor(props, context) {
        super(props, context);

        const hideMenuFromLocalStorage = localStorage.getItem('hideMenu');
        const hideMenuValue = hideMenuFromLocalStorage ? JSON.parse(hideMenuFromLocalStorage) : false;

        this.state = {
            dialogCheckId: true,
            dialogCheckFNId: false,
            dialogPatient: false,
            dialogCancelOrder: false,
            dialogOrderExists: false,
            showPrintReceipt: false,
            dialogCloseRegister: false,
            dialogCashIn: false,
            dialogCashDrop: false,
            dialogOpenDrawerPin: false,
            oldOpenOrdersDialog: false,
            oldOpenOnlineOrdersDialog: false,
            openInventoryFlagDialog: false,
            dialogServiceError: false,
            cashDrawerOpenWhenOrderCompleted: false,
            dialogRecentOrders: false,
            dialogRefundOrder: false,
            barcode: {
                id: '',
                qnt: ''
            },
            openDialogAddProduct: false,
            dialogProduct: null,
            onlineDialogOpen: false,
            buddiDialogOpen: false,
            leaflyDialogOpen: false,
            comboDialogOpen: false,
            filterCombos: [],
            comboProductClicked: null,
            openRefundAmount: false,
            openGiftCardInit: false,
            openGiftCardInquiry: false,
            openGiftCardActivation: false,
            openGiftCardDeactivation: false,
            openPaystoneGiftCardActivation: false,
            openPaystoneGiftCardCheckBalance: false,
            openPaystoneGiftCardCancel: false,
            openBirchmountGiftCardActivation: false,
            openBirchmountGiftCardCheckBalance: false,
            openBirchmountGiftCardCancel: false,
            openEmailReceiptDialog: false,
            openEmailInvoiceDialog: false,
            openSMSReceiptDialog: false,
            refund: 0,
            activateOrderId: 0,
            visitDiscountDialogOpen: false,
            springBigRewardsDialogOpen: false,
            springBigOffersDialogOpen: false,
            alpineIQRewardsDialogOpen: false,
            loading: false,
            cashInNoteDialog: false,
            cancelOpenOrdersDialog: false,
            assignMember: false,
            addMemberOpenDialog: false,
            addMoreProductDialog: false,
            addMoreProductDetail: null,
            paystoneActivationFromSale: false,
            birchmountActivationFromSale: false,
            scrollButtonShow: false,
            variableGiftCardDialog: false,
            addDutchieDialog: false,
            monerisTipDialog: false,
            isPaid: false,
            openSellGiftCard: false,
            openCheckBalanceDialog: false,
            showLastItemDialog: false,
            dialogVapeSale: false,
            dutchieOrLeafly: "",
            acccessorySaleDialog: false,
            genericGiftCardDialog: false,
            hideMenu: hideMenuValue,
            showOrderHistoryDialog: false,
            showPatientSaveDialog: false,
            openPointsDiag: false,
            productSuggestionDialog: false,
            confirmPOSOrderImportDialog: false,
            isOpenMessage: false,
            isImportingPOS: false,
            isAddToOrderDialogOpen: false,
            barcodeStr: "",
            barcodeTimeout: null,
            anchorEl: null,
            anchorElGift: null,
            anchorElPurchaseGift: null,
            anchorElPaystoneGift: null,
            anchorElBirchmountGift: null,
            dialogWebSocketError: false
        };

        this.barcodeReader = new BarcodeReader();
        this.ws = null;
        this.getOpenOnlineOrdersCountInterval = null;
        this.getWordpressOrdersUpdate = null;
        this.finalizeOrder = this.finalizeOrder.bind(this);
        this.lockPinPassword = this.lockPinPassword.bind(this);
        this.printReceipt = this.printReceipt.bind(this);
        this.printCredit = this.printCredit.bind(this);
        this.payByCardPIC = this.payByCardPIC.bind(this);
        this.payByGlobal = this.payByGlobal.bind(this);
        this.openDrawerAndDialog = this.openDrawerAndDialog.bind(this);
        this.closeRefundAmountDialog = this.closeRefundAmountDialog.bind(this);
        this.barcodeListener = this.barcodeListener.bind(this);
        this.openVisitDiscountDialog = this.openVisitDiscountDialog.bind(this);
        this.openSpringBigRewardsDialog = this.openSpringBigRewardsDialog.bind(this);
        this.openSpringBigOffersDialog = this.openSpringBigOffersDialog.bind(this);
        this.goToDevicesPage = this.goToDevicesPage.bind(this);
        this.lastItemAlert = this.lastItemAlert.bind(this);
        this.idleTimer = null;
        this.handleOnIdle = this.handleOnIdle.bind(this);
    }

    componentWillMount() {
        //CLEAN DETAIL FOR BARCODE
        this.props.cleanProductDetail();

        if (this.props.deviceKeyName != null && this.props.deviceKeyName != "" && this.props.deviceKeyName != undefined) {
            const deviceKeyName = this.props.deviceKeyName;
            const deviceData = JSON.parse(localStorage.getItem(deviceKeyName));
            const userPin = JSON.parse(sessionStorage.getItem('pinUser'));
            if (userPin !== null) {
                this.props.setPinUserToStore(userPin);
            }

            if (deviceData == null) {
                this.mapIpToDevice();
            } else {
                // check if local IP is up to date comparing it to the database
                this.verifyDevice(deviceKeyName);

                const orderId = this.props.params.id;
                if (orderId) {
                    const deviceData = JSON.parse(localStorage.getItem(deviceKeyName));
                    this.props.getOrder(orderId, this.props.branchId, deviceData.id);
                }
                else {
                    this.props.initializeStorePOS();
                }

                // get all data needed for POS
                this.props.getPOS(deviceData.id, this.props.branchId);

                try {
                    //if (process.env.NODE_ENV !== 'development') {
                    this.initWebSocket();
                    //}
                }
                catch (err) {
                    this.initWebSocket();
                }
            }
        }

        if (this.props.getOpenOnlineOrdersInterval > 0 && (this.props.hasWebMenu || this.props.buddiEnabled || this.props.leaflyEnabled) && this.props.branchId > 0) {
            this.props.getOpenOnlineOrdersCount(this.props.branchId);
            if (this.getOpenOnlineOrdersCountInterval == null) {
                this.getOpenOnlineOrdersCountInterval = setInterval(() => {
                    this.props.getOpenOnlineOrdersCount(this.props.branchId);
                }, 1000 * this.props.getOpenOnlineOrdersInterval);
            }
        }
    }

    componentDidMount() {
        //auto focus window after it mounts
        setTimeout(() => {
            window.focus();
        }, 2000);
        window.addEventListener("keypress", this.barcodeListener);
        this.props.getCombos({
            branchId: this.props.branchId,
            onlyActive: true
        });

        window.addEventListener("scroll", this.listenToScroll);

        if (this.props.offlineProductScan && !this.props.padVersion && this.props.posOrder) {
            window.addEventListener('beforeunload', this.handleBeforeUnload);
        }
    }

    componentWillReceiveProps(newProps) {
        // update device IP
        if (this.props.updateDeviceIpSaveError !== newProps.updateDeviceIpSaveError) {
            if (newProps.updateDeviceIpSaveError) {
                console.log("There is an error to initialize this POS. The IP address has been changed. Contact the manager to check the Device list and try to reload the page.");
            }
        }

        // link patient
        if (this.props.patient !== newProps.patient && newProps.patient !== undefined && newProps.patient !== null) {
            if (newProps.patient && (!this.props.patient || (this.props.patient.id !== newProps.patient.id))) {
                this.linkPatientToOder(newProps.patient);
            }
        }

        // add product
        if (newProps.newProduct && this.props.newProduct !== newProps.newProduct) {
            this.addProductToOrder(newProps.newProduct, null);
            this.closeProductSuggestionDialog()
        }

        //add combo product
        if (newProps.newComboProduct && this.props.newComboProduct !== newProps.newComboProduct) {
            this.addProductToOrder(null, newProps.newComboProduct);
        }

        // load pos order by redirecting
        if (!this.props.posOrder && newProps.posOrder) {
            if (newProps.posOrder.id && newProps.posOrder.id != 0) {
                this.props.navigate(`/pos/${newProps.posOrder.id}`);
            }
            if (newProps.posOrder.status === 'Completed' || newProps.posOrder.status == 2) {
                this.setState({ cashDrawerOpenWhenOrderCompleted: true });
            }
        }

        // order cancelled
        if (this.props.posOrderCancelled !== newProps.posOrderCancelled && newProps.posOrderCancelled !== undefined && newProps.posOrderCancelled !== null) {
            if (newProps.posOrderCancelled === true) {
                this.props.navigate(`/pos/${newProps.posOrder.id}`);
                this.setState({ dialogCancelOrder: false });
            }
        }

        //order cancelled all
        if (this.props.posOrderCancelledAll !== newProps.posOrderCancelledAll && newProps.posOrderCancelledAll) {
            window.location.reload();
        }

        // pos error
        if (this.props.posOrderError !== newProps.posOrderError && newProps.posOrderError) {
            if (newProps.posOrderError.success === false) {
                this.handleError(newProps.posOrderError);
            }
        }

        // pos email receipt sent
        if (this.props.posEmailReceiptSuccess !== newProps.posEmailReceiptSuccess && newProps.posEmailReceiptSuccess) {
            this.props.showSnackbar(this.props.t('pos.page.emailSentSuccess', { email: newProps.posEmailReceiptAddress }));
            this.props.formInput(null, 'posEmailReceiptSuccess');
            this.props.formInput(null, 'posEmailReceiptAddress');
        }

        // pos SMS receipt sent
        if (this.props.posSMSReceiptSuccess !== newProps.posSMSReceiptSuccess && newProps.posSMSReceiptSuccess === true) {
            this.props.showSnackbar(this.props.t('pos.messages.smsReceiptSent'));
            this.props.formInput(null, 'posSMSReceiptSuccess');
        }

        //Get Product By Barcode
        if (this.props.product === null && newProps.product) {
            if (newProps.product.id == 0 && newProps.product.comboProducts && newProps.product.comboProducts.length > 0) {
                this.addComboProductsToOrder(newProps.product.comboProducts);
            } else {
                this.preScanToOrder(newProps.product.id);
            }
        }

        //Get the barcode scan result
        if (newProps.barcodeNotFound && newProps.barcodeNotFound != this.props.barcodeNotFound) {
            this.props.showError(this.props.t('pos.page.productNotFound'));
        }

        if (newProps.posOrder && newProps.posOrder.orderProductStatus == 7 && this.props.posOrder != newProps.posOrder) {
            this.openDrawerAndDialog(newProps.posOrder.refund - this.props.posOrder.refund);
            this.printReceipt(newProps.posOrder, newProps.numberOfCopies);
        }

        if (newProps.savedDevice && newProps.savedDevice != this.props.savedDevice) {
            this.reloadPOS();
        }

        if (newProps.cashInSavedTime != undefined && newProps.cashInSavedTime != null && newProps.cashInSavedTime != this.props.cashInSavedTime) {
            this.closeDialogCashIn();
        }

        if (newProps.cashDropSavedTime != undefined && newProps.cashDropSavedTime != null && newProps.cashDropSavedTime != this.props.cashDropSavedTime) {
            this.closeDialogCashDrop();
        }

        if (newProps.oldOpenOrders != undefined && newProps.oldOpenOrders != null && newProps.oldOpenOrders.length > 0 && newProps.oldOpenOrderGotTime != this.props.oldOpenOrderGotTime && newProps.showOpenOrders === true) {
            this.openOldOpenOrdersDialog();
        }

        if (newProps.oldOpenOnlineOrders != undefined && newProps.oldOpenOnlineOrders != null && newProps.oldOpenOnlineOrders.length > 0 && newProps.oldOpenOrderGotTime != this.props.oldOpenOrderGotTime && newProps.showOpenOnlineOrders === true) {
            this.openOldOpenOnlineOrdersDialog();
        }

        if (newProps.inventoryFlags != undefined && newProps.inventoryFlags != null && newProps.inventoryFlags.length > 0 && newProps.inventroyFlagGotTime != this.props.inventroyFlagGotTime) {
            this.openInventoryFlagDialog();
        }

        if (newProps.inventoryFlags != undefined && newProps.inventoryFlags != null && newProps.inventoryFlags.length === 0 && newProps.inventroyFlagGotTime != this.props.inventroyFlagGotTime) {
            this.closeInventoryFlagDialog();
        }

        if (this.props.userPinAuthenticated !== newProps.userPinAuthenticated && newProps.userPinAuthenticated == true && (newProps.cashFlow == null || newProps.cashFlow == undefined) && !newProps.cashInEnabled) {
            const deviceData = JSON.parse(localStorage.getItem(newProps.deviceKeyName));
            newProps.cashInAmount(0, deviceData.id, newProps.branchId);
        }

        if (this.props.sendToFulfillmentSuccess !== newProps.sendToFulfillmentSuccess && newProps.sendToFulfillmentSuccess !== null && newProps.sendToFulfillmentSuccess !== undefined && newProps.fulfillmentEnabled) {
            this.props.showSnackbar(this.props.t('pos.messages.fulfillmentSent'));
        }

        if (newProps.deviceKeyName != null && newProps.deviceKeyName != "" && newProps.deviceKeyName != undefined && newProps.deviceKeyName != this.props.deviceKeyName) {
            const deviceKeyName = newProps.deviceKeyName;
            const deviceData = JSON.parse(localStorage.getItem(deviceKeyName));
            const userPin = JSON.parse(sessionStorage.getItem('pinUser'));
            if (userPin !== null) {
                this.props.setPinUserToStore(userPin);
            }

            if (deviceData == null) {
                this.mapIpToDevice();
            } else {
                // check if local IP is up to date comparing it to the database
                this.verifyDevice(deviceKeyName);

                const orderId = this.props.params.id;
                if (orderId) {
                    const deviceData = JSON.parse(localStorage.getItem(deviceKeyName));
                    this.props.getOrder(orderId, this.props.branchId, deviceData.id);
                }
                else {
                    this.props.initializeStorePOS();
                }
                // get all data needed for POS
                this.props.getPOS(deviceData.id, this.props.branchId);


                try {
                    //if (process.env.NODE_ENV !== 'development') {
                    this.initWebSocket();
                    //}
                }
                catch (err) {
                    this.initWebSocket();
                }
            }
        }

        if (newProps.monerisReceiptsTime != null && newProps.monerisReceiptsTime !== this.props.monerisReceiptsTime) {
            let that = this;
            for (let i = 0; i < newProps.monerisReceipts.length; i++) {
                (function (i) {
                    setTimeout(function () {
                        let result = newProps.monerisReceipts[i];
                        let model = {
                            TranscationType: result.TransType,
                            AccountType: CardAccountType[result.AccountType],
                            Amount: result.Amount,
                            CardType: CardType[result.CardType],
                            CardNumber: result.Pan,
                            CardName: result.CardName,
                            TranscationDate: result.TransDate,
                            TranscationTime: result.TransTime,
                            Reference: result.ReferenceNumber,
                            ResponseCode: result.ResponseCode,
                            ISO: result.ISO,
                            AuthCode: result.AuthCode,
                            AppLabel: result.AppLabel,
                            AppPreferredName: result.AppPreferredName,
                            Aid: result.Aid,
                            TvrArqc: result.TvrArqc,
                            TvrTcacc: result.TvrTcacc,
                            Tsi: result.Tsi,
                            CvmIndicator: result.CvmIndicator,
                            SwipeIndicator: result.SwipeIndicator,
                            LanguageCode: LanguageCode[result.LanguageCode],
                            InvoiceNumber: result.InvoiceNumber,
                            FFDT: result.FormFactor
                        }
                        that.printCredit(model, newProps.monerisReceiptType);
                    }, 4000 * i);
                })(i);
            }
        }

        if (newProps.getOpenOnlineOrdersInterval !== null && newProps.getOpenOnlineOrdersInterval !== undefined && newProps.getOpenOnlineOrdersInterval > 0 && newProps.getOpenOnlineOrdersInterval != this.props.getOpenOnlineOrdersInterval && (newProps.hasWebMenu || newProps.buddiEnabled || newProps.leaflyEnabled)) {
            this.props.getOpenOnlineOrdersCount(newProps.branchId);
            if (this.getOpenOnlineOrdersCountInterval == null) {
                this.getOpenOnlineOrdersCountInterval = setInterval(() => {
                    this.props.getOpenOnlineOrdersCount(newProps.branchId);
                }, 1000 * newProps.getOpenOnlineOrdersInterval);
            }
        }

        if (newProps.getWordpressOrdersInterval !== null && newProps.getWordpressOrdersInterval !== undefined && newProps.getWordpressOrdersInterval > 0 && newProps.getWordpressOrdersInterval != this.props.getWordpressOrdersInterval && newProps.wordpressEnabled) {
            this.getWordpressOrdersUpdate = setInterval(() => {
                this.props.getWordpressOrdersUpdate(newProps.branchId);
            }, 1000 * newProps.getWordpressOrdersInterval);
        }

        //gift card stuff
        if (newProps.monerisGiftCardEnabled) {
            if (newProps.giftCardInitializationTime !== null && newProps.giftCardInitializationTime !== undefined && newProps.giftCardInitializationTime !== this.props.giftCardInitializationTime) {
                this.closeGiftCardInitDialog();
                this.props.showSnackbar(this.props.t('pos.page.initializationSuccess'));
            }

            if (newProps.giftCardDatInquiryResponse !== null && newProps.giftCardDatInquiryResponse !== undefined && newProps.giftCardDatInquiryResponse !== this.props.giftCardDatInquiryResponse) {
                this.closeGiftCardInquiry();
                this.printGiftCardReceipt(newProps.giftCardDatInquiryResponse);
                this.props.showSnackbar(`${this.props.t('pos.page.currentBalance')}: ${newProps.giftCardDatInquiryResponse.currentBalance}`);
            }

            if (newProps.giftCardActivationResponse !== null && newProps.giftCardActivationResponse !== undefined && newProps.giftCardActivationResponse !== this.props.giftCardActivationResponse) {
                this.closeGiftCardActivation();
                this.printGiftCardReceipt(newProps.giftCardActivationResponse);
                this.props.showSnackbar(`${this.props.t('pos.page.currentBalance')}: ${newProps.giftCardActivationResponse.currentBalance}`);
            }

            if (newProps.giftCardDeactivationResponse !== null && newProps.giftCardDeactivationResponse !== undefined && newProps.giftCardDeactivationResponse !== this.props.giftCardDeactivationResponse) {
                this.closeGiftCardDeactivation();
                this.printGiftCardReceipt(newProps.giftCardDeactivationResponse);
                this.props.showSnackbar(this.props.t('pos.page.deactivationSuccess'));
            }

            if (newProps.giftCardPurchaseResponse !== null && newProps.giftCardPurchaseResponse !== undefined && newProps.giftCardPurchaseResponse !== this.props.giftCardPurchaseResponse) {
                this.printGiftCardReceipt(newProps.giftCardPurchaseResponse);
                this.props.showSnackbar(`${this.props.t('pos.page.currentBalance')}: ${newProps.giftCardPurchaseResponse.currentBalance}`);
            }

            if (newProps.giftCardRefundReponse !== null && newProps.giftCardRefundReponse !== undefined && newProps.giftCardRefundReponse !== this.props.giftCardRefundReponse) {
                this.printGiftCardReceipt(newProps.giftCardRefundReponse);
                this.props.showSnackbar(`${this.props.t('pos.page.currentBalance')}: ${newProps.giftCardRefundReponse.currentBalance}`);
            }

            if (newProps.giftCardPurchaseFailResponse !== null && newProps.giftCardPurchaseFailResponse !== undefined && newProps.giftCardPurchaseFailResponse !== this.props.giftCardPurchaseFailResponse) {
                this.printGiftCardReceipt(newProps.giftCardPurchaseFailResponse);
                this.props.showSnackbar(newProps.giftCardPurchaseFailResponse.errorMessage);
            }

            if (newProps.giftCardActivationFailResponse !== null && newProps.giftCardActivationFailResponse !== undefined && newProps.giftCardActivationFailResponse !== this.props.giftCardActivationFailResponse) {
                this.printGiftCardReceipt(newProps.giftCardActivationFailResponse);
                this.props.showSnackbar(newProps.giftCardActivationFailResponse.errorMessage);
            }
        }

        if (newProps.paystoneGiftCardEnabled) {
            if (newProps.paystoneGiftCardOperation !== null && newProps.paystoneGiftCardOperation !== undefined && newProps.paystoneGiftCardOperation !== this.props.paystoneGiftCardOperation) {
                this.closePaystoneGiftCardDialogs();
                this.printPaystoneGiftCardReceipt(newProps.paystoneGiftCardOperation);
                this.props.showSnackbar(`Success! ${this.props.t('pos.page.currentBalance')}: ${newProps.paystoneGiftCardOperation.balance}`);
            }
        }

        if (newProps.birchmountGiftCardEnabled) {
            if (newProps.birchmountGiftCardOperation !== null && newProps.birchmountGiftCardOperation !== undefined && newProps.birchmountGiftCardOperation !== this.props.birchmountGiftCardOperation) {
                this.closeBirchmountGiftCardDialogs();
                this.printBirchmountGiftCardReceipt(newProps.birchmountGiftCardOperation.response);
                this.props.showSnackbar(`${this.props.t('pos.page.success')}! ${this.props.t('pos.page.currentBalance')}: ${newProps.birchmountGiftCardOperation.response.balance}`);
            }
        }

        if ((newProps.openQueuedOrdersCount && newProps.openQueuedOrdersCount !== this.props.openQueuedOrdersCount)) {
            this.PlayNotification();
        }

        if (newProps.posOrder && this.props.posOrder && this.props.posOrder != newProps.posOrder && this.props.posOrder.status === "Opened" && (newProps.posOrder.status === "Completed" || newProps.posOrder.status === "Returned" || newProps.posOrder.status === "ReturnedPartial" || newProps.posOrder.status === "WaitingPickUp" || newProps.posOrder.status === "WaitingFulfillment")) {
            this.ToggleClosePayment();
        }

        if (newProps.posCreated !== null && newProps.posCreated !== undefined && newProps.posCreated !== this.props.posCreated && newProps.posOrder && newProps.posOrder.products && newProps.posOrder.products.find(p => p.category && p.category.toLowerCase().indexOf('vape') !== -1) && newProps.showVapeProductSaleDialog) {
            this.setState({ dialogVapeSale: true });
        }

        //reward points set
        if (newProps.rewardSuccess !== undefined && newProps.rewardSuccess !== this.props.rewardSuccess && newProps.rewardSuccess !== null) {

            if (newProps.rewardSuccess) {
                this.props.showSnackbar(this.props.t('pos.page.rewardPointsChangeSuccess'))
                this.props.getOrderPatientReward(this.props.posOrder.id)
                this.props.resetReward();
                this.closePointsDialog();
            } else {
                this.props.showError(newProps.rewardError)
            }
        }

        if (newProps.eliteMemberEndDate && newProps.eliteMemberEndDate !== this.props.eliteMemberEndDate) {
            let daysDiff = Math.ceil(numDaysBetween(new Date(newProps.eliteMemberEndDate), new Date()));
            const eliteEndDate = new Date(newProps.eliteMemberEndDate).getTime();
            const currentDate = new Date().getTime()

            //show dialog if elite member going to be expire in 15 days
            if ((eliteEndDate > currentDate) && daysDiff < 15) {
                this.props.showError(`${this.props.t('common.membershipGoingExpiredWarning', { daysDiff: daysDiff })}`);
            }

            // Expired elite members
            if (eliteEndDate < currentDate) {
                const purchaseSKU = "SKU: 420/Y";
                const renewSKU = "SKU: 420/Y-Renew";
                const eliteMessage = eliteEndDate < currentDate && daysDiff > 15
                    ? <span>. {this.props.t('pos.page.purchaseEliteMembership', { sku: purchaseSKU })}</span>
                    : <span> {this.props.t('pos.page.renewEliteMembership', { sku: renewSKU })}</span>
                this.props.showError(<div><span>{this.props.t('pos.page.eliteMembershipExpireWarning')} {eliteMessage}</span></div>);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.posOrder && prevProps.posOrder && this.props.posOrder.id != prevProps.posOrder.id) {
            this.props.navigate(`/pos/${this.props.posOrder.id}`);
        }

        if (this.props.posOrder && this.props.posOrder.status == "Completed" && prevProps.posOrder && prevProps.posOrder.status == "Opened") {
            this.lastItemAlert();
        }

        if (!this.props.posOrder && prevProps.posOrder && this.props.showAddMemberAfterSale && !this.state.dialogCashIn) {
            this.openAddMemberDialog();
        }

        if (this.props.posOrder && this.props.posOrder.patientId && this.props.posOrder.patientId !== 0 && (!prevProps.posOrder || prevProps.posOrder.patientId === 0 || prevProps.posOrder.patientId === null)) {
            if (this.props.springbigApiKey !== "") {
                this.props.patientSpringBigNotifications({ patientId: this.props.posOrder.patientId, branchId: this.props.branchId, compName: "POSPage" });
            }
        }

        if (this.props.logoutPinAfterSeconds && this.idleTimer) {
            if (this.state != prevState && !this.isAllDialogClosed()) {
                this.idleTimer.pause();
            }
            if (this.state != prevState && this.isAllDialogClosed()) {
                this.idleTimer.reset();
            }
        }

        if (this.props.posOrder && this.props.posOrder.totalGramExceed && prevProps.posOrder && !prevProps.posOrder.totalGramExceed) {
            this.props.showError(this.props.t('pos.page.limitOfDriedExceeded'));
            this.props.clearOfflineOrderError();
        }

        if (this.props.posOrder && this.props.posOrder.totalQtyExceed && prevProps.posOrder && !prevProps.posOrder.totalQtyExceed) {
            this.props.showError(this.props.t('pos.page.productNotEnoughStock'));
            this.props.clearOfflineOrderError();
        }

        if (this.props.offlineProductScan && !this.props.padVersion && this.props.posOrder) {
            window.addEventListener('beforeunload', this.handleBeforeUnload);
        } else {
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
        if (this.ws) {
            this.ws.close();
        }
        this.props.clearFormInput('POSPatientPatient');
        this.props.clearPOSError();
        window.removeEventListener("keypress", this.barcodeListener);
        clearInterval(this.getOpenOnlineOrdersCountInterval);
        clearInterval(this.getWordpressOrdersUpdate);
        window.removeEventListener('scroll', this.listenToScroll);
        if (sessionStorage.getItem('shouldRefreshPOS') === 'true') {
            sessionStorage.removeItem('shouldRefreshPOS');
            window.location.reload()
        }

        if (this.props.offlineProductScan && !this.props.padVersion && this.props.posOrder) {
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
        }
    }

    handleBeforeUnload = (event) => {
        const message = this.props.t('pos.page.leaveConfirm');
        event.returnValue = message;
        return message;
    };

    isAllDialogClosed = () => {
        const dialogs = [
            this.state.dialogPatient,
            this.state.addMemberOpenDialog,
            this.state.dialogCashIn,
            this.state.dialogCashDrop,
            this.state.dialogRecentOrders,
            this.state.dialogRefundOrder,
            this.state.cancelOpenOrdersDialog,
            this.state.cashInNoteDialog,
            this.state.dialogCloseRegister,
            this.state.dialogOpenDrawerPin,
            this.state.onlineDialogOpen,
            this.state.comboDialogOpen,
            this.state.openPaystoneGiftCardCheckBalance,
            this.state.openSellGiftCard,
            this.state.openCheckBalanceDialog,
            this.state.isPaid,
            this.state.isImportingPOS,
            this.state.isAddToOrderDialogOpen,
            this.state.buddiDialogOpen,
            this.state.leaflyDialogOpen,
            this.state.openDialogAddProduct
        ];

        return dialogs.every(dialog => !dialog);
    }

    handleOnIdle() {
        this.props.lockPinPassword();
        if (this.props.posOrder) {
            this.startNewOrder();
        }
    }

    openDrawerAndDialog = (refund) => {
        console.log("I want to open the drawer");
        console.log(`The refund amount is ${refund}`);
        let ws = window.posWebSocket;
        if (ws && ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const model = {
                Command: 'OPEN DRAWER',
                Data: null
            };
            ws.send(JSON.stringify(model));

            this.setState({
                openRefundAmount: true,
                refund: refund
            });
        }
        else if (this.props.padVersion) {
            openCashDrawer('OPEN DRAWER');
            this.setState({
                openRefundAmount: true,
                refund: refund
            });
        }
    }

    openDrawerPinDialog = (currentState) => {
        this.setState({ ...this.state, dialogOpenDrawerPin: !currentState })
    }

    closeRefundAmountDialog = () => {
        this.setState({
            openRefundAmount: false
        });
    }

    handleCheckId() {
        this.setState(prevState => {
            return {
                ...prevState,
                dialogCheckId: !prevState.dialogCheckId
            }
        });
    }

    handleCheckFNId() {
        this.setState(prevState => {
            return {
                ...prevState,
                dialogCheckFNId: !prevState.dialogCheckFNId
            }
        });
        this.applyTaxExempt("FNTaxes")
    }

    barcodeListener = (e) => {
        if (document.activeElement.tagName != "INPUT") {
            e.preventDefault();
            if (this.props.offlineProductScan && !this.props.padVersion) {
                this.setState(prevState => ({
                    barcodeStr: prevState.barcodeStr + (e.key == 'Enter' ? '\n' : e.key)
                }))

                if (this.state.barcodeTimeout != null) {
                    clearTimeout(this.state.barcodeTimeout)
                }

                this.setState({
                    barcodeTimeout: setTimeout(() => {
                        this.getProductByBarcode(this.state.barcodeStr)
                        this.setState({
                            barcodeStr: ""
                        })
                    }, 500)
                })
            } else {
                this.barcodeReader.listening(this.getProductByBarcode, 1000);
            }
        }
    }

    getProductByBarcode = (barcodes) => {
        if (!this.props.loading && this.props.cachingProducts) {
            this.getCachedProductsByBarcodes(barcodes);
        } else if (!this.props.loading) {
            this.props.getProductByBarcode(barcodes, this.props.branchId);
        }
    }

    getBarcodeType = (barcode) => {
        if (barcode[0] == 'Z') {
            return Barcode.Product;

        } else if (barcode[0] == 'C') {
            return Barcode.Combo;

        } else if (barcode.length >= 25 && barcode.substring(0, 2) === "01" && (barcode.substring(16, 18) === "17" || barcode.substring(16, 18) === "13")
            && barcode.substring(24, 26) === "10") {
            return Barcode.Government;

        } else if (barcode.substring(0, 5) == "01006") {
            return Barcode.GreenPreRole;

        } else {
            return Barcode.UPC;
        }
    }

    getCachedProductsByBarcodes = async (barcodesStr) => {
        const barcodes = barcodesStr.split("\n");
        let p = this.props;
        const newProducts = await Promise.all(
            barcodes
                .filter(barcode => barcode.trim() !== "")
                .map(async barcode => {
                    const barcodeType = this.getBarcodeType(barcode);

                    if (barcodeType === Barcode.Product) {
                        const productId = parseInt(barcode.replace("Z", ""), 10);
                        return await idb.product.getById(productId);

                    } else if (barcodeType === Barcode.Combo) {
                        const comboId = parseInt(barcode.replace("C", ""), 10);
                        const combo = this.props.comboList.find(combo => combo.id == comboId);
                        return combo.products;

                    } else if (barcodeType === Barcode.Government) {
                        // not implemented, getByLotNumber
                        return null;

                    } else if (barcodeType === Barcode.GreenPreRole) {
                        // Not implemented
                        return null;

                    } else {
                        return await idb.product.getByBarcode(barcode);
                    }
                }));

        this.props.saveOrderOffline(p.posOrder, newProducts, p.isInspired);
    }

    addComboProductsToOrder = (comboProducts) => {
        this.props.cleanProductDetail();
        if (!this.props.posOrder || this.props.posOrder.status === OrderStatus.Opened) {
            let comboProductsVM = [];
            comboProducts.map((comboProduct) => comboProductsVM.push({
                ...comboProduct,
                id: 0,
                productId: comboProduct.id,
                quantity: comboProduct.quantity,
                isManuallyInputted: false,
                packageReference: comboProduct.packages ? comboProduct.packages.length > 0 ? comboProduct.packages[0].packageReference : '' : '',
                price: comboProduct.originalUnitPrice
            }))
            this.props.addComboProductToPOSOrder(comboProductsVM);

        }
        else {
            this.props.showError(this.props.t('pos.page.mustStartNewOrder'));
        }
    }

    preScanToOrder(id, quantity = 1) {
        this.setState(prevState => {
            return {
                ...prevState,
                barcode: {
                    ...prevState.barcode,
                    id: id,
                    qnt: quantity
                }
            }
        }, this.scanToOrder);
    }

    scanToOrder() {
        //CLEAN DETAIL FOR BARCODE
        this.props.cleanProductDetail();
        if (parseFloat(this.state.barcode.qnt) === 0) {
            this.props.setProductFilter(parseInt(this.state.barcode.id));
        } else {
            if (!this.props.posOrder || this.props.posOrder.status === OrderStatus.Opened) {

                let product = this.props.product;
                if (product !== null) {
                    //If there`s 1/0 lots - we need to check if it`s medical or retail to add automatically or not
                    if (this.props.offlineProductScan && !this.props.padVersion || product.packages.length <= 1) {
                        //If it`s not medical - add automatically
                        if (!this.props.isMedical) {
                            this.props.addProductToPOSOder({
                                id: 0,
                                productId: this.state.barcode.id,
                                quantity: product.quantitySelected > 0 ? product.quantitySelected : this.state.barcode.qnt,
                                isManuallyInputted: false,
                                packageReference: (product.packages.length === 1 ? product.packages[0].packageReference : ""),
                                packages: product.packages,
                                isCannabis: true,
                                isScanned: true
                            });
                        }
                        //If it`s medical, we have to ask the unit/weight
                        else {
                            if (product.quantitySelected > 0) {
                                this.props.addProductToPOSOder({
                                    id: 0,
                                    productId: this.state.barcode.id,
                                    quantity: product.quantitySelected,
                                    isManuallyInputted: false,
                                    packageReference: (product.packages.length === 1 ? product.packages[0].packageReference : ""),
                                    packages: product.packages,
                                    isCannabis: true,
                                    isScanned: true
                                });
                            } else {
                                this.setState({ openDialogAddProduct: true, dialogProduct: product });
                            }
                        }
                    }
                    //If there are many lots, we need to ask the which lot
                    else {
                        this.setState({ openDialogAddProduct: true, dialogProduct: product });
                    }
                }

            } else {
                this.props.showError(this.props.t('pos.page.mustStartNewOrder'));
            }
        }
    }

    updateDialogProduct(product) {
        this.setState({ dialogProduct: product })
    }

    addToOrder = (product) => {
        const order = this.props.posOrder;
        const orderHasPayment = order && order.payments && order.payments.length > 0;
        if (!orderHasPayment) {
            this.setState({ openDialogAddProduct: true, isAddingProduct: true, dialogProduct: product });
        }
        else {
            this.props.showError(this.props.t('pos.page.cannotAddProduct'));
        }
    }

    closeAddProductDialog = () => {
        this.setState({ openDialogAddProduct: false, dialogProduct: null });
    }

    closeAddMoreProductDialog = () => {
        this.setState({ addMoreProductDialog: false, addMoreProductDetail: null });
    }

    initWebSocket = () => {
        try {
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";
            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    console.log('ws connected');
                }
            };

            this.ws.onerror = () => {
                if (this.props.posFraudProtection) {
                    this.setState({ dialogServiceError: true });
                }
            };

            this.ws.onclose = (event) => {
                if (event.code !== 1000 && this.props.posFraudProtection) {
                    this.setState({ dialogServiceError: true });
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];
                switch (responseType) {
                    case 'SCALE':
                        if (value !== 'OFFLINE') {
                            //MATH ROUND - Put the Parse on the Math.round - To avoid long numbers.
                            console.log(value);
                            let amountScale = value;
                            //;
                            if (amountScale > 0)
                                this.props.formInput(amountScale, 'POSProductsDetailsAmount');
                            else
                                this.props.showError(this.props.t('pos.page.scaleWeightLessThanZero'));
                        }
                        else {
                            this.formInput(false, 'posIsScaleAvailable');
                        }
                        break;
                    case 'MACADDRESS':
                        console.log("here is the mac address");
                        console.log(value);
                        break;
                    case 'PICPAYMENT':
                        console.log("here is the pic");
                        console.log(value);
                        if ((value == "" || value == null || value == undefined)) {
                            value = "FF";
                            alert(this.props.t('pos.page.paymentFailed'));
                        };
                        this.props.formInput(response, `picStatus`);
                        break;
                    case "GLOBALPAYMENT":
                        console.log("here is the global");
                        console.log(value);
                        this.props.formInput(response, `globalStatus`);
                        break;
                    default:
                        break;
                }
            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(1000);
                    window.posWebSocket = null;
                }
            };

            window.posWebSocket = this.ws;
        }
        catch (err) {
            console.log(err);
        }
    }

    reloadPOS = () => {
        window.location.reload();
    }

    formInput = (value, name) => {
        this.props.formInput(value, name);
    }

    mapIpToDevice = () => {
        let findIP = new Promise(r => {
            let w = window;
            let a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({
                iceServers: []
            }), b = () => { };
            a.createDataChannel("");
            a.createOffer(c => a.setLocalDescription(c, b, b), b);
            a.onicecandidate = c => {
                try {
                    c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r);
                }
                catch (e) {
                    console.log(e);
                }
            };
        });

        findIP.then(ip => {
            console.log(ip);
            this.props.getDeviceByIP(ip, this.props.branchId);
        }).catch(e => { console.log(e); });
    }

    verifyDevice = (deviceKeyName) => {
        const deviceData = JSON.parse(localStorage.getItem(deviceKeyName));
        let findIP = new Promise(r => {
            let w = window;
            let a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({
                iceServers: []
            }), b = () => { };
            a.createDataChannel("");
            a.createOffer(c => a.setLocalDescription(c, b, b), b);
            a.onicecandidate = c => {
                try {
                    c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r);
                }
                catch (e) {
                    console.log(e);
                }
            };
        });

        findIP.then(ip => {
            if (deviceData.ipAddress !== ip) {
                this.props.updateDeviceIp(deviceData.id, ip);
            }
        }).catch(e => { console.log(e); });
    }

    handleError = (data) => {
        switch (data.error) {
            // OpenedOrderExisted
            case 1: {
                this.setState({ dialogOrderExists: true });
                break;
            }
            // PatientMandatory
            case 2: {
                this.props.showError(this.props.t('pos.messages.noPatientSelectedCannabisProduct'));
                break;
            }
            // OrderNotAdd
            case 3: {
                this.props.showError(data.message ? data.message : this.props.t('pos.messages.errorSave'));
                break;
            }
            // OrderNotUpdate
            case 4: {
                this.props.showError(data.message ? data.message : this.props.t('pos.messages.errorSave'));
                break;
            }
            // OrderNotCancelled
            case 5: {
                this.props.showError(this.props.t('pos.messages.errorSave'));
                break;
            }
            // OrderNotCompleted
            case 6: {
                this.props.showError(this.props.t('pos.messages.errorSave'));
                break;
            }
            // PaymentNotAdd
            case 7: {
                this.props.showError(this.props.t('pos.messages.errorSave'));
                break;
            }
            // ProductNotVoid
            case 8: {
                this.props.showError(this.props.t('pos.messages.voidItemError'));
                break;
            }
            // InvalidCredentials
            case 9: {
                this.props.showError(this.props.t('pos.messages.invalidCredentials'));
                break;
            }
            // UnavailableProductStock
            case 10: {
                this.props.showError(this.props.t('pos.messages.unavailableProductStock'));
                break;
            }
            // OrderNotFound
            case 14: {
                this.props.showError((
                    <div>
                        <p>{this.props.t('pos.messages.orderNotFound')}</p>
                        <Button
                            type="RaisedButton"
                            name="startNewOrderButtonNotFound"
                            label={this.props.t('pos.buttons.startNewOrder')}
                            fullWidth={true}
                            primary={true}
                            onTouchTap={() => this.startNewOrder()} />
                    </div>
                ), false);
                break;
            }
            // EmailReceiptNotSended
            case 16: {
                this.props.showError(this.props.t('pos.messages.emailReceiptNotSent'));
                break;
            }
            // EmailReceiptInvalid
            case 17: {
                this.props.showError(this.props.t('pos.messages.emailReceiptInvalid'));
                break;
            }
            //ProductWarehouseNotFound
            case 18: {
                const message = data.message ? data.message.message : this.props.t('pos.messages.productWarehouseNotFound')
                this.props.showError(message);
                break;
            }
            //InactiveProductException
            case 19: {
                this.props.showError(this.props.t('pos.messages.InactiveProductException'));
                break;
            }
            //InvalidQuantityForProduct
            case 20: {
                this.props.showError(this.props.t('pos.messages.invalidQuantityForProduct'));
                break;
            }
            case 21: {
                const message = data.message ? data.message.message : this.props.t('pos.messages.invalidQuantityForOrder')
                this.props.showError(message);
                break;
            }

            //StoreCreditInSufficient
            case 22: {
                this.props.showError(this.props.t('pos.messages.storeCreditInSufficient'));
                break;
            }

            //NoStoreCreditAvailable
            case 23: {
                this.props.showError(this.props.t('pos.messages.noStoreCreditAvailable'));
                break;
            }

            //SMS Not Sent
            case 24: {
                this.props.showError(this.props.t('pos.messages.noStoreCreditAvailable'));
                break;
            }

            case 25: {
                this.props.showError(this.props.t('pos.messages.orderAlreadyCompleted'));
                break;
            }

            case 26: {
                this.props.showError(this.props.t('pos.messages.orderAfterStoreHours'));
                break;
            }

            case 27: {
                this.props.showError(this.props.t('pos.messages.orderAlreadyDone'));
                break;
            }
            case 30: {
                this.props.showError(this.props.t('pos.messages.OrderNotCreatedToday'));
                break;
            }

            default:
                break;
        }
    }

    redirectExistingOrder = () => {
        window.location = `/pos/${this.props.posOrderError.data.id}`;
        this.props.clearPOSError();
        this.setState({ dialogOrderExists: false });
    }

    cancelRedirectExistingOrder = () => {
        this.setState({ dialogOrderExists: false });
        this.props.clearPOSError();
    }

    openPatientDialog = () => {
        this.setState({ dialogPatient: true });
        window.removeEventListener("keypress", this.barcodeListener);
    }

    closePatientDialog = () => {
        this.setState({ dialogPatient: false });
        window.addEventListener("keypress", this.barcodeListener);
    }

    addMember = () => {
        this.props.navigate('/member/add');
    }

    openCloseRegisterDialog = () => {
        this.props.getInventoryFlag(this.props.branchId);
        this.setState({ dialogCloseRegister: true });
        //check if there are open orders from yesterday
        this.props.getOldOpenOrders(this.props.branchId);
    }


    closeCloseRegisterDialog = () => {
        this.setState({ dialogCloseRegister: false });
    }

    openDialogCashIn = () => {
        this.setState({ dialogCashIn: true });
    }

    closeDialogCashIn = () => {
        this.setState({ dialogCashIn: false });
    }

    openDialogCashDrop = () => {
        let cashTotal = this.props.cashFlow ? this.props.cashFlow.cashTotal : 0.00;
        this.props.formInput(cashTotal.toFixed(2), "POSCashDropCashDropAmount");
        this.setState({ dialogCashDrop: true });
    }

    closeDialogCashDrop = () => {
        this.setState({ dialogCashDrop: false });
    }

    openOldOpenOrdersDialog = () => {
        this.setState({ oldOpenOrdersDialog: true });
    }

    closeOldOpenOrdersDialog = () => {
        this.setState({ oldOpenOrdersDialog: false });
    }

    openOldOpenOnlineOrdersDialog = () => {
        this.setState({ oldOpenOnlineOrdersDialog: true });
    }

    closeOldOpenOnlineOrdersDialog = () => {
        this.setState({ oldOpenOnlineOrdersDialog: false });
    }

    confirmCloseOpenOrders = () => {
        this.setState({ oldOpenOrdersDialog: false });
        this.props.cancelOpenOrders(this.props.openOrdersCancellation);
    }

    confirmCloseOpenOnlineOrders = () => {
        this.setState({ oldOpenOnlineOrdersDialog: false });
        this.props.cancelOpenOnlineOrders(this.props.openOnlineOrdersCancellation);
    }

    openInventoryFlagDialog = () => {
        this.setState({ openInventoryFlagDialog: true });
    }

    openDialogCancelOrder = () => {
        this.props.clearPOSCancellationDialog();
        this.setState({ dialogCancelOrder: true });
    }

    closeDialogCancelOrder = () => {
        this.setState({ dialogCancelOrder: false });
    }

    cancelOrder = () => {
        this.setState({ dialogCancelOrder: false });
        if (this.props.offlineProductScan && !this.props.padVersion && this.props.posOrder.id == 0) {
            this.props.cleanOrderDetail(this.props.posShowProductCount);
            this.clearFilter();
        } else {
            const model = this.props.cancellationCredentials;
            this.props.cancelOrder(this.props.posOrder.id, model);
        }
    }

    linkPatientToOder = (patient) => {
        const orderModel = this.selectOrderModel(patient, null, null);
        this.props.saveOrder(orderModel);
    }

    removeMember = () => {
        this.props.clearFormInput("POSPatientPatient");
        const orderModel = this.selectOrderModel(null, null, null, true);
        this.props.saveOrder(orderModel);
    }

    addProductToOrder = (newProduct, newComboProduct) => {
        let p = this.props;
        if (this.props.offlineProductScan && !this.props.padVersion) {
            const productsModel = newProduct ? (newProduct.isScanned ? this.props.scannedProducts : [newProduct]) : newComboProduct
            this.props.saveOrderOffline(this.props.posOrder, productsModel, p.isInspired);
        } else {
            const orderModel = this.selectOrderModel(null, newProduct, newComboProduct);
            this.props.saveOrder(orderModel);
        }
    }

    voidItem = (orderId, orderProductid, removeProduct = false, product) => {
        let p = this.props;
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const employeeId = this.props.userPin.authenticated ? this.props.userPin.employee.id : 0;
        const modifiedDate = this.props.posOrder.modifiedDate;

        if (this.props.offlineProductScan && !this.props.padVersion) {
            this.props.voidOfflineItem(product, p.isInspired);
        } else {
            this.props.voidItem(orderId, orderProductid, deviceData.id, employeeId, this.props.branchId, removeProduct, modifiedDate);
        }
    }

    addMoreProducts = (product) => {
        this.setState({ addMoreProductDialog: true, addMoreProductDetail: product });
    }

    activateCard = (orderId, price, productName = "", productId = 0) => {
        let p = this.props;
        const isGenericGiftCard = productName.replace(/ /g, '').toLowerCase() === "giftcard";
        this.props.formInput(productId, "currentGiftCardActive");

        if (p.genericGiftCardEnabled && isGenericGiftCard) {
            this.setState({ genericGiftCardDialog: true });
            this.props.formInput(price.toFixed(2), "paidGenericGiftCardActivationAmount");
        } else if (p.monerisGiftCardEnabled) {
            this.setState({
                openGiftCardActivation: true,
                activateOrderId: orderId
            });
            this.props.formInput(price.toFixed(2), "POSGiftCardActivationinitAmount");
        } else if (p.paystoneGiftCardEnabled) {
            this.setState({
                paystoneActivationFromSale: true
            });
            this.openPaystoneGiftCardActivationDialog();
            this.props.formInput(price.toFixed(2), "PaystoneGiftCardActivationAmount");
        } else if (p.birchmountGiftCardEnabled) {
            this.setState({
                birchmountActivationFromSale: true
            });
            this.openBirchmountGiftCardActivationDialog();
            this.props.formInput(price.toFixed(2), "BirchmountGiftCardActivationAmount");
        }
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    printCredit = (model, type = 'both') => {
        const store = this.props.store;
        let dataMerchant = {
            ...model,
            Type: "Merchant",
            AddressOne: store.name,
            AddressTwo: store.street,
            AddressThree: store.city + "," + store.provinceState + " " + store.postalCode
        }
        let dataHolder = {
            ...model,
            Type: "Holder",
            AddressOne: store.name,
            AddressTwo: store.street,
            AddressThree: store.city + "," + store.provinceState + " " + store.postalCode
        }
        console.log(dataMerchant);
        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const commandMerchant = {
                Command: "PRINT CARDINVOICE",
                Data: JSON.stringify(dataMerchant)
            };
            console.log(commandMerchant);
            const commandHolder = {
                Command: "PRINT CARDINVOICE",
                Data: JSON.stringify(dataHolder)
            };
            if (type == 'merchant') {
                this.ws.send(JSON.stringify(commandMerchant));
                return;
            }
            if (type == 'customer') {
                this.ws.send(JSON.stringify(commandHolder));
                return;
            }
            if (this.props.monerisMerchantCopyAutoPrinted) {
                this.ws.send(JSON.stringify(commandMerchant));
            }
            if (this.props.monerisCustomerCopyAutoPrinted) {
                this.ws.send(JSON.stringify(commandHolder));
            }
        } else if (this.props.padVersion) {
            const commandMerchantPad = {
                Command: "PRINT CARDINVOICE",
                Data: dataMerchant
            };
            const commandHolderPad = {
                Command: "PRINT CARDINVOICE",
                Data: dataHolder
            };
            if (type == 'merchant') {
                printing && printing(JSON.stringify(commandMerchantPad));
                return;
            }
            if (type == 'customer') {
                printing && printing(JSON.stringify(commandHolderPad));
                return;
            }
            if (this.props.monerisMerchantCopyAutoPrinted) {
                printing && printing(JSON.stringify(commandMerchantPad));
            }
            if (this.props.monerisCustomerCopyAutoPrinted) {
                printing && printing(JSON.stringify(commandHolderPad));
            }
        } else {
            console.log("Web Socket not connected!")
        }
    }

    printPaystoneInStoreReceipt = (model) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const receiptModel = {
                Command: "PRINT PAYSTONEINSTORE",
                Data: JSON.stringify(model)
            }
            this.ws.send(JSON.stringify(receiptModel));
            this.setState({ dialogWebSocketError: false });
        } else {
            console.log("Web Socket not connected!");
            this.setState({ dialogWebSocketError: true });
        }
    }

    printReceipt = (orderCreated = null, numberOfCopies = 1) => {
        const store = this.props.store;
        const order = (orderCreated) ? orderCreated : this.props.posOrder;
        const patientId = order.patientId;

        const isFreeOrder = (order && order.subTotalIncludingDiscounts === 0 && order.products.filter(item => item.status === OrderProductStatus.Open).length > 0);
        let orderProducts = order.products;

        if (!this.props.voidItemShowOnReceipt) {
            orderProducts = orderProducts.filter(p => p.status != OrderProductStatus.Voided);
        }

        let memberSavings = 0;
        order.products.map(x => memberSavings += (x.status == 1 || x.status == 2) ? (x.originalNonMemberPrice - x.price) : 0);

        let productCount = 0;
        order.products.map(x => productCount += x.quantity);

        let totalDiscountsOnProducts = orderProducts.reduce((sum, product) => {
            const productSum = product.productDiscountList.reduce((subsum, discount) => subsum + discount.amount, 0);
            return sum + productSum;
        }, 0)

        let totalDiscountsOnOrder = order.discounts.reduce((sum, discount) => sum + discount.amount, 0);

        let totalDiscounts = totalDiscountsOnProducts + totalDiscountsOnOrder;


        let data = {
            NumberOfCopies: numberOfCopies,
            CompanyName: this.props.isShopNameDisplayed ? store.name : "",
            CompanyWebSite: store.site,
            CompanyAddress: store.street,
            CompanyCity: store.city,
            CompanyStateProvince: store.provinceState,
            CompanyCountry: store.country,
            CompanyPostalCode: store.postalCode,
            CompanyPhone: store.phone,
            GSTNumber: this.props.receiptShowGSTNumber ? store.GSTNumber : "",
            PatientId: patientId,
            OrderId: this.props.receiptShowOrderNumber ? order.id : null,
            OnlineOrderCode: order ? (order.onlineOrderCode !== null || order.onlineOrderCode !== undefined) ? order.onlineOrderCode : null : null,
            Register: this.props.receiptShowTerminal ? order.deviceName : "",
            RewardPoint: this.props.receiptShowMemberPoints ? (order.patientRewardPoints ? order.patientRewardPoints.toFixed(0) : 0) : 0,
            VisitCount: this.props.receiptShowVisitCount ? (order.patientVisitCount ? order.patientVisitCount.toFixed(0) : 0) : 0,
            IsCompleted: !this.state.cashDrawerOpenWhenOrderCompleted && !isFreeOrder && ((order.payments && order.payments.filter(p => p.name == 'Cash').length > 0) || !this.props.onlyCashPaymentOpenDrawer),
            Paid: order.paid,
            ShippingCost: order.shippingCost,
            SubTotal: order && order.subTotal ? order.subTotal.toFixed(2) : "0.00",
            DepositAmount: order && order.depositAmount ? order.depositAmount.toFixed(2) : "0.00",
            SubTotalWithDiscount: order && order.subTotal && order.subTotal !== order.subTotalIncludingDiscounts ? order.subTotalIncludingDiscounts.toFixed(2) : order.subTotal.toFixed(2),
            Total: order && order.total && order.total.toFixed(2),
            Tips: order.tipAmount ? order.tipAmount.toFixed(2) : "0.00",
            Due: order && order.balanceDue ? order.balanceDue.toFixed(2) : "0.00",
            Change: order && order.change ? order.change.toFixed(2) : "0.00",
            Refund: order && order.refund ? order.refund.toFixed(2) : "0.00",
            EmployeeFirstName: this.props.receiptShowEmployeeFirstName ? (this.props.showEmployeeNameOnReceipt ? order.employeeFirstName : order.employeeId) : "",
            EmployeeLastName: this.props.receiptShowEmployeeLastName ? (this.props.showEmployeeNameOnReceipt ? order.employeeLastName : "") : "",
            PatientName: this.props.receiptShowMemberName ? `${order.patientFirstName} ${order.patientLastName}` : "",
            PosReceiptBottomText: this.props.posReceiptBottomText,
            CreatedDate: this.props.receiptShowCreatedDate ? order.createdDate : null,
            CompletedDate: order.completedDate,
            RefundDate: order.refundDate,
            Products: orderProducts.map(p => {
                return {
                    ProductId: p.id,
                    SKU: p.sku,
                    ProductName: p.name,
                    Quantity: p.measurementType === MeasurementType.Unit
                        ? p.quantity.toFixed(0)
                        : p.measurementType === MeasurementType.Gram
                            ? p.quantity.toFixed(2)
                            : (p.quantity / p.weightPerUnit).toFixed(0),
                    Price: p.status === OrderProductStatus.ReturnedStoreCredit || p.status === OrderProductStatus.ReturnedCreditCard || p.status === OrderProductStatus.ReturnedDebitCard || p.status === OrderProductStatus.ReturnedCash || p.status === OrderProductStatus.ReturnedGiftCard
                        ? (p.discountType !== null ? p.newPrice.toFixed(2) : p.price.toFixed(2))
                        : p.price.toFixed(2),
                    IsVoided: p.status === OrderProductStatus.Voided,
                    OrderProductDiscountReason: p.orderProductDiscountReason,
                    DiscountText: p.discountValue != 0 && p.productDiscountList.length == 0 ?
                        p.discountType === OrderDiscountType.Percentage ? `${this.props.t('pos.page.discountOf')} ${p.discountAmount.toFixed(0)} %` : `${this.props.t('pos.page.discountOf')} $ ${p.discountAmount.toFixed(2)}`
                        : '',
                    PriceWithDiscount: p.discountType !== null ? p.newPrice.toFixed(2) : '0.00',
                    IsUnitProduct: p.isUnitProduct,
                    PricePerUnit: p.pricePerUnit || 0,
                    LotNumber: p.packageReference,
                    WeightPerUnit: p.weightPerUnit || 0,
                    IsRefunded: p.status === OrderProductStatus.ReturnedStoreCredit || p.status === OrderProductStatus.ReturnedCreditCard || p.status === OrderProductStatus.ReturnedDebitCard || p.status === OrderProductStatus.ReturnedCash || p.status === OrderProductStatus.ReturnedGiftCard,
                    OriginalNonMemberPrice: p.originalNonMemberPrice.toFixed(2),
                    ProductDiscountList: p.productDiscountList.map((item) => {
                        return {
                            Id: item.id,
                            Amount: item.amount,
                            Percentage: item.percentage,
                            Text: item.text,
                            Type: item.type
                        }
                    })
                };
            }),
            TotalDiscountsOnProducts: totalDiscountsOnProducts,
            TotalDiscounts: totalDiscounts,
            Discounts: order.discounts.map((item) => {
                return {
                    text: item.text,
                    value: item.amount.toFixed(2)
                };
            }),
            TaxRates: order.taxesRate.map(t => {
                return {
                    name: t.name,
                    value: t.value.toFixed(2)
                };
            }),
            MemberSavings: this.props.receiptShowMemberSavings ? memberSavings : 0,
            ProductCount: this.props.receiptShowProductCount ? productCount : 0,
            UseFNTax: order.useFNTax,
            TaxExemptAll: order.taxExemptAll

        };
        order.payments.map(p => {
            data[p.name] = p.value.toFixed(2);
            return;
        });
        order.taxesRate.map(t => {
            data[t.name] = t.value.toFixed(2);
            return;
        });
        if (data.Discounts.length === 0 && data.SubTotal !== data.SubTotalWithDiscount) {
            data.Discounts.push({
                text: this.props.t('pos.page.discountOnProduct'),
                value: (data.SubTotal - data.SubTotalWithDiscount).toFixed(2)
            });
        }

        data.memberLabel = store.memberLabelReceipt;
        data.hideMedicalMessage = store.hideMedicalLabelReceipt;
        data.HideRewards = store.hideRewardsReceipt;
        data.fianlSaleTextShowOnReceipt = this.props.fianlSaleTextShowOnReceipt;
        data.fulfillmentEnabled = this.props.fulfillmentEnabled;
        data.showOriginalNonMemberPrice = this.props.showOriginalNonMemberPrice;
        data.inStoreTipEnabled = this.props.inStoreTipEnabled;

        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion && !this.props.httpPrintingEnabled) {
            const model = {
                Command: "PRINT INVOICE",
                Data: JSON.stringify(data)
            };
            if (this.state.cashDrawerOpenWhenOrderCompleted === false) {
                this.setState({ cashDrawerOpenWhenOrderCompleted: true });
            }
            this.ws.send(JSON.stringify(model));
        } else if (this.props.padVersion) {
            data.IsCompleted = true;
            const model = {
                Command: "PRINT INVOICE",
                Data: data
            };
            if (this.state.cashDrawerOpenWhenOrderCompleted === false) {
                this.setState({ cashDrawerOpenWhenOrderCompleted: true });
            }
            printing && printing(JSON.stringify(model));
        } else if (this.props.httpPrintingEnabled) {
            fetch('http://127.0.0.1:5656/print/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ data })
            }).then(response => {
                if (!response.ok) {
                    throw new Error('HTTP printing failed');
                }
                return response.json();
            }).then(result => {
                console.log('HTTP printing success:', result);
            }).catch(error => {
                console.error('HTTP printing error:', error);
            });
        } else {
            if (numberOfCopies > 0) {
                if (this.props.padVersion) {
                    buildURLScheme(document.getElementById('pos-receipt').innerHTML);
                } else {
                    return new Promise(() => {
                        setTimeout(() => {
                            console.log("I want to print!");
                            document.getElementById('to-print').innerHTML = document.getElementById('pos-receipt').innerHTML;
                            console.log(document.getElementById('pos-receipt').innerHTML);
                            window.print();
                        }, 1000)
                    });
                }
            }
        }
    }

    openDrawerCount = () => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const model = {
                Command: 'OPEN DRAWER',
                Data: null
            };
            this.ws.send(JSON.stringify(model));
        }
        else if (this.props.padVersion) {
            openCashDrawer('OPEN DRAWER');
        }
    }

    openDrawer = () => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const model = {
                Command: 'OPEN DRAWER',
                Data: null
            };
            this.ws.send(JSON.stringify(model));
        }
        else if (this.props.padVersion) {
            openCashDrawer('OPEN DRAWER');
        }
        const model = {
            branchId: this.props.branchId,
            cashflowId: this.props.cashFlow.id || "",
            orderId: this.props.posOrder && this.props.posOrder.id || "0"
        };
        this.props.trackingDrawerOpen(model);
    }

    printMoneris = (type) => {
        console.log('I want to print moneris');
        let model = {
            orderId: this.props.posOrder.id,
            type: type
        };
        this.props.getMonerisReceiptByOrderId(model);
    }

    printLabel = (product) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const store = this.props.store;
            const patientId = this.props.posOrder.patientId;

            const model = {
                Command: 'PRINT LABEL',
                Data: JSON.stringify([{
                    CompanyName: store.name,
                    CompanyPhone: store.phone,
                    PatientId: patientId,
                    ProductName: product.name,
                    ProductType: product.type,
                    ProductCategory: product.category,
                    Quantity: product.quantity.toFixed(1),
                    THC: product.thc.toFixed(2),
                    CBD: product.cbd.toFixed(2)
                }])
            };

            this.ws.send(JSON.stringify(model));
        }
        else {
            // printing using browser
            this.setState({ printLabel: true, labelProductId: product.id });
        }
    }

    printGiftCardReceipt = (model) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const store = this.props.store;
            const data = {
                Command: 'PRINT GIFTCARD',
                Data: JSON.stringify({
                    CompanyName: store.name,
                    Address: store.street,
                    City: store.city,
                    Province: store.provinceState,
                    PostalCode: store.postalCode,
                    Phone: store.phone,
                    WebSite: store.site,
                    TerminalId: model.terminalId,
                    TransactionDescription: model.transactionDescription,
                    TransactionAmount: model.transactionAmount || 0,
                    BenefitAmount: model.benefitAmount ? stringToDecimalFormatter(model.benefitAmount) : 0,
                    BalanceDue: model.balanceDue ? stringToDecimalFormatter(model.balanceDue) : '',
                    RemainingBalance: model.currentBalance ? stringToDecimalFormatter(model.currentBalance) : '',
                    BatchNumber: model.batchNumber || '',
                    ReferenceNumber: model.referenceNumber || '',
                    CardNumber: model.cardNumber || '',
                    CardDescription: model.cardDescription || '',
                    CardStatus: model.cardStatus,
                    PromptText: model.promptText || '',
                    ReceiptText: model.teceiptText || '',
                    VoucherText: model.voucherText || '',
                    CardHolderName: model.cardHolderName || '',
                    ResponseText: model.responseText || '',
                    ResponseCode: model.responseCode || ''
                })
            };

            // console.log(data);

            this.ws.send(JSON.stringify(data));
            this.setState({ dialogWebSocketError: false });
        } else {
            this.setState({ dialogWebSocketError: true });
        }
    }

    printPaystoneGiftCardReceipt = (model) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const store = this.props.store;
            let cardNumber = model.cardNumber;
            if (cardNumber) {
                cardNumber = cardNumber.substring(0, 6) + "*********" + cardNumber.substring(15);
            }
            const data = {
                Command: 'PRINT PAYSTONEGIFTCARD',
                Data: JSON.stringify({
                    CompanyName: store.name,
                    Address: store.street,
                    City: store.city,
                    Province: store.provinceState,
                    PostalCode: store.postalCode,
                    Phone: store.phone,
                    WebSite: store.site,
                    WorkStationNumber: model.wsn,
                    EmployeeNumber: model.wan,
                    InvoiceNumber: model.invoiceNumber,
                    CardNumber: cardNumber,
                    TransactionType: model.payStoneOperations,
                    Amount: model.amount,
                    TransactionNumber: model.tcn,
                    BalanceInfo: model.balance,
                    AvailableDollars: model.balance,
                })
            };

            // console.log(data);
            this.ws.send(JSON.stringify(data));
            this.setState({ dialogWebSocketError: false });
        } else {
            this.setState({ dialogWebSocketError: true });
        }
    }

    printBirchmountGiftCardReceipt = (model) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const store = this.props.store;
            const data = {
                Command: 'PRINT BIRCHMOUNTGIFTCARD',
                Data: JSON.stringify({
                    CompanyName: store.name,
                    Address: store.street,
                    City: store.city,
                    Province: store.provinceState,
                    PostalCode: store.postalCode,
                    Phone: store.phone,
                    WebSite: store.site,
                    Balance: model.balance,
                    Msg: model.msg,
                    Status: model.status,
                    TimeStamp: model.timeStamp,
                    TransactionID: model.transactioN_ID
                })
            };

            console.log(data);
            this.ws.send(JSON.stringify(data));
        }
        else if (this.props.padVersion) {
            const store = this.props.store;
            const data = {
                Command: "PRINT BIRCHMOUNTGIFTCARD",
                Data: {
                    CompanyName: store.name,
                    Address: store.street,
                    City: store.city,
                    Province: store.provinceState,
                    PostalCode: store.postalCode,
                    Phone: store.phone,
                    WebSite: store.site,
                    Balance: model.balance,
                    Msg: model.msg,
                    Reloadable: model.reloadable,
                    Status: model.status,
                    TimeStamp: model.timeStamp,
                    TransactionID: model.transactioN_ID
                }
            };

            printing && printing(JSON.stringify(data));
            this.setState({ dialogWebSocketError: false });
        } else {
            this.setState({ dialogWebSocketError: true });
        }
    }

    printStoreCredit = () => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const store = this.props.store;
        const storeCredit = this.props.storeCredit;
        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const model = {
                Command: 'PRINT STORECREDIT',
                Data: JSON.stringify({
                    CompanyName: store.name,
                    CompanyWebSite: store.site,
                    CompanyAddress: store.street,
                    CompanyCity: store.city,
                    CompanyStateProvince: store.provinceState,
                    CompanyCountry: store.country,
                    CompanyPostalCode: store.postalCode,
                    CompanyPhone: store.phone,
                    Register: deviceData.deviceWorkStationName,
                    OrderId: parseInt(storeCredit.orderId),
                    Code: storeCredit.code,
                    CurrentValue: storeCredit.currentValue.toFixed(2),
                    StartDate: storeCredit.startDate,
                    EndDate: storeCredit.endDate
                })
            };

            this.ws.send(JSON.stringify(model));
        }
        else if (this.props.padVersion) {
            let dataJSON = {
                CompanyName: store.name,
                CompanyWebSite: store.site,
                CompanyAddress: store.street,
                CompanyCity: store.city,
                CompanyStateProvince: store.provinceState,
                CompanyCountry: store.country,
                CompanyPostalCode: store.postalCode,
                CompanyPhone: store.phone,
                Register: deviceData.deviceWorkStationName,
                OrderId: parseInt(storeCredit.orderId),
                Code: storeCredit.code,
                CurrentValue: storeCredit.currentValue.toFixed(2),
                StartDate: storeCredit.startDate,
                EndDate: storeCredit.endDate
            };
            const model = {
                Command: "PRINT STORECREDIT",
                Data: dataJSON
            };
            console.log("you want to print credit");
            storeCreditPrinting(JSON.stringify(model));
            this.setState({ dialogWebSocketError: false });
        } else {
            this.setState({ dialogWebSocketError: true });
        }
    }

    printAllLabel = () => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const products = this.props.posOrder.products.filter(p => p.isCannabis === true && p.measurementType === MeasurementType.Gram && (p.status === 1 || p.status === 2));
            const store = this.props.store;
            const patientId = this.props.posOrder.patientId;
            const data = products.map((product) => {
                return {
                    CompanyName: store.name,
                    CompanyPhone: store.phone,
                    PatientId: patientId,
                    ProductName: product.name,
                    ProductType: product.type,
                    ProductCategory: product.category,
                    Quantity: product.quantity.toFixed(1),
                    THC: product.thc.toFixed(2),
                    CBD: product.cbd.toFixed(2)
                };
            });

            const model = {
                Command: 'PRINT LABEL',
                Data: JSON.stringify(data)
            };

            this.ws.send(JSON.stringify(model));
        }
        else {
            // printing using browser
            this.setState({ printLabel: true, labelProductId: null });
        }
    }

    payByCardPIC = (data) => {
        // console.log(data);
        const model = {
            Command: 'GET PIC',
            Data: JSON.stringify(data)
        };
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(model));
            this.setState({ dialogWebSocketError: false });
        } else {
            this.setState({ dialogWebSocketError: true });
        }
    }

    payByGlobal = (data) => {
        console.log(data);
        const model = {
            Command: 'GET GLOBAL',
            Data: JSON.stringify(data)
        };
        console.log(model);
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(model));
            this.setState({ dialogWebSocketError: false });
        } else {
            this.setState({ dialogWebSocketError: true });
        }

    }

    onPrintLabelComplete = () => {
        this.setState({ printLabel: false, labelProductId: null });
    }

    startNewOrder = () => {
        // Clean up and other logic...
        this.props.cleanProductDetail();
        this.props.cleanOrderDetail(this.props.posShowProductCount);
        this.props.clearPriceMatchRows();
        this.clearFilter();
        this.setState({
            cashDrawerOpenWhenOrderCompleted: false,
            dialogCheckId: true
        });
        this.props.getProducts({
            page: 1,
            itemsPerPage: this.props.posShowProductCount,
            searchText: "",
            baseCategoryId: 3,
            categoryId: null,
            branchId: this.props.branchId,
            THC_MIN: 0,
            THC_MAX: 100,
            CBD_MIN: 0,
            CBD_MAX: 100,
            SubCategoryId: [],
            Weight: []
        });
        // Change the URL without a full page reload
        this.props.navigate('/pos');
    }

    redirectHomePage = () => {
        this.props.navigate('/');
    }

    troubleshootPage = () => {
        window.open('https://knowledge.techpos.ca/en/knowledge/troubleshooting-printer', '_blank')
    }

    goToDevicesPage = () => {
        this.props.navigate('/manage/device');
    }

    selectOrderModel = (patient, newProduct, newComboProduct, removeMember = false) => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const posOrderModel = this.props.posOrder;
        const productsModel = posOrderModel ? posOrderModel.products || [] : [];
        const branchId = this.props.branchId;
        const employeeId = this.props.userPin.authenticated ? this.props.userPin.employee.id : 0;
        let useFNTax = posOrderModel ? posOrderModel.useFNTax : false;
        let taxExemptAll = posOrderModel ? posOrderModel.taxExemptAll : false;

        if (posOrderModel && posOrderModel.useFNTax){
            useFNTax = false;
        }else if (posOrderModel && posOrderModel.patientIsMember && this.props.patientIdType === "IdentificationCard" && this.props.patientIdNumber){
            useFNTax = true;
        }

        let products = productsModel ? productsModel.map((item) => {
            return {
                id: item.id,
                productId: item.productId,
                quantity: item.quantity,
                branchId: branchId,
                packageReference: item.packageReference,
                status: item.status
            };
        }) : [];

        if (newProduct) {
            if (newProduct.quantity > 1 && !this.props.isMedical && this.props.fulfillmentEnabled && newProduct.isCannabis) {
                for (let i = 0; i < newProduct.quantity; i++) {
                    let oneSplitedQtyNewProducts = {
                        id: 0,
                        productId: newProduct.productId,
                        quantity: 1,
                        branchId: branchId,
                        packageReference: newProduct.packageReference
                    }
                    products.push(oneSplitedQtyNewProducts);
                }
            } else {
                products.push(newProduct);
            }
        }

        if (newComboProduct) {
            newComboProduct.map((item) => {
                let oneProduct = {
                    id: item.id,
                    packageReference: item.packageReference,
                    isManuallyInputted: item.isManuallyInputted,
                    price: item.price,
                    productId: item.productId,
                    quantity: item.quantity,
                    isInCombo: true
                }
                products.push(oneProduct);
            })
        }

        const order = {
            id: posOrderModel ? posOrderModel.id : 0,
            patientId: patient ? patient.id : removeMember ? 0 : posOrderModel ? posOrderModel.patientId : 0,
            deviceId: deviceData.id,
            employeeId: employeeId,
            products: products.reverse(),
            branchId: branchId,
            useFNTax: useFNTax,
            taxExemptAll: taxExemptAll,
            modifiedDate: posOrderModel ? posOrderModel.modifiedDate : ""
        };

        return order;
    }

    applyTaxExempt = (taxType) => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const posOrderModel = this.props.posOrder;
        const productsModel = posOrderModel ? posOrderModel.products || [] : [];
        const branchId = this.props.branchId;
        const employeeId = this.props.userPin.authenticated ? this.props.userPin.employee.id : 0;
        let useFNTax = false;
        let taxExemptAll = (taxType == "AllTaxes") ? !this.props.posOrder.taxExemptAll : this.props.posOrder.taxExemptAll;

        if (taxType == "FNTaxes"){
            if (this.props.posOrder.useFNTax){
                useFNTax = false;
            }else if (posOrderModel && posOrderModel.patientIsMember && this.props.patientIdType === "IdentificationCard" && this.props.patientIdNumber){
                useFNTax = true;
            }
        }

        const products = productsModel ? productsModel.map((item) => {
            return {
                id: item.id,
                productId: item.productId,
                quantity: item.quantity,
                branchId: branchId,
                packageReference: item.packageReference
            };
        }) : [];

        const order = {
            id: posOrderModel ? posOrderModel.id : 0,
            patientId: posOrderModel ? posOrderModel.patientId : 0,
            deviceId: deviceData.id,
            employeeId: employeeId,
            products: products,
            branchId: branchId,
            useFNTax: useFNTax,
            taxExemptAll: taxExemptAll,
            modifiedDate: posOrderModel ? posOrderModel.modifiedDate : ""
        };

        this.props.saveOrder(order);
    }

    setMonerisPinpad = (type) => {
        let model;
        //init
        if (type == "I") {
            model = {
                branchId: this.props.branchId,
                terminalId: this.props.pinPadId,
                txnType: "initialization",
                postbackUrl: this.props.store.apiUrl + "unauthorized/monerisComplete",
                request: {
                    terminalId: this.props.pinPadId
                }
            };
            // set tip
        } else if (type == "T") {
            model = {
                branchId: this.props.branchId,
                terminalId: this.props.pinPadId,
                txnType: "setTip",
                postbackUrl: this.props.store.apiUrl + "unauthorized/monerisComplete",
                request: {
                    tipType: this.props.posMonerisTipDialogTipOption
                }
            };
        }

        this.setState({
            loading: true
        });
        return fetch(this.props.store.apiUrl + "unauthorized/setMonerisPinpad", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                console.log(data);
                return data;
            }).then(r => this.getMonerisResult(this.props.store.apiUrl + `unauthorized/getMonerisResult/${type}`));
    }

    getMonerisResult = (url) => {
        fetch(url, {
            method: 'get'
        })
            .then(res => res.json())
            .then((result) => {
                console.log(result);
                this.setState({
                    loading: false
                }, this.showMonerisResult(result));
            }).catch((err) => {
                console.error(` Err: ${err}`);
                this.setState({
                    loading: false
                });
            })
    }

    showMonerisResult = (result) => {
        if (result.success) {
            this.setState({ monerisTipDialog: false });
            this.props.showSnackbar(this.props.t('pos.page.exciteSuccess'));
        } else {
            this.props.showSnackbar(this.props.t('pos.page.exciteFail'));
        }
    }

    openMonerisTipDialog = () => {
        this.setState({ monerisTipDialog: true });
    }

    closeMonerisTipDialog = () => {
        this.setState({ monerisTipDialog: false });
    }

    openRecentOrdersDialog = () => {
        this.setState({ dialogRecentOrders: true });
    }

    closeRecentOrdersDialog = () => {
        this.setState({ dialogRecentOrders: false });
    }

    closeInventoryFlagDialog = () => {
        this.setState({ openInventoryFlagDialog: false });
    }

    finalizeOrder = () => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        this.props.finalizeOrder({ orderId: this.props.posOrder.id, deviceId: deviceData.id, branchId: this.props.branchId, employeeId: this.props.userPin.authenticated ? this.props.userPin.employee.id : 0, modifiedDate: this.props.posOrder.modifiedDate });
    }

    openRefundOrderDialog = () => {
        this.setState({ dialogRefundOrder: true });
    }

    closeRefundOrderDialog = () => {
        this.setState({ dialogRefundOrder: false });
    }

    reopenOrderRefund = () => {
        let model = { orderId: this.props.orderIdOpenForRefund };
        const validators = [
            [`${this.props.name}POSOrderOpenForRefund`, d => (d.orderId && !isNaN(d.orderId) && d.orderId > 0), this.props.t('common.orderNum')]
        ];

        if (util.validate(validators, model, this.props.formError)) {
            window.location = `/pos/${model.orderId}`;
        }
    }

    onRefundKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
            this.reopenOrderRefund();
        }
    }

    emailReceipt = () => {
        let email = this.props.posOrder.patientEmail == null || this.props.posOrder.patientEmail == "" ? this.props.posOrder.onlineOrderEmail == null || this.props.posOrder.onlineOrderEmail == "" ? this.props.posEmailReceiptDialogEmail : this.props.posOrder.onlineOrderEmail : this.props.posOrder.patientEmail;
        if (!email) {
            this.openEmailReceiptDialog();
        } else {
            this.closeEmailReceiptDialog();
            this.props.posEmailReceipt({ orderId: this.props.posOrder.id, email: email, isInvoice: false });
            this.props.formInput(email, "posEmailReceiptAddress");
        }
    }

    emailInvoice = () => {
        let email = this.props.posEmailInvoiceDialogEmail;

        if (email) {
            this.closeEmailInvoiceDialog();
            this.props.posEmailReceipt({ orderId: this.props.posOrder.id, email: email, isInvoice: true });
            this.props.formInput(email, "posEmailReceiptAddress");
        }
    }

    SMSReceipt = () => {
        let phonenumber = this.props.posOrder.patientPhoneNumber == null ? this.props.posSMSReceiptDialogSMS : this.props.posOrder.patientPhoneNumber;
        if (!phonenumber) {
            this.openSMSReceiptDialog();
        } else {
            this.closeSMSReceiptDialog();
            this.props.posSMSReceipt({ orderId: this.props.posOrder.id, phoneNumber: phonenumber });
        }
    }

    lockPinPassword() {
        window.location = '/pos';
        this.props.lockPinPassword();

    }

    openOnlineOrderSearch = () => {
        this.setState({ onlineDialogOpen: true });
    }

    closeOnlineOrderSearch = () => {
        this.setState({ onlineDialogOpen: false });
    }

    opencashInDialog = () => {
        this.openDialogCashIn();
    }

    openCashDropDialog = () => {
        this.openDialogCashDrop();
    }

    openBuddiOrdersDialog = () => {
        this.setState({ buddiDialogOpen: true });
    }

    closeBuddiOrdersDialog = () => {
        this.setState({ buddiDialogOpen: false });
    }

    openLeaflyOrdersDialog = () => {
        this.setState({ leaflyDialogOpen: true });
    }

    closeLeaflyOrdersDialog = () => {
        this.setState({ leaflyDialogOpen: false });
    }

    openComboDialog = () => {
        this.setState({ comboDialogOpen: true });
    }

    closeComboDialog = () => {
        this.setState({ comboDialogOpen: false, filterCombos: [], comboProductClicked: null });
    }

    openVariableGiftCardDialog = () => {
        this.setState({ variableGiftCardDialog: true });
    }

    closeVariableGiftCardDialog = () => {
        this.setState({ variableGiftCardDialog: false });
    }

    activateNewCard = () => {
        this.setState({
            openGiftCardActivation: true
        })
    }

    deactivateCard = () => {
        this.setState({
            openGiftCardDeactivation: true
        })
    }

    openEmailReceiptDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openEmailReceiptDialog: true
        });
    }

    openEmailInvoiceDialog = () => {
        const memberEmail = this.props.posOrder ? this.props.posOrder.patientEmail : null
        this.props.formInput(memberEmail, "POSEmailInvoiceDialogEmail");
        this.setState({
            openEmailInvoiceDialog: true
        })
    }

    openSMSReceiptDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openSMSReceiptDialog: true
        });
    }

    openGiftCardInquiryDialog = () => {
        this.setState({
            openGiftCardInquiry: true
        })
    }

    closeGiftCardInquiry = () => {
        this.setState({
            openGiftCardInquiry: false
        })
    }

    openGiftCardInitDialog = () => {
        this.setState({
            openGiftCardInit: true
        })
    }

    closeGiftCardInitDialog = () => {
        this.setState({
            openGiftCardInit: false
        })
    }

    closeGiftCardActivation = () => {
        this.setState({
            openGiftCardActivation: false,
            activateOrderId: 0
        });
        this.props.formInput("0.00", "POSGiftCardActivationinitAmount");
    }

    closeGiftCardDeactivation = () => {
        this.setState({
            openGiftCardDeactivation: false
        })
    }

    openSellGiftCardDialog = () => {
        this.setState({
            openSellGiftCard: true
        })
    }

    closeSellGiftCardDialog = () => {
        this.setState({
            openSellGiftCard: false
        })
    }

    closeGenericGiftCardDialog = () => {
        this.setState({
            genericGiftCardDialog: false
        })
    }

    openCheckBalanceDialog = () => {
        this.setState({
            openCheckBalanceDialog: true
        })
    }

    closeCheckBalanceDialog = () => {
        this.setState({
            openCheckBalanceDialog: false
        })
    }

    closeEmailReceiptDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openEmailReceiptDialog: false
        })
    }

    closeEmailInvoiceDialog = () => {
        this.setState({
            openEmailInvoiceDialog: false
        })
        this.props.formInput(null, "POSEmailInvoiceDialogEmail");
    }

    closeSMSReceiptDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openSMSReceiptDialog: false
        })
    }

    openPaystoneGiftCardActivationDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardActivation: true
        });
    }

    closePaystoneGiftCardActivationDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardActivation: false,
            paystoneActivationFromSale: false
        });
    }

    openPaystoneGiftCardCheckBalanceDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardCheckBalance: true
        });
    }

    closePaystoneGiftCardCheckBalanceDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardCheckBalance: false
        });
    }

    openPaystoneGiftCardCancelDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardCancel: true
        });
    }

    closePaystoneGiftCardCancelDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardCancel: false
        });
    }

    closePaystoneGiftCardDialogs = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openPaystoneGiftCardCheckBalance: false,
            openPaystoneGiftCardActivation: false,
            openPaystoneGiftCardCancel: false,
            paystoneActivationFromSale: false
        });
    }

    openBirchmountGiftCardCheckBalanceDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardCheckBalance: true
        });
    }

    closeBirchmountGiftCardCheckBalanceDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardCheckBalance: false
        });
    }

    openBirchmountGiftCardActivationDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardActivation: true
        });
    }

    closeBirchmountGiftCardActivationDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardActivation: false,
            birchmountActivationFromSale: false
        });
    }

    openBirchmountGiftCardCancelDialog = () => {
        window.removeEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardCancel: true
        });
    }

    closeBirchmountGiftCardCancelDialog = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardCancel: false
        });
    }

    closeBirchmountGiftCardDialogs = () => {
        window.addEventListener("keypress", this.barcodeListener);
        this.setState({
            openBirchmountGiftCardCheckBalance: false,
            openBirchmountGiftCardActivation: false,
            openBirchmountGiftCardCancel: false,
            birchmountActivationFromSale: false
        });
    }

    closeVisitDiscountDialog = () => {
        this.setState({ visitDiscountDialogOpen: false });
    }

    openVisitDiscountDialog = () => {
        this.setState({ visitDiscountDialogOpen: true });
    }

    closeSpringBigRewardsDialog = () => {
        this.setState({ springBigRewardsDialogOpen: false })
    }

    openSpringBigRewardsDialog = () => {
        if (this.props.posOrder) {
            const patientId = this.props.posOrder.patientId || 0;
            const patientPhoneNumber = this.props.posOrder.patientPhoneNumber || 0;
            this.props.getSpringbigMemberPoints({ patientId, patientPhoneNumber, branchId: this.props.branchId });
            this.props.getSpringbigRewards({ branchId: this.props.branchId });
            this.setState({ springBigRewardsDialogOpen: true });
        }
    }

    closeSpringBigOffersDialog = () => {
        this.setState({ springBigOffersDialogOpen: false })
    }

    openSpringBigOffersDialog = () => {
        if (this.props.posOrder) {
            this.props.getSpringbigOffers({ patientId: this.props.posOrder.patientId, branchId: this.props.branchId });
            this.setState({ springBigOffersDialogOpen: true });
        }
    }

    setDefaultImg = () => {
        this.setState({
            src: defaultImg
        })
    }

    closeAlpineIQRewardsDialog = () => {
        this.setState({ alpineIQRewardsDialogOpen: false });
        this.props.clearAlpineIQ();
    }

    openAlpineIQRewardsDialog = () => {
        if (this.props.posOrder) {
            if (this.props.alpineIQwalletCode && (this.props.wallet == null || this.props.wallet == undefined || this.props.wallet.length == 0)) {
                this.props.alpineIQviewWallet({
                    phoneNumber: this.props.posOrder.patientPhoneNumber, branchId: this.props.branchId, code: this.props.alpineIQwalletCode, email: this.props.posOrder.patientEmail
                });
            }
            else {
                this.props.alpineIQverifyWallet({
                    phoneNumber: this.props.posOrder.patientPhoneNumber, branchId: this.props.branchId, orderNumber: this.props.posOrder.id
                });
            }
            this.setState({ alpineIQRewardsDialogOpen: true });
        }
    }

    openCashInNoteDialog = () => {
        this.setState({ cashInNoteDialog: true });
    }

    closeCashInNoteDialog = () => {
        this.props.clearFormInput('POSCashInNote');
        this.setState({ cashInNoteDialog: false });
    }

    saveCashInNote = () => {
        this.props.cashFlowNotes(this.props.cashInNotes, this.props.cashFlow.id, this.props.branchId);
        this.props.clearFormInput('POSCashInNote');
        this.closeCashInNoteDialog();
    }

    openCancelOpenOrdersDialog = () => {
        this.setState({ cancelOpenOrdersDialog: true });
    }

    closeCanelOpenOrdersDialog = () => {
        this.setState({ cancelOpenOrdersDialog: false });
    }

    cancelAllOpenOrders = () => {
        const model = this.props.cancellationCredentials;
        this.props.cancelAllOpenOrders(this.props.branchId, model);
    }

    alpineCheckIn = () => {
        if (this.props.posOrder) {
            let phone = this.props.posOrder.patientPhoneNumber ? this.props.posOrder.patientPhoneNumber : "";
            let email = this.props.posOrder.patientEmail ? this.props.posOrder.patientEmail : "";
            this.props.alpineIQCheckIn({ phone: phone, email: email, branchId: this.props.branchId });
        }
    }

    openAssignMemberDialog = () => {
        this.setState({ assignMember: true });
    }

    closeAssignMemberDialog = () => {
        this.setState({ assignMember: false });
    }

    openAddDutchieDialog = (dutchieOrLeafly) => {
        this.setState({ addDutchieDialog: true, dutchieOrLeafly: dutchieOrLeafly });
    }

    closeAddDutchieDialog = () => {
        this.props.clearFormInput("dutchiePaidOnline");
        this.setState({ addDutchieDialog: false });
    }

    PlayNotification = () => {
        let context;
        let oscillator;
        let contextGain;
        let x = 0;

        context = new AudioContext();
        oscillator = context.createOscillator();
        contextGain = context.createGain();

        oscillator.connect(contextGain);
        contextGain.connect(context.destination);
        oscillator.start(0);
        x = 1;
        contextGain.gain.exponentialRampToValueAtTime(0.00001, context.currentTime + x);
    }

    openPOSOrderImportDialog = () => {
        this.setState({ confirmPOSOrderImportDialog: true });
    }

    closePOSOrderImportDialog = () => {
        this.setState({ confirmPOSOrderImportDialog: false });
    }


    openAddMemberDialog = () => {
        this.setState({ addMemberOpenDialog: true });
    }

    closeAddMemberDialog = () => {
        this.setState({ addMemberOpenDialog: false });
    }

    showProductSuggestionDialog = () => {
        this.setState({ productSuggestionDialog: true });
    }

    closeProductSuggestionDialog = () => {
        this.setState({ productSuggestionDialog: false });
    }

    togglePayment = () => {
        // Validate if lot numbers are chosen if offline product scan is enabled
        if (this.props.offlineProductScan && !this.props.padVersion) {
            const noLot = this.props.posOrder.products.filter(p => p.packages && p.packages.length > 1 && !p.packageReference);

            if (noLot.length > 0) {
                this.props.showError(this.props.t('pos.page.chooseLotNum'));
                return;
            }
        }

        this.setState({ isPaid: true });

        // Create or update order in db with balance due if offline product scan is enabled
        const order = this.props.posOrder;
        const orderIsCompleted = (order.status === 'Completed' || order.status === 'Returned' || order.status === 'ReturnedPartial' || order.status === 'WaitingPickUp' || order.status === 'WaitingFulfillment');

        if (this.props.offlineProductScan && !this.props.padVersion && !orderIsCompleted) {
            const orderModel = this.selectOrderModel(this.props.patient, null, null, true);
            this.props.saveOrder(orderModel);
        }
    }

    ToggleClosePayment = () => {
        this.setState({ isPaid: false })
    }

    toTheTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    listenToScroll = () => {
        if (window.scrollY >= 900) {
            this.setState({ scrollButtonShow: true })
        } else if (window.scrollY < 900) {
            this.setState({ scrollButtonShow: false })
        }
    }

    lastItemAlert = () => {
        if (this.props.posOrder && this.props.posOrder.products && this.props.posOrder.products.length > 0) {
            this.props.posOrder.products.forEach(element => {
                if (element.quantityInStock == 0 && element.status == 2) {
                    this.setState({ showLastItemDialog: true });
                }
            })
        }
    }

    closeLastItemDialog = () => {
        this.setState({ showLastItemDialog: false });
    }

    handleVapeSaleDialog = () => {
        this.setState({ dialogVapeSale: false });
    }

    sendToFulfillment = () => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const posOrderModel = this.props.posOrder;
        const productsModel = posOrderModel ? posOrderModel.products || [] : [];
        const branchId = this.props.branchId;
        const employeeId = this.props.userPin.authenticated ? this.props.userPin.employee.id : 0;

        let products = productsModel ? productsModel.map((item) => {
            return {
                id: item.id,
                productId: item.productId,
                quantity: item.quantity,
                branchId: branchId,
                packageReference: item.packageReference
            };
        }) : [];

        const order = {
            id: posOrderModel ? posOrderModel.id : 0,
            patientId: posOrderModel ? posOrderModel.patientId : 0,
            deviceId: deviceData.id,
            employeeId: employeeId,
            products: products,
            branchId: branchId
        };
        this.props.sendOrderToFulFillment(order);
    }

    openAccessorySaleDialog = () => {
        this.setState({ acccessorySaleDialog: true });
    }

    closeAccessorySaleDialog = () => {
        this.setState({ acccessorySaleDialog: false });
        this.props.clearFormInput(`variableAccessoryPrice`);
        this.props.clearFormInput(`variableAccessoryName`);
        this.props.clearFormInput(`variableAccessoryQuantity`);
    }

    hideSideBar = () => {
        this.setState((prevState) => {
            const newHideMenuValue = !prevState.hideMenu;
            localStorage.setItem('hideMenu', newHideMenuValue);
            return { hideMenu: newHideMenuValue };
        });
    }

    showOrderHistory = (id) => {
        this.props.setIDOrderHistory(id);
        this.getOrders(id);
        this.setState({ showOrderHistoryDialog: true });
    }

    closeOrderHistoryDialog = () => {
        this.setState({ showOrderHistoryDialog: false })
    }

    showPatientSaveDialog = () => {
        this.setState({ showPatientSaveDialog: true })
    }

    closePatientSaveDialog = () => {
        this.setState({ showPatientSaveDialog: false })
    }

    openPointsDialog = () => {
        this.setState({ openPointsDiag: true });
    }

    closePointsDialog = () => {
        this.props.clearFormInput('Comment');
        this.props.clearFormInput('Amount');
        this.props.clearFormInput('POSRewardUsername');
        this.props.clearFormInput('POSRewardPassword');
        this.props.clearFormInput('POSRewardPinCode');
        this.setState({ openPointsDiag: false });
    }

    addRewardPoints = () => {
        let validators = [
            ["Amount", d => (d.points && d.points !== ""), "Amount"]
        ];

        if (this.props.rewardPinCode == "") {
            validators.push(
                ["POSRewardUsername", d => (d.userName && d.userName !== ""), "UserName"],
                ["POSRewardPassword", d => (d.password && d.password !== ""), "Password"]
            );
        }

        let order = this.props.posOrder;
        const model = {
            patientId: order.patientId,
            branchId: this.props.branchId,
            comments: this.props.rewardComment,
            points: this.props.rewardAmount,
            validateUser: true,
            userName: this.props.rewardUserName,
            password: this.props.rewardPassword,
            pinCode: this.props.rewardPinCode
        }

        if (util.validate(validators, model, this.props.formError)) {
            this.props.updateRewardPoint(model, "POSPage");
        }
    }

    removeRewardPoints = () => {
        let validators = [
            ["Amount", d => (d.points && d.points !== ""), "Amount"]
        ];

        if (this.props.rewardPinCode == null || this.props.rewardPinCode == "") {
            validators.push(
                ["POSRewardUsername", d => (d.userName && d.userName !== ""), "UserName"],
                ["POSRewardPassword", d => (d.password && d.password !== ""), "Password"]
            );
        }

        let order = this.props.posOrder;
        const model = {
            patientId: order.patientId,
            branchId: this.props.branchId,
            comments: this.props.rewardComment,
            points: this.props.rewardAmount,
            remove: true,
            validateUser: true,
            userName: this.props.rewardUserName,
            password: this.props.rewardPassword,
            pinCode: this.props.rewardPinCode
        }


        if (util.validate(validators, model, this.props.formError)) {

            //if there is an issue with this.props.rewardAmount or patient.rewardPoints in the front end, deducting more then a patient has will be caught in the back end as well
            if (this.props.rewardAmount && order.patientRewardPoints && order.patientRewardPoints < this.props.rewardAmount) {
                this.props.showError(this.props.t('pos.page.cannotDeductMorePoints'));
                return;
            }
            this.props.updateRewardPoint(model, "POSPage");
        }
    }

    getOrders = (id) => {
        const model = {
            branchId: 0,
            orderNumber: null,
            orderDate: null,
            patientFirstName: "",
            employeeFirstName: "",
            status: 'None',
            total: null,
            orderBy: "DESC",
            sortBy: "Id",
            innerClass: "",
            employeeId: null,
            patientId: id,
            page: 1,
            itemsPerPage: 10
        }

        this.props.getPatientOrders(model);
    }

    checkComboInDateRange = (combo) => {
        let currentDate = new Date();
        let currentTime = "0000-01-01 " + moment(currentDate).format("HH:mm:ss");
        let startTime = "0000-01-01 " + moment(combo.startTime).format("HH:mm:ss");
        let endTime = "0000-01-01 " + moment(combo.endTime).format("HH:mm:ss");

        return (
            (combo.dateFrom == null || moment(combo.dateFrom).isBefore(currentDate)) &&
            (combo.dateTo == null || moment(combo.dateTo).isAfter(currentDate)) &&
            (combo.daysOfWeek.length == 0 || combo.daysOfWeek.includes(currentDate.getDay())) &&
            (combo.startTime == null || moment(currentTime).isBetween(startTime, endTime))
        )
    }

    findCombos = (combos, posProduct) => {
        let foundCombos = [];

        combos.forEach(combo => {
            if (this.checkComboInDateRange(combo) &&
                combo.products.some(p => p.id == posProduct.productId)) {
                foundCombos.push(combo.id);
            }
        });
        return foundCombos;
    }

    openProductComboList = (combos, posProduct) => {
        let comboProductClicked = {
            orderProductId: posProduct.id,
            productId: posProduct.productId,
            quantityAddedBack: posProduct.quantity
        }
        this.setState({ comboDialogOpen: true, filterCombos: combos, comboProductClicked: comboProductClicked })
    }

    syncData = () => {
        if (this.props.deviceKeyName != null && this.props.deviceKeyName != "" && this.props.deviceKeyName != undefined) {
            const deviceKeyName = this.props.deviceKeyName;
            const deviceData = JSON.parse(localStorage.getItem(deviceKeyName))
            this.props.getPOS(deviceData.id, this.props.branchId);
        }
        this.props.getSettings(this.props.branchId, 'SettingsPage');
        this.props.getCombos({
            branchId: this.props.branchId,
            onlyActive: true
        });
    }

    clearFilter = () => {
        this.props.clearFormInput(`POSProductsProductSearch`);
        this.props.clearFormInput(`POSPatientPatient`);
        this.props.formInput("3", "POSTypeCheckbox");
        this.props.formInput([], "POSWeightCheckbox");
        this.props.formInput([], "POSBrandCheckbox");
        this.props.formInput([], "POSSpeciesCheckbox");
        this.props.formInput(null, "POSCategory");
        this.props.formInput(0, `SortFilter`);
        this.props.formInput(null, `POSEmailReceiptDialogEmail`);
        this.props.formInput(null, `POSEmailInvoiceDialogEmail`);
    }

    setIsImportingPOS = (value) => {
        this.setState({
            isImportingPOS: value
        })
    }

    closeMenu = () => {
        this.setState({ anchorEl: null });
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        const s = this.state;
        const order = p.posOrder;
        const doesOrderExist = order ? true : false;
        const orderIsCancelled = order && order.status === 'Cancelled';
        const orderIsCompleted = order && (order.status === 'Completed' || order.status === 'Returned' || order.status === 'ReturnedPartial' || order.status === 'WaitingPickUp' || order.status === 'WaitingFulfillment');
        const orderHasPayment = order && order.payments && order.payments.length > 0;
        const orderIsFulfilled = this.props.fulfillmentMustScanAllForComplete && order && order.fulfillmentDone;
        const disableAllButtons = orderIsCancelled || orderIsCompleted;
        const productTotaldiscount = order && order.products ? order.products.reduce((acc, product) => acc + product.discountValue, 0) : 0
        const memberSelected = order && order.patientId && order.patientId !== 0;
        const isAlpine = this.props.alpineIQApiKey && this.props.posOrder && (this.props.posOrder.status == "Opened" || this.props.posOrder.status == "Reopened");
        const isSpring = Boolean(this.props.springbigApiKey && !this.props.springBigRewardsOff && this.props.posOrder && !this.props.posOrder.hasDiscounts && (this.props.posOrder.status == "Opened" || this.props.posOrder.status == "Reopened"));
        const sbMemberOptIn = order && order.patientSpringBig && this.props.sbOptInSpringBig && this.props.sbPatientExists;
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const hideBCRewards = this.props.store && this.props.store.provinceState && (this.props.store.provinceState.toLowerCase() == "bc" || this.props.store.provinceState.toLowerCase() == "british columbia") && !this.props.isMedical;
        const allowPayment = !(order && order.status === 'Opened' && order.products
            && order.products.length > 0
            && order.products.filter((i) => i.status === 1 || i.status === 2).length > 0);
        const allowPrintAllLabels = !(order && order.products
            && order.products.length > 0
            && order.products.filter((i) => i.isCannabis && (i.status === 1 || i.status === 2)).length > 0);
        const { anchorEl, anchorElGift, anchorElPurchaseGift, anchorElPaystoneGift, anchorElBirchmountGift } = this.state;
        let optionMenuList = [
            {
                label: t('pos.buttons.startNewOrder')
                , onClick: () => this.startNewOrder()
            },
            {
                label: t('pos.buttons.viewOrders')
                , onClick: () => this.openRecentOrdersDialog()
            },
            {
                label: t('pos.buttons.cancelOrder')
                , onClick: () => this.openDialogCancelOrder()
                , disabled: (disableAllButtons || !doesOrderExist)
            },
            {
                label: t('pos.buttons.findOrder')
                , onClick: () => this.openRefundOrderDialog()
            },
            {
                label: t('pos.buttons.refresh')
                , onClick: () => this.reloadPOS()
            }
        ];

        if (p.showRemoveFNTaxBtn) {
            optionMenuList.push({
                label: t('pos.buttons.addRemoveFnTax')
                , onClick: () => {memberSelected ? this.setState({ dialogCheckFNId: true }) : this.props.showError(t('pos.page.findFNMemberToAdd'))}
                , disabled: (disableAllButtons || !doesOrderExist)
            });
        }

        if (p.taxExemptAllEnabled) {
            optionMenuList.push({
                label: t('pos.buttons.addRemoveAllTax')
                , onClick: () => this.applyTaxExempt("AllTaxes")
                , disabled: (disableAllButtons || !doesOrderExist || !memberSelected || !p.taxExemptAllEnabled)
            });
        }

        if (p.monerisEnabled) {
            optionMenuList.push({
                label: t('pos.buttons.initPinpad')
                , onClick: () => this.setMonerisPinpad("I")
            });
        }

        if (p.monerisEnabled && p.inStoreTipEnabled) {
            optionMenuList.push({
                label: t('pos.buttons.setPinpadTip')
                , onClick: () => this.openMonerisTipDialog()
            });
        }

        optionMenuList.push({
            label: t('pos.buttons.cancelOpenOrders')
            , onClick: () => this.openCancelOpenOrdersDialog()
        });

        optionMenuList.push({
            label: t('pos.buttons.cashFlowNote')
            , onClick: () => this.openCashInNoteDialog()
        });

        optionMenuList.push({
            label: t('pos.buttons.closeRegister')
            , onClick: () => this.openCloseRegisterDialog()
        });

        optionMenuList.push({
            label: t('pos.buttons.openCashDrawer')
            , onClick: () => this.openDrawerPinDialog(this.state.dialogOpenDrawerPin)
        });

        const optionsMenu = (
            <React.Fragment>
                <Button
                    name={`${p.name}OptionsMenu`}
                    id="options"
                    fullWidth
                    variant="contained"
                    className="pos-button-color"
                    onClick={(event) => { this.setState({ anchorEl: event.currentTarget }) }}
                    sx={{
                        height: "45px",
                        lineHeight: 1.2,
                        width: "100px",
                        padding: "3px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {t('pos.buttons.optionsUpper')}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => {
                        this.setState({ anchorEl: null });
                    }}
                >

                    {optionMenuList.map((option, index) => (
                        <MenuItem key={index} disabled={option.disabled} onClick={() => { this.setState({ anchorEl: null }); option.onClick() }}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            </React.Fragment>
        );

        const giftCardMenu = (
            <React.Fragment>
                <Button
                    name={`${p.name}GiftCardMenu`}
                    fullWidth
                    variant="contained"
                    className="pos-button-color btn-gift-card"
                    onClick={(event) => { this.setState({ anchorElGift: event.currentTarget }); }}
                >
                    {t('pos.buttons.giftCardIcon')}
                </Button>
                <Menu
                    anchorEl={anchorElGift}
                    open={Boolean(anchorElGift)}
                    onClose={() => {
                        this.setState({ anchorElGift: null });
                    }}
                >
                    {[
                        {
                            label: t('pos.buttons.initStore'),
                            onClick: () => this.openGiftCardInitDialog()
                        },
                        {
                            label: t('pos.buttons.addGiftCardToOrder'),
                            onClick: () => this.openVariableGiftCardDialog()
                        },
                        {
                            label: t('pos.buttons.cardInquiry'),
                            onClick: () => this.openGiftCardInquiryDialog()
                        },
                        {
                            label: t('pos.buttons.deactivateCard'),
                            onClick: () => this.deactivateCard()
                        }
                    ].map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => { this.setState({ anchorElGift: null }); option.onClick() }}
                            disabled={option.disabled || false}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            </React.Fragment>
        );

        const purchaseGiftCardMenu = (
            <React.Fragment>
                <Button
                    name={`${p.name}PurchaseGiftCardMenu`}
                    fullWidth
                    variant="contained"
                    className="pos-button-color btn-gift-card"
                    onClick={(event) => { this.setState({ anchorElPurchaseGift: event.currentTarget }); }}
                >
                    {t('pos.buttons.giftCardIcon')}
                </Button>
                <Menu
                    anchorEl={anchorElPurchaseGift}
                    open={Boolean(anchorElPurchaseGift)}
                    onClose={() => {
                        this.setState({ anchorElPurchaseGift: null });
                    }}
                >
                    {[
                        {
                            label: t('pos.buttons.addGiftCardToOrder'),
                            onClick: () => this.openSellGiftCardDialog()
                        },
                        {
                            label: t('pos.page.checkBalance'),
                            onClick: () => this.openCheckBalanceDialog()
                        }
                    ].map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => { this.setState({ anchorElPurchaseGift: null }); option.onClick() }}
                            disabled={option.disabled || false}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            </React.Fragment>
        );

        const paystoneGiftCardMenu = (
            <React.Fragment>
                <Button
                    name={`${p.name}PaystoneGiftCardMenu`}
                    fullWidth
                    variant="contained"
                    className="pos-button-color btn-gift-card"
                    onClick={(event) => { this.setState({ anchorElPaystoneGift: event.currentTarget }); }}
                >
                    {t('pos.buttons.giftCardIcon')}
                </Button>
                <Menu
                    anchorEl={anchorElPaystoneGift}
                    open={Boolean(anchorElPaystoneGift)}
                    onClose={() => {
                        this.setState({ anchorElPaystoneGift: null });
                    }}
                >
                    {[
                        {
                            label: t('pos.buttons.addGiftCardToOrder'),
                            onClick: () => this.openVariableGiftCardDialog()
                        },
                        {
                            label: t('pos.page.checkBalance'),
                            onClick: () => this.openPaystoneGiftCardCheckBalanceDialog()
                        },
                        {
                            label: t('pos.buttons.cancelActivation'),
                            onClick: () => this.openPaystoneGiftCardCancelDialog()
                        }
                    ].map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => { this.setState({ anchorElPaystoneGift: null }); option.onClick() }}
                            disabled={option.disabled || false}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            </React.Fragment>
        );

        const birchmountGiftCardMenu = (
            <React.Fragment>
                <Button
                    name={`${p.name}BirchmountGiftCardMenu`}
                    fullWidth
                    variant="contained"
                    className="pos-button-color btn-gift-card"
                    onClick={(event) => { this.setState({ anchorElBirchmountGift: event.currentTarget }); }}
                >
                    {t('pos.buttons.giftCardIcon')}
                </Button>
                <Menu
                    anchorEl={anchorElBirchmountGift}
                    open={Boolean(anchorElBirchmountGift)}
                    onClose={() => {
                        this.setState({ anchorElBirchmountGift: null });
                    }}
                >
                    {[
                        {
                            label: t('pos.buttons.addGiftCardToOrder'),
                            onClick: () => this.openVariableGiftCardDialog()
                        },
                        {
                            label: t('pos.page.checkBalance'),
                            onClick: () => this.openBirchmountGiftCardCheckBalanceDialog()
                        },
                        {
                            label: t('pos.buttons.reverseActivate'),
                            onClick: () => this.openBirchmountGiftCardCancelDialog()
                        }
                    ].map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => { this.setState({ anchorElBirchmountGift: null }); option.onClick() }}
                            disabled={option.disabled || false}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            </React.Fragment>
        );

        let onlineOrderText = this.props.fulfillmentEnabled ? t('pos.page.queuedOrderLower') : t('pos.page.onlineOrderLower');
        const patientAvatarFirstName = order ? order.patientFirstName : null;
        const patientAvatarLastName = order ? order.patientLastName : null;

        if (deviceData == null) {
            return (
                <div className="pos-error">
                    <h3>{t('pos.page.posNotConfiguredYet')}</h3>
                    <p>{t('pos.page.forFurtherAssistance')} <a href='https://knowledge.techpos.ca/en/knowledge/how-to-troubleshoot-pos-not-configured-error' target="_blank">{t('pos.page.clickeHere')}</a>.</p>
                    <CustomButton
                        className="pull-right space"
                        name="buttonRemoveItem"
                        label={t('pos.page.goToDevicePage')}
                        primary={true}
                        onTouchTap={this.goToDevicesPage} />
                </div>
            );
        }
        const lastItems = p.posOrder && p.posOrder.products ? p.posOrder.products.filter(item => item.quantityInStock == 0) : [];

        const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
            height: 12,
            borderRadius: 2,
            [`&.${linearProgressClasses.colorPrimary}`]: {
                backgroundColor: theme.palette.grey[200],
                ...theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[800],
                }),
            },
            [`& .${linearProgressClasses.bar}`]: {
                borderRadius: 2,
                backgroundColor: "rgb(74, 186, 108)",
                ...theme.applyStyles('dark', {
                    backgroundColor: '#308fe8',
                }),
            },
        }));

        const lang = localStorage.getItem("language") || "en";

        return (
            <div className={`POSPage ${lang}`}>
                {(this.props.usePinPad && !this.props.userPin.authenticated) ? <PinScreen /> :
                    <div>
                        {p.logoutPinAfterSeconds && !p.loading && (p.posOrder ? p.posOrder.status !== "Opened" : (p.cashFlow && p.cashInEnabled)) && this.isAllDialogClosed() &&
                            <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onIdle={this.handleOnIdle}
                                debounce={250}
                                timeout={p.logoutPinAfterSeconds * 1000} />
                        }
                        {/* p.logoutPinAfterSeconds * 1000} />} */}
                        <DialogInput
                            title={<DialogHeader text="TECHPOS" classicClass="posDialogClassic" />}
                            actions={[
                                <CustomButton
                                    key={1}
                                    name="buttonHome"
                                    label={t('pos.page.troubleshootHere')}
                                    primary={false}
                                    onTouchTap={() => this.troubleshootPage()} />,
                                <CustomButton
                                    key={2}
                                    className="pull-right space btnNewBrandPOS"
                                    name="buttonRemoveItem"
                                    label={t('pos.page.tryAgain')}
                                    primary={true}
                                    onTouchTap={() => this.reloadPOS()} />]}
                            modal={true}
                            style={{ zIndex: '980' }}
                            open={this.state.dialogServiceError}>
                            {t('pos.page.hardwareProblemMsg')}
                        </DialogInput>
                        <DialogInput
                            title={<DialogHeaderWithClose text={t('pos.openRefundDialog.title')} classicClass="posDialogClassic" handleClose={() => this.closeRefundOrderDialog()} />}
                            actions={[
                                <CustomButton
                                    key={1}
                                    name="buttonRefundDialogCancel"
                                    type="Button"
                                    className="corner_X"
                                    primary={false}
                                    onTouchTap={() => this.closeRefundOrderDialog()} />,
                                <CustomButton
                                    key={2}
                                    className="pull-right space btnNewBrandPOS"
                                    name="buttonRefundDialogConfirm"
                                    label={t('pos.page.open')}
                                    primary={true}
                                    onTouchTap={() => this.reopenOrderRefund()} />]}
                            modal={true}
                            style={{ zIndex: '980' }}
                            autoScrollBodyContent={true}
                            open={this.state.dialogRefundOrder}>
                            <div>
                                <h4>{t('pos.openRefundDialog.message')}</h4>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}POSOrderOpenForRefund`}
                                            fullWidth={true}
                                            label={t('common.orderNum')}
                                            floatingLabelText={t('common.orderNum')}
                                            onKeyPress={this.onRefundKeyPress}
                                            hintText={t('common.orderNum')} />
                                    </div>
                                </div>
                            </div>
                        </DialogInput>

                        <Dialog
                            modal={true}
                            open={this.state.loading}
                            contentStyle={loadDialogcustomContentStyle}
                            style={loadDialogStyle}>
                            <div className="loading">
                                <CircularProgress size={50} thickness={5} />
                            </div>
                        </Dialog>

                        {/* Internal Message Dialog */}
                        <DialogInput
                            title={<DialogHeader text={t('pos.page.viewInternalMsg')} />}
                            actions={
                                <CustomButton
                                    type="CancelButton"
                                    className="btn-space"
                                    label={t('common.close')}
                                    secondary={true}
                                    onTouchTap={() => this.setState({ isOpenMessage: false })}
                                />}
                            modal={true}
                            open={this.state.isOpenMessage}
                            autoScrollBodyContent={true}>
                            <div className="row">
                                <div className="col-lg-12 p-0" style={{ whiteSpace: 'pre-line' }}>
                                    <br />
                                    <p>{this.props.internalMessage}</p>
                                    <img src={this.props.bannerImageURL} className="w-100" />
                                </div>
                            </div>
                        </DialogInput>


                        <POSRecentOrdersDialog open={s.dialogRecentOrders} onClose={this.closeRecentOrdersDialog} />

                        <InventoryFlagDialog open={s.openInventoryFlagDialog} onClose={this.closeInventoryFlagDialog} />

                        <POSVariableGiftCardDialog open={s.variableGiftCardDialog} onClose={this.closeVariableGiftCardDialog} addProductToPOSOder={this.props.addProductToPOSOder} />

                        <POSAccessorySaleDialog open={s.acccessorySaleDialog} onClose={this.closeAccessorySaleDialog} addProductToPOSOder={this.props.addProductToPOSOder} />

                        <POSPrintLabel name="pos-labels" order={p.posOrder}
                            products={p.posOrder
                                ? (s.labelProductId ? p.posOrder.products.filter((i) => i.id === s.labelProductId) : p.posOrder.products) : []}
                            print={s.printLabel}
                            onPrintCompleted={() => this.onPrintLabelComplete()} />

                        <POSPrintReceipt name="pos-receipt" order={p.posOrder} fianlSaleTextShowOnReceipt={this.props.fianlSaleTextShowOnReceipt} showMemberSavings={p.receiptShowMemberSavings} />

                        {/* Main Area */}
                        <div className="col-lg-12 bottom20">
                            <div className="sales_header m-0">
                                {/* Button Header */}
                                <div className="posBtnHeader">
                                    <div className="regPosButtons pt-1 pb-1">
                                        {!disableAllButtons && this.props.memberEnabled && (!order || !order.patientId || order.patientId === 0) ?
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    name="saveButton"
                                                    id="searchMemberButton"
                                                    fullWidth={true}
                                                    className="seach_member_color"
                                                    variant="contained"
                                                    sx={{ height: "45px", lineHeight: 1.2, width: "100px", padding: "3px", display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                    onClick={this.openPatientDialog} >
                                                    {t('pos.page.searchHereIcon')}
                                                </Button>
                                            </div>
                                            : ""}
                                        <div className="float-L posBtnMargin">
                                            <Button
                                                name="SearchOnlineOrderBtn"
                                                className="pos-button-color"
                                                sx={{ height: "45px", lineHeight: 1.2, width: "100px", padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                fullWidth={true}
                                                variant="contained"
                                                onClick={() => this.syncData()}
                                            >{t('pos.page.syncSetting')}</Button>
                                        </div>
                                        {!disableAllButtons && this.props.memberEnabled && (!order || !order.patientId || order.patientId === 0) ?
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    name="addButton"
                                                    id="addMemberButton"
                                                    fullWidth={true}
                                                    variant="contained"
                                                    className="pos-button-color"
                                                    sx={{ height: "45px", lineHeight: 1.2, width: "100px", padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                    onClick={this.openAddMemberDialog} >+ {t('pos.page.addMemberUpper')}</Button>

                                            </div>
                                            : ""}
                                        {this.props.cashInEnabled &&
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    name="OnlineOrderLineBtn"
                                                    id="CashInBtn"
                                                    className="pos-button-color"
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => this.opencashInDialog()}
                                                    onClose={() => this.closeDialogCashIn()}
                                                    sx={{
                                                        height: "45px",
                                                        lineHeight: 1.2,
                                                        width: "100px",
                                                        padding: "3px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    {t('pos.page.cashIn')}
                                                </Button>
                                            </div>
                                        }

                                        {
                                            this.props.cashInEnabled &&
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    fullWidth={true}
                                                    id="cashDropButton"
                                                    className="pos-button-color"
                                                    sx={{ height: "45px", lineHeight: 1.2, width: "100px", padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                    variant="contained"
                                                    onClick={() => this.openCashDropDialog()}
                                                    onClose={() => this.closeDialogCashDrop()}
                                                >{t('pos.buttons.cashDrop')}</Button>
                                            </div>
                                        }
                                        {
                                            p.posOrder && p.posOrder.status == "Opened" && p.fulfillmentEnabled && !p.posOrder.fulfillmentDone && !p.fulfillmentPayFirst && (
                                                <div className="float-L posBtnMargin">
                                                    <Button
                                                        fullWidth={true}
                                                        className="pos-button-color"
                                                        buttonStyle={{}}
                                                        sx={{
                                                            height: "45px", lineHeight: 1.2, width: "100px",
                                                            padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'
                                                        }}
                                                        variant="contained"
                                                        onClick={() => this.sendToFulfillment()}
                                                    >{t('pos.buttons.sendToFulfillment')}</Button>
                                                </div>
                                            )
                                        }
                                        {
                                            !disableAllButtons && this.props.showPOSBulkImport ?
                                                <div className="float-L posBtnMargin">
                                                    <ExcelUploadPOSOrder
                                                        employeeId={this.props.userPin.authenticated ? this.props.userPin.employee.id : 0}
                                                        deviceData={JSON.parse(localStorage.getItem(this.props.deviceKeyName))}
                                                        currentOrder={this.selectOrderModel(null, null, null, false)}
                                                    />
                                                </div> : ""
                                        }
                                        {
                                            this.props.hasWebMenu &&
                                            <div className="float-L posBtnMargin">
                                                <BadgeLabel
                                                    badgeContent={p.openQueuedOrdersCount}
                                                    name="SearchOnlineOrderBtn"
                                                    className={p.openQueuedOrdersCount > 0 ? 'queuedOrderBadge' : "queuedOrderBadgeNoCount"}
                                                    style={{ height: "45px" }}
                                                    buttonStyle={{ lineHeight: 1.2, width: "100px" }}
                                                    labelStyle={{ padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                    buttonClassName='pos-button-color'
                                                    fullWidth={true}
                                                    label={t('pos.page.queuedOrder')}
                                                    primary={true}
                                                    onTouchTap={() => this.openOnlineOrderSearch()}
                                                    onClose={() => this.closeOnlineOrderSearch()}
                                                />
                                            </div>
                                        }
                                        {
                                            this.props.buddiEnabled &&
                                            <div className="float-L posBtnMargin">
                                                <BadgeLabel
                                                    badgeContent={p.openBuddiOrdersCount}
                                                    name="OnlineOrderLineBtn"
                                                    fullWidth={true}
                                                    label={t('pos.page.buddiOrder')}
                                                    primary={true}
                                                    className={p.openBuddiOrdersCount > 0 ? 'queuedOrderBadge' : "queuedOrderBadgeNoCount"}
                                                    style={{ height: "45px" }}
                                                    buttonStyle={{ lineHeight: 1.2, width: "100px" }}
                                                    labelStyle={{ padding: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                    buttonClassName='pos-button-color'
                                                    onTouchTap={() => this.openBuddiOrdersDialog()}
                                                    onClose={() => this.closeBuddiOrdersDialog()}
                                                />
                                            </div>
                                        }
                                        {
                                            this.props.leaflyEnabled &&
                                            <div className="float-L posBtnMargin">
                                                <BadgeLabel
                                                    badgeContent={p.openLeaflyOrdersCount}
                                                    name="OnlineOrderLineBtn"
                                                    fullWidth={true}
                                                    label={t('pos.page.leaflyOrder')}
                                                    primary={true}
                                                    className={p.openLeaflyOrdersCount > 0 ? 'queuedOrderBadge' : "queuedOrderBadgeNoCount"}
                                                    style={{ height: "45px" }}
                                                    buttonStyle={{ lineHeight: 1.2, width: "100px" }}
                                                    labelStyle={{ padding: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                                                    buttonClassName='pos-button-color'
                                                    onTouchTap={() => this.openLeaflyOrdersDialog()}
                                                    onClose={() => this.closeLeaflyOrdersDialog()}
                                                />
                                            </div>
                                        }
                                        {
                                            this.props.wordpressEnabled &&
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    name="SearchOnlineOrderBtn"
                                                    className="pos-button-color"
                                                    sx={{
                                                        height: "45px",
                                                        lineHeight: 1.2, width: "100px",
                                                        padding: '3px', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'center', height: '100%'
                                                    }}
                                                    fullWidth={true}
                                                    variant="contained"
                                                    onClick={() => this.props.getManualWordpressOrdersUpdate(this.props.branchId)}
                                                >{t('pos.page.lookupWpOrders')}</Button>
                                            </div>
                                        }
                                        {this.props.genericGiftCardEnabled &&
                                            <div className="float-L posBtnMargin">
                                                {purchaseGiftCardMenu}
                                            </div>
                                        }
                                        {
                                            this.props.monerisGiftCardEnabled &&
                                            <div className="float-L posBtnMargin">
                                                {giftCardMenu}
                                            </div>
                                        }
                                        {
                                            this.props.paystoneGiftCardEnabled &&
                                            <div className="float-L posBtnMargin">
                                                {paystoneGiftCardMenu}
                                            </div>
                                        }
                                        {
                                            this.props.birchmountGiftCardEnabled &&
                                            <div className="float-L posBtnMargin">
                                                {birchmountGiftCardMenu}
                                            </div>
                                        }
                                        {
                                            this.props.generalAccessorySaleEnabled &&
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    name="SearchOnlineOrderBtn"
                                                    className="pos-button-color"
                                                    id="accessorySale"
                                                    sx={{
                                                        height: "45px", lineHeight: 1.2, width: "100px",
                                                        padding: '3px', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'center', height: '100%'
                                                    }}
                                                    fullWidth={true}
                                                    variant="contained"
                                                    onClick={() => this.openAccessorySaleDialog()}
                                                >{t('pos.page.accessorySale')}</Button>
                                            </div>
                                        }
                                        {
                                            this.props.combos && this.props.combos.length > 0 && !orderIsFulfilled &&
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    name="SearchOnlineOrderBtn"
                                                    id="openComboButton"
                                                    className="pos-button-color"
                                                    sx={{
                                                        height: "45px", lineHeight: 1.2, width: "100px", padding: '3px', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'center', height: '100%'
                                                    }}
                                                    fullWidth={true}
                                                    variant="contained"
                                                    onClick={() => this.openComboDialog()}
                                                >{t('pos.page.combos')}</Button>
                                            </div>
                                        }
                                        <div className="float-L posBtnMargin">{optionsMenu}</div>
                                        {memberSelected && isAlpine ?
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    className="btn-online-orders"
                                                    name={'alpineIQdiscounts'}
                                                    onClick={() => this.openAlpineIQRewardsDialog()}
                                                    disabled={this.props.posOrder && this.props.posOrder.discounts && this.props.posOrder.discounts.length > 0}
                                                >{t('pos.page.alpineIqDiscounts')} </Button>
                                            </div> : ""}
                                        {memberSelected && isAlpine && this.props.alpineIQCheckInButton ?
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    className="btn-online-orders"
                                                    name={'alpineIQcheckin'}
                                                    onClick={() => this.alpineCheckIn()} >{t('pos.page.alpineIqCheckIn')}</Button>
                                            </div> : ""}

                                        {memberSelected && isSpring && sbMemberOptIn ?
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    className="btn-online-orders"
                                                    name={'springbigdiscounts'}
                                                    onClick={() => this.openSpringBigOffersDialog()} >{t('pos.page.springOffers')}</Button>
                                            </div> : ""}
                                        {memberSelected && isSpring && sbMemberOptIn ?
                                            <div className="float-L posBtnMargin">
                                                <Button
                                                    className="btn-online-orders"
                                                    buttonStyle={{}}
                                                    sx={{
                                                        height: "45px", lineHeight: 1.2, width: "100px",
                                                        padding: '3px', display: 'flex', alignItems: 'center',
                                                        justifyContent: 'center', height: '100%', color: "white"
                                                    }}
                                                    name={'springbigdiscounts'}
                                                    onClick={() => this.openSpringBigRewardsDialog()} >{t('pos.page.springRewards')}</Button>
                                            </div> : ""
                                        }
                                    </div>
                                    {(this.props.internalMessage || this.props.bannerImageURL) &&
                                        <div className="pos-message-board-container">
                                            <div className="pos-message-board" onClick={() => this.setState({ isOpenMessage: true })}>
                                                {this.props.bannerImageURL
                                                    ?
                                                    <div>
                                                        <img src={this.props.bannerImageURL} />
                                                    </div>
                                                    :
                                                    <div className="pos-message-text">
                                                        <div className="pos-message ml-1">{t('pos.page.bellIcon')} {(this.props.internalMessage && this.props.internalMessage.length > 70) ? this.props.internalMessage.slice(0, 70) + "..." + t('pos.page.viewMore') : this.props.internalMessage}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                {this.props.usePinPad && (
                                    <div className="pin-lock-btn-wrapper">
                                        <CustomButton
                                            type="IconButton"
                                            className="pin-lock-btn pin-lock-btn"
                                            name="lockPin"
                                            label={t('pos.page.lock')}
                                            primary={true}
                                            icon={<LockIcon />}
                                            onTouchTap={this.lockPinPassword}
                                        />
                                    </div>
                                )}

                                {order && order.onlineOrderCode !== null && order.onlineOrderCode !== undefined && order.onlineOrderCode > 0 &&
                                    (<span className='font_jakarta' style={{ fontSize: '18px' }}>
                                        {`${onlineOrderText}#: `}<span style={{ fontWeight: 'bold' }}>{order.onlineOrderCode}</span>
                                    </span>)}

                                {order && order.onlineOrderCode !== null && order.onlineOrderCode !== undefined && order.patientId !== 0 &&
                                    (<br />)}

                                {memberSelected ?
                                    <div className="pos-member-info pt-1">
                                        <div className="avatar_container">
                                            {memberSelected ?
                                                (<Avatar imageUrl={order ? order.patientPhotoUrl : null} />) : null}
                                        </div>
                                        <div className="member_MamePoint_container">
                                            {order && this.props.memberEnabled &&
                                                <Link onClick={this.showPatientSaveDialog}>
                                                    <div className="member_name_container">
                                                        <span className='font_jakarta' style={{ fontSize: "18px" }}>{order.patientId !== 0 ? patientAvatarFirstName : null}</span>
                                                        <br />
                                                        <span className='font_jakarta' style={{ fontSize: "18px" }}>{order.patientId !== 0 ? patientAvatarLastName : null}</span>
                                                    </div>
                                                </Link>}
                                            {memberSelected && order.status == "Opened" ?
                                                <div>
                                                    <Link onClick={this.removeMember}>
                                                        <span className="text-info">{t('pos.page.remove')}</span>
                                                    </Link>
                                                    <span>&nbsp;/&nbsp;</span>
                                                    <Link onClick={this.openPatientDialog}>
                                                        <span className="text-info">{t('pos.page.changeMember')}</span>
                                                    </Link>
                                                </div>
                                                : null
                                            }
                                            <div className="member_points_container">

                                                {memberSelected ? !this.props.alpineIQApiKey && !this.props.springbigApiKey && !this.props.hideRewards && !hideBCRewards &&
                                                    <Link onClick={this.openPointsDialog}>
                                                        <div className='font_jakarta' style={{ fontSize: "14px", color: "#31708f" }}>{t('pos.page.rewardPoints')}: {order && order.patientRewardPoints && order.patientRewardPoints > 0 ? <b>{order.patientRewardPoints.toFixed(0)}</b> : <b> 0</b>}
                                                        </div>
                                                    </Link> : null
                                                }

                                                {memberSelected ?
                                                    (<div className='font_jakarta' style={{ fontSize: "14px", color: "#333333" }}>
                                                        {t('pos.page.completedOrders')}: {order && order.patientOrderCount && order.patientOrderCount > 0 ? <b>{order.patientOrderCount}</b> : <b>0</b>}
                                                    </div>) : ""}

                                                {memberSelected && !this.props.alpineIQApiKey && !this.props.springbigApiKey && this.props.visitCountsForDiscount > 0 && this.props.visitCountDiscount > 0 && !hideBCRewards ?
                                                    <div>
                                                        <span className='font_jakarta' style={{ verticalAlign: 'center', fontSize: "14px", color: "#333333" }}>{t('pos.page.visitCount')}: {order && order.patientVisitCount > 0 ? <b>{order.patientVisitCount}</b> : <b> 0</b>} </span><br />
                                                        {order && !orderIsCancelled && !orderIsCompleted && order.patientVisitCount >= this.props.visitCountsForDiscount && (this.props.stackDiscountsEnabled || !this.props.posOrder.hasDiscounts) && this.props.posOrder.total > 0 && !hideBCRewards &&
                                                            <CustomButton
                                                                className="btnNewBrandPOS member-view-order-history-btn"
                                                                type="RaisedButton"
                                                                name={'visitCount'}
                                                                label={t('pos.page.visitCountDiscountNotice', { visitCountDiscount: this.props.visitCountDiscount, visitCountsForDiscount: this.props.visitCountsForDiscount})}
                                                                onTouchTap={() => this.openVisitDiscountDialog()} />
                                                        }
                                                    </div> : null
                                                }
                                                {
                                                    memberSelected && this.props.eliteMemberStartDate && this.props.eliteMemberEndDate && (new Date(this.props.eliteMemberStartDate).getTime() < new Date().getTime()) && (new Date(this.props.eliteMemberEndDate).getTime() > new Date().getTime()) ?
                                                        (
                                                            <div className='font_jakarta' style={{ fontSize: "16px", color: "red" }}>
                                                                {t('pos.page.eliteMember')}
                                                            </div>
                                                        ) : ""
                                                }
                                                {
                                                    memberSelected && this.props.eliteMemberEndDate && (new Date(this.props.eliteMemberEndDate).getTime() < new Date().getTime()) ?
                                                        <div className="font_jakarta">
                                                            {t('pos.page.expiredEliteMember')} <br /><b>{moment(this.props.eliteMemberEndDate).format("MM-DD-YYYY")}</b>
                                                        </div>
                                                        : ""
                                                }
                                                {
                                                    memberSelected && order.patientIsEmployee ?
                                                        (
                                                            <div className='font_jakarta' style={{ fontSize: "16px", color: "red" }}>
                                                                {t('pos.page.employee')}
                                                            </div>
                                                        ) : ""
                                                }
                                                {memberSelected ?
                                                    <CustomButton
                                                        className='btnNewBrandPOS member-view-order-history-btn'
                                                        type="RaisedButton"
                                                        style={{ marginTop: '10px' }}
                                                        label={t('pos.page.viewOrderButton')}
                                                        onTouchTap={() => this.showOrderHistory(order.patientId)}
                                                    /> : null

                                                }
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                            </div>

                            <POSPatient name="POSPatient" isOpen={this.state.dialogPatient} onClose={() => this.closePatientDialog()} />

                            <POSAssignMember isOpen={this.state.assignMember} onClose={() => this.closeAssignMemberDialog()} />

                            <POSAddAsDutchieLeafly isOpen={this.state.addDutchieDialog} onClose={this.closeAddDutchieDialog} dutchieOrLeafly={this.state.dutchieOrLeafly} />

                            <RewardPoints openDiag={this.state.openPointsDiag} closePoints={this.closePointsDialog} addRewardPoints={this.addRewardPoints} removeRewardPoints={this.removeRewardPoints} isPOS />

                            <section className="posContainer">
                                <div className="FilterCategoriesContainer">
                                    <DialogHeader
                                        text={
                                            (orderIsCancelled || orderIsCompleted)
                                                ? ""
                                                : (this.state.hideMenu ? t('pos.page.categories') : t('pos.page.filtersAndCategories'))
                                        }
                                        classicClass="posDialogClassic"
                                        classicClassFont="classicClassFont"
                                    />
                                    {
                                        orderIsCompleted ? (
                                            <React.Fragment>
                                                <br />
                                                <div className="row">
                                                    <div className="col-lg-12 p-1">
                                                        <div className="alert alert-info">
                                                            {
                                                                order && order.status == "WaitingPickUp" ? <strong>{t('pos.page.orderToPickUp')}</strong> : order.status == "WaitingFulfillment" ? <strong>{t('pos.page.orderToFulfill')}</strong> : <strong>{t('pos.page.orderCompleted')}</strong>
                                                            }
                                                        </div>
                                                        <CustomButton
                                                            type="RaisedButton"
                                                            name="startNewOrderButton"
                                                            label={t('pos.buttons.startNewOrder')}
                                                            fullWidth={true}
                                                            primary={true}
                                                            className="new-order-pos btnNewBrandPOS"
                                                            onTouchTap={() =>
                                                                this.startNewOrder()} />
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            orderIsCancelled ? (
                                                <div className="m-1">
                                                    <br />
                                                    <div className="row">
                                                        <br />
                                                        <div className="col-lg-12">
                                                            <div className="alert alert-danger">
                                                                <strong>{t('pos.page.attentionWarning')} </strong>
                                                                <br />
                                                                <p>
                                                                    {t('pos.page.orderIsCanceled')}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <CustomButton
                                                                type="RaisedButton"
                                                                name="startNewOrderButton"
                                                                label={t('pos.buttons.startNewOrder')}
                                                                fullWidth={true}
                                                                primary={true}
                                                                className="new-order-pos"
                                                                onTouchTap={() => this.startNewOrder()} />
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>
                                            ) : (<POSProduct name="POSProducts" webSocket={this.ws} updateDialogProduct={this.updateDialogProduct} hideMenu={this.state.hideMenu} hideSideBar={this.hideSideBar} />)
                                        )
                                    }
                                </div>
                                {/* ORDER DETAILS - MIDDLE SECTION - COL-6 */}
                                <div className="CheckoutContainer">
                                    <div>
                                        {
                                            this.props.posOrder != null && this.props.posOrder.totalGram ?
                                                <div className="gram-bar">
                                                    <BorderLinearProgress variant="determinate" value={(this.props.posOrder.totalGram - 0) * 100 / (30 - 0)} />
                                                    <p className="purpleText">30gr</p>
                                                </div>
                                                : ""
                                        }
                                        <div className="orderDetailsHeader font_jakarta">
                                            <div className="order_img"></div>
                                            <div className="order_qty">{t('pos.page.qty')}</div>
                                            <div className="order_description">{t('common.description')}</div>
                                            <div className="order_price">{t('common.price')}</div>
                                        </div>
                                        <div className="list-group">
                                            <div className="sales_order_group font_jakarta">
                                                {
                                                    order && order.products && order.products.length > 0 ?
                                                        (
                                                            order.products.map((product, index) => {
                                                                let foundCombos = [];

                                                                if (!product.isInCombo && product.status == 1) {
                                                                    foundCombos = this.findCombos(p.combos, product);
                                                                }
                                                                let isInCombo = foundCombos.length > 0;
                                                                return (
                                                                    <div key={product.orderProductId} style={{ borderBottom: "0.5px solid #e0e0e0", height: "auto" }}>
                                                                        <div style={{ display: 'flex' }} key={index}>
                                                                            <div className="POS_cart_product_img_container">
                                                                                <img className='POS_cart_product_img' src={product.imageUrl ? product.imageUrl : imgDefault} alt={`img for ${product.name}`} />
                                                                            </div>
                                                                            <div className={memberSelected ? "member_item_qty" : "item_qty"}>
                                                                                {
                                                                                    product.measurementType === MeasurementType.Unit ? (
                                                                                        <span className={product.status === 4 ? 'voided purpleText font_jakarta' : 'font_jakarta'}>
                                                                                            {product.quantity}
                                                                                        </span>
                                                                                    ) : product.measurementType === MeasurementType.Gram ? (
                                                                                        <span className={product.status === 4 ? 'voided purpleText font_jakarta' : 'font_jakarta'}>
                                                                                            {product.quantity} g
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span className={product.status === 4 ? 'voided purpleText font_jakarta' : 'font_jakarta'}>
                                                                                            {product.quantity / product.weightPerUnit}
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                                {(disableAllButtons || orderHasPayment) || !(product.measurementType === MeasurementType.Unit) || orderIsFulfilled ? null :
                                                                                    <div id={`addmore_${index}`}>
                                                                                        <CustomButton
                                                                                            type="IconButton"
                                                                                            name="add"
                                                                                            label=""
                                                                                            onTouchTap={() => this.addMoreProducts(product)}
                                                                                            icon={<AddCircleOutlined />}
                                                                                        />
                                                                                    </div>
                                                                                }
                                                                            </div>

                                                                            <div className="item_description">
                                                                                <div className={`order_details_product_name ${product.status === 4 ? 'voided font_jakarta' : 'font_jakarta'}`}>
                                                                                    #{index + 1}- {product.name} <br />

                                                                                    {!this.props.isMedical && this.props.offlineProductScan && !this.props.padVersion && product.packages && product.packages.length > 1 && !product.packageReference ?
                                                                                        <SelectInputPOSLot
                                                                                            name={`PackageReference-${product.orderProductId}`}
                                                                                            hintText={t('pos.page.chooseLotNumLabel')}
                                                                                            options={product.packages}
                                                                                            onChange={(packageReference) => this.props.updatePackageReference(product.orderProductId, packageReference)}
                                                                                        />
                                                                                        :
                                                                                        <span className="lot-number-pos-item font_jakarta">
                                                                                            ({(product.packageReference != null && product.packageReference != "") ? t('pos.page.lotNum') + product.packageReference : t('pos.page.noLotNum')})
                                                                                        </span>
                                                                                    }
                                                                                </div>
                                                                                <span style={{ textAlign: "left", fontSize: "12px" }}>
                                                                                    {product.priceMatchPlusPercentage !== 0 && product.priceMatchPlusPercentage !== null
                                                                                        ? t('pos.page.priceMatch')
                                                                                        : ``}
                                                                                </span>
                                                                                {
                                                                                    product.discountType && product.discountType !== OrderDiscountType.Order ?
                                                                                        !this.props.stackDiscountsEnabled && (product.priceMatchPlusPercentage != 0 || product.priceMatchPlusPercentage == null) ? (
                                                                                            <p className={`order_details_product_name ${product.status === 4 ? 'voided' : ''}purpleText font_jakarta`} id={`order_details_discount_info-${index}`}>
                                                                                                {product.discountAmount > 0 ? product.discountType === OrderDiscountType.Percentage ? t('pos.page.discountOfPerc', { discount: product.discountAmount.toFixed(0) }) : t('pos.page.discountOfAmt', { discount: product.discountAmount.toFixed(2) }) : null}
                                                                                                <br />
                                                                                                {product.discountAmount > 0 ? product.notes ? `${t('common.notes')}: ${product.notes}` : null : null}
                                                                                            </p>
                                                                                        ) :
                                                                                            <div className={`order_details_product ${product.status === 4 ? 'voided' : ''}purpleText font_jakarta`}>
                                                                                                {product.productDiscountList.map(discount => (
                                                                                                    !discount.isPriceMatchPlus && discount.amount > 0 && ( // Add this condition to only render when isPriceMatchPlus is false
                                                                                                        <div key={discount.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                                                <span style={{ textAlign: "left", fontSize: "12px" }}>
                                                                                                                    {discount.type === "Percentage"
                                                                                                                        ? t('pos.page.discountOfPerc', { discount: discount.percentage.toFixed(0) })
                                                                                                                        : t('pos.page.discountOfAmt', { discount: discount.amount.toFixed(2) })}
                                                                                                                </span>
                                                                                                                <span style={{ textAlign: "left", fontSize: "11px" }}>
                                                                                                                    {discount.notes && discount.notes.trim() !== "" && `${t('common.notes')}: ${discount.notes}`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                            <span className={product.status === 4 ? 'space_discount voided' : 'space_discount'} style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>
                                                                                                                <span style={{ display: 'inline-block', verticalAlign: 'baseline' }}>- $</span>
                                                                                                                <span>{discount.amount.toFixed(2)}</span>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )
                                                                                                ))}
                                                                                            </div>
                                                                                        : null
                                                                                }
                                                                                {
                                                                                    product.depositAmount && product.depositAmount > 0 ? (
                                                                                        <span className="lot-number-pos-item">
                                                                                            {t('pos.page.additionalDepositFee',{ amount: product.depositAmount.toFixed(2) })}
                                                                                        </span>
                                                                                    ) : null
                                                                                }
                                                                            </div>

                                                                            <div className={memberSelected ? "member_item_price" : "item_price"}>
                                                                                <div>
                                                                                    {
                                                                                        this.props.showOriginalNonMemberPrice && product.price < product.originalNonMemberPrice ? (
                                                                                            <div>
                                                                                                <span className='font_jakarta'>
                                                                                                    {t('common.member')}/{t('pos.page.combo')}: ${product.price.toFixed(2)}
                                                                                                </span>
                                                                                                <br />
                                                                                                <span className='font_jakarta'> {/* className='space voided' */}
                                                                                                    {t('pos.page.regular')}: ${product.originalNonMemberPrice.toFixed(2)}
                                                                                                </span>
                                                                                            </div>
                                                                                        ) :
                                                                                            <div className='font_jakarta'> {/* className={product.status === 4 ? 'space voided' : 'space'} */}
                                                                                                ${product.price.toFixed(2)}
                                                                                            </div>
                                                                                    }
                                                                                    {
                                                                                        product.discountType && product.discountType !== OrderDiscountType.Order && !this.props.stackDiscountsEnabled ? (
                                                                                            <div className={product.status === 4 ? 'space_discount voided' : 'space_discount'}>
                                                                                                - $ {product.discountValue.toFixed(2)}
                                                                                            </div>
                                                                                        ) : null
                                                                                    }
                                                                                </div>
                                                                                {(disableAllButtons || orderHasPayment || product.status === 4) ? null :
                                                                                    <div id={`voidProduct-${index}`}>
                                                                                        <CustomButton
                                                                                            type="IconButton"
                                                                                            onTouchTap={() => this.voidItem(product.orderId, product.id, false, product)}
                                                                                            icon={<DeleteIcon sx={{ color: "#FF4040" }} />}
                                                                                        />
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            justifyContent: 'flex-end',
                                                                            width: '100%',
                                                                            marginBottom: '3px',
                                                                        }}>
                                                                            {isInCombo && !product.isInCombo && product.status == 1 && <a className="mr-1" onClick={() => this.openProductComboList(foundCombos, product)}>
                                                                                {t('pos.page.canAddToCombo')}
                                                                            </a>
                                                                            }
                                                                            {
                                                                                product.status === 4
                                                                                    ? (<div className="pull-right label-item-pos voided-label">{t('pos.page.voided')}</div>)
                                                                                    : (product.qtyAvaibleForRefund == 0 ? (
                                                                                        <div className="pull-right label-item-pos refunded-label">{t('pos.page.refunded')}</div>
                                                                                    ) : product.qtyAvaibleForRefund > 0 && product.qtyAvaibleForRefund < product.quantity ? <div className="pull-right label-item-pos refunded-label">{t('pos.page.partiallyRefunded')}</div>
                                                                                    
                                                                                        :
                                                                                        (
                                                                                            <div>

                                                                                                {
                                                                                                    this.props.isMedical &&
                                                                                                        product.measurementType === MeasurementType.Gram ? (
                                                                                                        <Button
                                                                                                            type="FlatButtonPrimary"
                                                                                                            name="printLabelButton"
                                                                                                            className="pull-right space"
                                                                                                            label={t('pos.page.printLabel')}
                                                                                                            onTouchTap={() => this.printLabel(product)} />
                                                                                                    ) : null
                                                                                                }
                                                                                                {
                                                                                                    product.status === 2
                                                                                                    && product.category
                                                                                                    && product.category.replace(' ', '').toUpperCase().includes('GIFTCARD')
                                                                                                    && (p.monerisGiftCardEnabled || p.birchmountGiftCardEnabled || p.paystoneGiftCardEnabled || p.genericGiftCardEnabled)
                                                                                                    && !p.POSGenericGiftCardOrderSucessList.includes(product.id)
                                                                                                    && !product.giftCardLoadedSuccess
                                                                                                    && (
                                                                                                        <CustomButton
                                                                                                            type="FlatButtonPrimary"
                                                                                                            name="voidButton"
                                                                                                            className='pull-right void-button'
                                                                                                            label={t('pos.page.activateReload')}
                                                                                                            onTouchTap={() => this.activateCard(product.orderId, product.price, product.name, product.id)}
                                                                                                        />
                                                                                                    )
                                                                                                }
                                                                                            </div>
                                                                                        ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        )
                                                        : (
                                                            <div className="list-group-item thin_border">
                                                                <p className="list-group-item-heading font_jakarta">{t('pos.page.noProductsAdded')}</p>
                                                            </div>
                                                        )
                                                }
                                            </div>
                                            {
                                                order ? (
                                                    <POSOrderSummary order={order} togglePayment={this.togglePayment} />
                                                ) : null
                                            }
                                            {
                                                order && order.subTotalIncludingDiscounts === 0 && order.products.filter(item => item.status === OrderProductStatus.Open).length > 0 ? (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <CustomButton
                                                                type="RaisedButton"
                                                                name="finalizeOrderButton"
                                                                label={t('pos.page.finalizeOrder')}
                                                                fullWidth={true}
                                                                primary={true}
                                                                onTouchTap={this.finalizeOrder} />
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    {(orderIsCompleted || orderIsCancelled) ? null :
                                        <div className="float-R">
                                            <Button
                                                sx={{ padding: 1, color: "#FFFFFF" }}
                                                className="row mt-3 product-suggestion"
                                                variant="contained"
                                                fullWidth={false}
                                                onClick={() => this.showProductSuggestionDialog()}
                                            >
                                                <div>
                                                    <img src="https://techposdev.blob.core.windows.net/static/ProductSuggest.png" style={{ width: "auto", height: 48 }} />
                                                    <span style={{ marginLeft: "10px", marginRight: "10px", color: "white", fontWeight: "bold" }}>{t('pos.page.productSuggestion')}</span>
                                                </div>

                                            </Button>
                                        </div>
                                    }
                                </div>

                                {/* end order details - middle section */}
                                <DialogInput
                                    title={
                                        <DialogHeaderWithClose
                                            text={t('pos.page.checkOut')}
                                            handleClose={this.ToggleClosePayment}
                                        />
                                    }
                                    modal={true}
                                    open={this.state.isPaid}
                                    autoScrollBodyContent={true}
                                    style={{ zIndex: "950" }}
                                    contentStyle={{ width: "65%" }}
                                >
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="orderDetailsHeader">
                                                <div className="col-lg-1 col-xs-2">{t('pos.page.qty')}</div>
                                                <div className="col-lg-8 col-xs-7">{t('pos.page.description')}</div>
                                                <div className="col-lg-3 col-xs-3 text-right">{t('pos.page.price')}</div>
                                            </div>
                                            <div className='list-group'>
                                                <div className='sales_order_group' style={{ maxHeight: "200px" }}>
                                                    {!order ? null : order.products && order.products.filter(product => product.status !== 4).map((product, index) => {
                                                        return (
                                                            <div className="list-group-item" key={index} style={memberSelected ? { padding: '10px 0' } : {}} >
                                                                <div className="row">
                                                                    <div className="col-lg-1 col-xs-2 text-center">
                                                                        {product.measurementType === MeasurementType.Unit ? (
                                                                            <span className={product.status === 4 ? 'voided purpleText' : ''}>
                                                                                {product.quantity}
                                                                            </span>
                                                                        ) : product.measurementType === MeasurementType.Gram ? (
                                                                            <span className={product.status === 4 ? 'voided purpleText' : ''}>
                                                                                {product.quantity} g
                                                                            </span>
                                                                        ) : (
                                                                            <span className={product.status === 4 ? 'voided purpleText' : ''}>
                                                                                {product.quantity / product.weightPerUnit}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-lg-8 col-xs-7">
                                                                        <p className={`order_details_product_name ${product.status === 4 ? 'voided' : ''}`}>
                                                                            #{index + 1}- {product.name} <br />

                                                                            {!this.props.isMedical &&
                                                                                <span className="lot-number-pos-item">
                                                                                    ({(product.packageReference != null && product.packageReference != "") ? t('pos.page.lotNum') + product.packageReference : t('pos.page.noLotNum')})
                                                                                </span>
                                                                            }


                                                                        </p>
                                                                        <span style={{ textAlign: "left", fontSize: "12px" }}>
                                                                            {product.priceMatchPlusPercentage !== 0 && product.priceMatchPlusPercentage !== null
                                                                                ? t('pos.page.priceMatch')
                                                                                : ``}
                                                                        </span>
                                                                        {
                                                                            product.discountType && product.discountType !== OrderDiscountType.Order ?
                                                                                !this.props.stackDiscountsEnabled && (product.priceMatchPlusPercentage != 0 || product.priceMatchPlusPercentage == null) ? (
                                                                                    <p className={`order_details_product_name ${product.status === 4 ? 'voided' : ''}purpleText font_jakarta`}>
                                                                                        {product.discountAmount > 0 ? product.discountType === OrderDiscountType.Percentage ? t('pos.page.discountOfPerc', { discount: product.discountAmount.toFixed(0) }) : t('pos.page.discountOfAmt', { discount: product.discountAmount.toFixed(2) }) : null}
                                                                                        <br />
                                                                                        {product.discountAmount > 0 ? product.notes ? t('pos.page.productNotes', { notes: product.notes}) : null : null}
                                                                                    </p>
                                                                                ) :
                                                                                    <div className={`order_details_product ${product.status === 4 ? 'voided' : ''}purpleText font_jakarta`}>
                                                                                        {product.productDiscountList.map(discount => (
                                                                                            !discount.isPriceMatchPlus && discount.amount > 0 && ( // Add this condition to only render when isPriceMatchPlus is false
                                                                                                <div key={discount.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                                        <span style={{ textAlign: "left", fontSize: "12px" }}>
                                                                                                            {discount.type === "Percentage"
                                                                                                                ? t('pos.page.discountOfPerc', { discount: discount.percentage.toFixed(0)})
                                                                                                                : t('pos.page.discountOfAmt', { discount: discount.amount.toFixed(2)})}
                                                                                                        </span>
                                                                                                        <span style={{ textAlign: "left", fontSize: "11px" }}>
                                                                                                            {discount.notes && discount.notes.trim() !== "" && t('pos.page.productNotes', { notes: discount.notes})}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <span className={product.status === 4 ? 'space_discount voided' : 'space_discount'} style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>
                                                                                                        <span style={{ display: 'inline-block', verticalAlign: 'baseline' }}>- $</span>
                                                                                                        <span>{discount.amount.toFixed(2)}</span>
                                                                                                    </span>
                                                                                                </div>
                                                                                            )
                                                                                        ))}
                                                                                    </div>
                                                                                : null
                                                                        }
                                                                        {
                                                                            product.depositAmount && product.depositAmount > 0 ? (
                                                                                <span className="lot-number-pos-item">
                                                                                    {t('pos.page.additionalDepositFee', { amount: product.depositAmount.toFixed(2) })}
                                                                                </span>
                                                                            ) : null
                                                                        }
                                                                    </div>
                                                                    <div className="col-lg-3 col-xs-3">
                                                                        <div className="price-section text-right">
                                                                            {
                                                                                this.props.showOriginalNonMemberPrice && product.price < product.originalNonMemberPrice ? (
                                                                                    <React.Fragment>
                                                                                        <span className='space'>
                                                                                            {t('common.member')}/{t('pos.page.combo')}: ${product.price.toFixed(2)}
                                                                                        </span>
                                                                                        <br />
                                                                                        <span className='space voided'>
                                                                                            {t('pos.page.regular')}: ${product.originalNonMemberPrice.toFixed(2)}
                                                                                        </span>
                                                                                    </React.Fragment>
                                                                                ) :
                                                                                    <span className={product.status === 4 ? 'space' : 'space'}>
                                                                                        $ {product.price.toFixed(2)}
                                                                                    </span>
                                                                            }
                                                                        </div>
                                                                        <div className="discount-section">
                                                                            {
                                                                                !p.stackDiscountsEnabled && product.discountType && product.discountValue && product.discountType !== OrderDiscountType.Order ? (
                                                                                    <span className={product.status === 4 ? 'space voided' : 'space'}>
                                                                                        - $ {product.discountValue.toFixed(2)}
                                                                                    </span>
                                                                                ) : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {order ?
                                        <div className="list-group-item-heading pt-2">
                                            <div className="row">
                                                <div className="col-lg-5">
                                                    <p className="pull-left pos-summary"><strong>{t('pos.page.subtotal')}</strong></p>
                                                </div>
                                                <div className="col-lg-7">
                                                    <span className="pull-right pos-summary">
                                                        <strong>$ {order.subTotal.toFixed(2) || "0.00"}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            {
                                                (this.props.stackDiscountsEnabled && order.subTotalIncludingDiscounts && order.subTotalIncludingDiscounts !== order.subTotal) &&
                                                (<div className="row">
                                                    <div className="col-lg-9">
                                                        <p className="pull-left pos-summary" style={{ fontWeight: 700 }}>
                                                            {t('pos.orderSummary.totalDiscounts')}
                                                        </p>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <span className="pull-right pos-summary" style={{ fontWeight: 700 }}>
                                                            - $ {(order.subTotal - order.subTotalIncludingDiscounts).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>)
                                            }
                                            {
                                                !this.props.stackDiscountsEnabled ? (
                                                    // Displaying order discounts or product discount when stackDiscountsEnabled is false
                                                    order.discounts && order.discounts.length > 0 ? (
                                                        order.discounts.map((discount, index) => (
                                                            <div className="row" key={index}>
                                                                <div className="col-lg-9">
                                                                    <p className="pull-left pos-summary">
                                                                        {discount.text}
                                                                        {discount.notes ? `   ( ${t('pos.page.productNotes', { notes: discount.notes})} )` : null}
                                                                    </p>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <span className="pull-right pos-summary">
                                                                        - $ {discount.amount.toFixed(2)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : order.subTotal !== order.subTotalIncludingDiscounts ? (
                                                        <div className="row">
                                                            <div className="col-lg-9">
                                                                <p className="pull-left pos-summary">
                                                                    {t('pos.page.totalDiscountOnProd')}
                                                                </p>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <span className="pull-right pos-summary">
                                                                    - $ {(order.subTotal - order.subTotalIncludingDiscounts).toFixed(2)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : null
                                                ) : null
                                            }
                                            {this.props.stackDiscountsEnabled &&
                                                // Displaying individual discounts when stackDiscountsEnabled is true
                                                order.discounts && order.discounts.map((discount, index) => (
                                                    <div className="row" key={index}>
                                                        <div className="col-lg-9">
                                                            <p className="pull-left pos-summary">
                                                                {discount.text}
                                                                {discount.notes ? ` ( ${t('pos.page.productNotes', { notes: discount.notes})} )` : null}
                                                            </p>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <span className="pull-right pos-summary">
                                                                - $ {discount.amount.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            {this.props.stackDiscountsEnabled && productTotaldiscount > 0 &&
                                                // Displaying total discount on products if applicable when stackDiscountsEnabled is true
                                                (<div className="row">
                                                    <div className="col-lg-9">
                                                        <p className="pull-left pos-summary">
                                                            {t('pos.page.totalDiscountOnProd')}
                                                        </p>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <span className="pull-right pos-summary">
                                                            - $ {productTotaldiscount.toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>)
                                            }
                                            {
                                                order.subTotalIncludingDiscounts && order.subTotalIncludingDiscounts !== order.subTotal ? (
                                                    <div className="row">
                                                        <div className="col-lg-10">
                                                            <p className="pull-left pos-summary">{t('pos.page.subtotalIncludingDiscounts')} </p>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <span className="pull-right pos-summary">
                                                                $ {order.subTotalIncludingDiscounts.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                            {
                                                order.taxesRate ? order.taxesRate.map((tax, index) => {
                                                    return (
                                                        <div className="row" key={index}>
                                                            <div className="col-lg-10">
                                                                <p className="pull-left pos-summary">{tax.name}</p>
                                                            </div>
                                                            <div className="col-lg-2">
                                                                <span className="pull-right pos-summary">
                                                                    $ {tax.value.toFixed(2)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                }) : null
                                            }
                                            {
                                                order.shippingCost ? (
                                                    <div className="row">
                                                        <div className="col-lg-10">
                                                            <p className="pull-left pos-summary">{t('pos.page.deliveryCost')}</p>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <span className="pull-right pos-summary">
                                                                $ {order.shippingCost.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                            {
                                                (order && order.depositAmount > 0) && (
                                                    <div className="row">
                                                        <div className="col-lg-10">
                                                            <p className="pull-left pos-summary">{t('pos.page.depositeAmount')}</p>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <span className="pull-right pos-summary">
                                                                $ {order.depositAmount.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                order && order.useFNTax ?
                                                    <p><i>{t('pos.page.orderFnTaxApplied')}</i></p> : null
                                            }
                                            {
                                                order && order.taxExemptAll ?
                                                    <p><i>{t('pos.page.orderAllTaxExempt')}</i></p> : null
                                            }
                                            <div className="row">
                                                <div className="col-lg-5">
                                                    <p className="pull-left pos-summary order_details_balance purpleText font_jakarta"><strong>{t('common.total')}</strong></p>
                                                </div>
                                                <div className="col-lg-7">
                                                    <span className="pull-right pos-summary value_nowrap order_details_balance purpleText font_jakarta">
                                                        <strong>$ {order.total.toFixed(2)}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            {!order || order.payments.length === 0 ? null :
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <hr style={{ marginTop: "5px", marginBottom: "15px" }} />

                                                        <h5 className="purpleText font_jakarta">{t('pos.page.receivedPayment')}</h5>

                                                    </div>
                                                </div>
                                            }

                                            {
                                                order ? order.payments.map((payment, index) => {
                                                    return (
                                                        <div className="row" key={index} style={{ marginTop: "3px" }}>
                                                            <div className="col-lg-10">
                                                                <span className="pull-left pos-summary purpleText font_jakarta">{(payment.name === "StoreCredit") ? t('pos.page.storeCredit') : payment.name} </span>
                                                            </div>
                                                            <div className="col-lg-2" >
                                                                <span className="pull-right pos-summary">
                                                                    $ {payment.value.toFixed(2)}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    );
                                                }) : null
                                            }
                                        </div>
                                        : null}
                                    {
                                        !order || order.change === 0 ? null : (
                                            <div className="row " >
                                                <div className="col-lg-10">
                                                    <span style={{ fontSize: "150%" }} className="pull-left pos-summary order_details_balance green-text"><strong>{t('pos.page.changeDue')}</strong></span>
                                                </div>
                                                <div className="col-lg-2">
                                                    <span style={{ fontSize: "150%" }} className="pull-right pos-summary value_nowrap order_details_balance green-text">
                                                        <strong>$ {order.change.toFixed(2)}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        !order || order.refund === 0 ? null : (
                                            <div className="row">
                                                <div className="col-lg-10">
                                                    <span className="pull-left pos-summary" style={{ color: "#FF4C5B", fontSize: "150%" }}><strong>{t('pos.page.refundedLower')}</strong></span>
                                                </div>
                                                <div className="col-lg-2">
                                                    <span className="pull-right pos-summary value_nowrap" style={{ color: "#FF4C5B", fontSize: "150%" }}>
                                                        <strong>$ {order.refund.toFixed(2)}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 sales_payment bgWhiteColorMenu">
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <POSPayment name="POSPayments"
                                                    key={this.state.keyCount}
                                                    disableAllButtons={disableAllButtons || allowPayment}
                                                    openEmailInvoiceDialog={this.openEmailInvoiceDialog}
                                                    printReceipt={this.printReceipt}
                                                    printCredit={this.printCredit}
                                                    payByCardPIC={this.payByCardPIC}
                                                    payByGlobal={this.payByGlobal}
                                                    barcodeListener={this.barcodeListener}
                                                    printPaystoneGiftCardReceipt={this.printPaystoneGiftCardReceipt}
                                                    printBirchmountGiftCardReceipt={this.printBirchmountGiftCardReceipt}
                                                    order={order}
                                                    onPaymentSelect={this.onPaymentSelect}
                                                    ToggleClosePayment={this.ToggleClosePayment}
                                                    printPaystoneInStoreReceipt={this.printPaystoneInStoreReceipt}
                                                />
                                                {this.props.isMedical &&
                                                    <div className="btnPaymentContainer p-4">
                                                        <CustomButton
                                                            type="FlatButtonPrimary"
                                                            name={"printAllLabelsButton"}
                                                            fullWidth={true}
                                                            className="pull-right vertical-space btn-border-pos"
                                                            label={t('pos.page.printAllLabels')}
                                                            disabled={allowPrintAllLabels}
                                                            onTouchTap={() => this.printAllLabel()} />
                                                    </div>
                                                }
                                            </div>
                                            <div className="col-xl-12 row p-0 mt-2">
                                                {
                                                    (p.storeCredit && p.storeCredit.value > 0) ? (
                                                        <div className='refundBtn'>
                                                            <Button
                                                                name={"printStoreCreditButton"}
                                                                fullWidth={true}
                                                                className="pull-right vertical-space text-xl refundBtn-inner"
                                                                onClick={() => this.printStoreCredit()} >{t('pos.page.printStoreCredit')}</Button>
                                                        </div>
                                                    ) : null
                                                }
                                                {
                                                    orderIsCompleted ? (
                                                        <React.Fragment>
                                                            <div className="col-xl-4 btns-payment-receipt">
                                                                <CustomButton
                                                                    type="RaisedButton"
                                                                    name={"printReceiptButton"}
                                                                    fullWidth={true}
                                                                    className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                    label={t('pos.page.printReceipt')}
                                                                    primary={true}
                                                                    onTouchTap={() => this.printReceipt()} />
                                                            </div>
                                                            {order && order.payments && order.payments.find(_ => _.name === 'Credit' || _.name === 'Debit') && this.props.monerisEnabled ? (
                                                                <React.Fragment>
                                                                    <div className="col-xl-4 btns-payment-receipt">
                                                                        <CustomButton
                                                                            type="RaisedButton"
                                                                            name={"openDrawerBtn"}
                                                                            fullWidth={true}
                                                                            className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                            label={t('pos.page.printMerchantReceipt')}
                                                                            primary={true}
                                                                            onTouchTap={() => this.printMoneris('merchant')} />
                                                                    </div>
                                                                    <div className="col-xl-4 btns-payment-receipt">
                                                                        <CustomButton
                                                                            type="RaisedButton"
                                                                            name={"openDrawerBtn"}
                                                                            fullWidth={true}
                                                                            className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                            label={t('pos.page.printCustomerReceipt')}
                                                                            primary={true}
                                                                            onTouchTap={() => this.printMoneris('customer')} />
                                                                    </div>
                                                                </React.Fragment>
                                                            ) : null
                                                            }
                                                            <div className="col-xl-4 btns-payment-receipt">
                                                                <CustomButton
                                                                    type="RaisedButton"
                                                                    name={"openDrawerBtn"}
                                                                    fullWidth={true}
                                                                    className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                    label={t('pos.page.openDrawer')}
                                                                    primary={true}
                                                                    onTouchTap={() => this.openDrawer()} />
                                                            </div>
                                                            <div className="col-xl-4 btns-payment-receipt">
                                                                <CustomButton
                                                                    type="RaisedButton"
                                                                    name={"emailReceiptButton"}
                                                                    fullWidth={true}
                                                                    className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                    label={t('pos.page.emailReceipt')}
                                                                    primary={true}
                                                                    onTouchTap={() => this.emailReceipt()} />
                                                            </div>
                                                            <div className="col-xl-4 btns-payment-receipt">
                                                                <CustomButton
                                                                    type="RaisedButton"
                                                                    name={"emailReceiptButton"}
                                                                    fullWidth={true}
                                                                    className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                    label={t('pos.page.smsReceipt')}
                                                                    primary={true}
                                                                    onTouchTap={() => this.SMSReceipt()} />
                                                            </div>
                                                            {order.patientId == 0 && orderIsCompleted ?
                                                                <div className="col-xl-4 btns-payment-receipt">
                                                                    <CustomButton
                                                                        type="RaisedButton"
                                                                        name={"assignMemberButton"}
                                                                        fullWidth={true}
                                                                        className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                        label={t('pos.page.assignMember')}
                                                                        primary={true}
                                                                        onTouchTap={() => this.openAssignMemberDialog()} />
                                                                </div>
                                                                : ""
                                                            }
                                                            {this.props.dutchieIsEnabled && orderIsCompleted && !order.onlineOrderCode ?
                                                                <div className="col-xl-4 btns-payment-receipt">
                                                                    <CustomButton
                                                                        type="RaisedButton"
                                                                        name={"addDutchieButton"}
                                                                        fullWidth={true}
                                                                        className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                        label={t('pos.page.addAsDutchieOrder')}
                                                                        onTouchTap={() => this.openAddDutchieDialog("Dutchie")}
                                                                    />
                                                                </div>
                                                                : ""
                                                            }
                                                            {this.props.leaflyEnabled && orderIsCompleted && !order.onlineOrderCode ?
                                                                <div className="col-xl-4 btns-payment-receipt">
                                                                    <CustomButton
                                                                        type="RaisedButton"
                                                                        name={"addLeaflyButton"}
                                                                        fullWidth={true}
                                                                        className="pull-right vertical-space btnNewBrandPOS btns-payment-receipt-inner"
                                                                        label={t('pos.page.addLeaflyOrder')}
                                                                        onTouchTap={() => this.openAddDutchieDialog("Leafly")}
                                                                    />
                                                                </div>
                                                                : ""
                                                            }
                                                        </React.Fragment>
                                                    ) : null
                                                }
                                            </div>
                                        </div>
                                    </div>{/* end col-4 div */}
                                </DialogInput>
                            </section>{/* end section */}



                            {/* CHECK ID Dialog Input */}
                            {this.props.idPopupEnabled && (this.props.posOrder == null || this.props.posOrder.status != "Completed") && (
                                <DialogInput
                                    title={<DialogHeader text={t('pos.page.checkPhotoId')} classicClass="posDialogClassic" classicClassFont="classicClassFont" />}
                                    modal={true}
                                    open={this.state.dialogCheckId}>
                                    <p className="pa-2 text-center purpleText mb-2 font-16px">{t('pos.page.askForId')} <br /> {t('pos.page.ageReq')} <br /><br />
                                        {t('pos.page.ageBirthDate')} {new Date().getMonth() + 1}-{new Date().getDate()}-{new Date().getFullYear() - 19}</p>
                                    <CustomButton
                                        key={2}
                                        name="buttonRemoveItem"
                                        label={t('common.confirm')}
                                        className="pull-right btnNewBrandPOS"
                                        primary={true}
                                        onTouchTap={() => this.handleCheckId()}
                                    />
                                </DialogInput>
                            )
                            }
                            {this.state.dialogCheckFNId && <POSFirstNationIdCheckDialog
                                patientId={order ? order.patientId : ``}
                                firstName={order ? order.patientFirstName : ``}
                                lastName={order ? order.patientLastName : ``}
                                open={this.state.dialogCheckFNId}
                                onClose={() => this.setState({ dialogCheckFNId: false })}
                                onConfirm={() => this.handleCheckFNId()}
                            />}
                            <DialogInput
                                title={<DialogHeader text={t('pos.page.buddiOrderSearch')} classicClass="posDialogClassic" />}
                                modal={true}
                                open={this.state.buddiDialogOpen}
                                autoScrollBodyContent={true}
                                className="online-orders-line-dialog checkIn_list"
                                handleClose={() => this.closeBuddiOrdersDialog()}
                                contentStyle={customContentStyle}
                            >
                                <CustomButton name="buttonCancel"
                                    type="Button"
                                    className="corner_X"
                                    label=""
                                    onTouchTap={() => this.closeBuddiOrdersDialog()}
                                />
                                <div className="no-crumb">
                                    <BuddiOrderSearch
                                        name="dialogOnlineOrder"
                                        isDialog={true}
                                        onClose={() => this.closeBuddiOrdersDialog()}
                                    />
                                </div>
                            </DialogInput>

                            <DialogInput
                                title={<DialogHeader text={t('pos.page.leaflyOrderSearch')} classicClass="posDialogClassic" />}
                                modal={true}
                                open={this.state.leaflyDialogOpen}
                                autoScrollBodyContent={true}
                                className="online-orders-line-dialog checkIn_list"
                                handleClose={() => this.closeLeaflyOrdersDialog()}
                                contentStyle={customContentStyle}
                            >
                                <CustomButton name="buttonCancel"
                                    type="Button"
                                    className="corner_X"
                                    label=""
                                    onTouchTap={() => this.closeLeaflyOrdersDialog()}
                                />
                                <div className="no-crumb">
                                    <LeaflyOrderSearch
                                        name="dialogOnlineOrder"
                                        isDialog={true}
                                        onClose={() => this.closeLeaflyOrdersDialog()}
                                    />
                                </div>
                            </DialogInput>

                            {/* Start Dialog Input */}
                            <DialogInput
                                title={<DialogHeaderWithClose
                                    text={this.props.fulfillmentEnabled ? t('pos.page.queuedOrdersLower') : t('pos.page.onlineOrdersLower')}
                                    classicClass="posDialogClassic"
                                    handleClose={() => this.closeOnlineOrderSearch()}
                                />}
                                modal={true}
                                open={this.state.onlineDialogOpen}
                                autoScrollBodyContent={true}
                                className="online-orders-line-dialog checkIn_list"
                                handleClose={() => this.closeOnlineOrderSearch()}
                                contentStyle={customContentStyle}
                            >
                                <div className="no-crumb">
                                    <OnlineOrderSearch
                                        name="dialogOnlineOrder"
                                        isDialog={true}
                                        onClose={() => this.closeOnlineOrderSearch()}
                                    />
                                </div>
                            </DialogInput>

                            <DialogInput
                                title={<DialogHeaderWithClose text={t('pos.page.combosLower')} classicClass="posDialogClassic" handleClose={() => this.closeComboDialog()} />}
                                modal={true}
                                open={this.state.comboDialogOpen}
                                autoScrollBodyContent={true}
                                className="online-orders-line-dialog checkIn_list"
                                handleClose={() => this.closeComboDialog()}
                                contentStyle={customContentStyle}
                            >
                                <br />

                                <CustomButton name="buttonCancel"
                                    type="Button"
                                    className="corner_X"
                                    label=""
                                    onTouchTap={() => this.closeComboDialog()}
                                />

                                <div className="no-crumb">
                                    <POSCombos
                                        name="POSCombo"
                                        isDialog={true}
                                        onClose={() => this.closeComboDialog()}
                                        filterCombos={this.state.filterCombos}
                                        comboProductClicked={this.state.comboProductClicked}
                                        orderId={this.props.posOrder ? this.props.posOrder.id : 0}
                                        checkComboInDateRange={this.checkComboInDateRange}
                                        voidItem={this.voidItem}
                                    />
                                </div>
                            </DialogInput>

                            <DialogInput
                                title={<DialogHeader text={t('pos.cancellationDialog.title')} classicClass="posDialogClassic" />}
                                autoScrollBodyContent={true}
                                actions={[
                                    <CustomButton
                                        key={1}
                                        type="CancelButton"
                                        name="buttonCancelRemoveItem"
                                        className="btn-space"
                                        label={t('common.cancel')}
                                        onTouchTap={() => this.closeDialogCancelOrder()} />,
                                    <CustomButton
                                        key={2}
                                        name="buttonRemoveItem"
                                        label={t('common.confirm')}
                                        primary={true}
                                        className="btnNewBrandPOS"
                                        onTouchTap={() => this.cancelOrder()} />]}
                                modal={true}
                                open={this.state.dialogCancelOrder}>
                                {
                                    this.props.cancelOrderNeedApproval ? (
                                        <div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="alert alert-danger">
                                                        <p className="purpleText">{t('pos.cancellationDialog.alertMessage')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <h4>{t('common.credentialsTitle')}</h4>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <TextInput name="POSOrderCancellationUserName"
                                                        fullWidth={true}
                                                        label={t('common.mgmtTeamUserName')}
                                                        floatingLabelText={t('common.mgmtTeamUserName')}
                                                        hintText={t('common.mgmtTeamUserName')} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <TextInput name="POSOrderCancellationPassword"
                                                        type="password"
                                                        fullWidth={true}
                                                        label={t('common.mgmtTeamPwd')}
                                                        floatingLabelText={t('common.mgmtTeamPwd')}
                                                        hintText={t('common.mgmtTeamPwd')} />
                                                </div>
                                            </div>
                                            <div>
                                                <h4 className="purpleText">{t('pos.page.or')} {t('pos.page.by')} {t('common.pinCode')}</h4>
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <TextInput name="POSOrderCancellationPinCode" hintText={t('common.password')} fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                        :
                                        <div className="row">
                                            <div className="col-lg-12 alert alert-danger">
                                                <p>{t('pos.cancellationDialog.alertMessageNoNeedApproval')}</p>
                                            </div>
                                        </div>
                                }

                            </DialogInput>
                            <DialogConfirm
                                title={t('pos.existingOrderDialog.title')}
                                isOpen={s.dialogOrderExists}
                                message={t('pos.existingOrderDialog.message')}
                                onConfirm={() => this.redirectExistingOrder()}
                                onCancel={() => this.cancelRedirectExistingOrder()}
                            />

                            <DialogInput
                                title={<DialogHeaderWithClose style="pink" text={t('pos.page.cashFlowEngagementNote')} handleClose={() => this.closeCashInNoteDialog()} />}
                                actions={[
                                    <CustomButton
                                        key={1}
                                        name="cashInNotesCancel"
                                        type="Button"
                                        className="corner_X"
                                        primary={false}
                                        onTouchTap={() => this.closeCashInNoteDialog()} />,
                                    <CustomButton
                                        key={2}
                                        className="pull-right space"
                                        name="saveCashInNotes"
                                        label={t('pos.page.saveNote')}
                                        primary={true}
                                        onTouchTap={() => this.saveCashInNote()} />]}
                                modal={true}
                                open={this.state.cashInNoteDialog}>
                                <div>
                                    <div className="row">
                                        <div className="col-lg-8 col-md-10 col-s-12">
                                            <TextInput name={`POSCashInNote`}
                                                fullWidth={true}
                                                label={t('common.note')}
                                                floatingLabelText={t('pos.page.noteAndAmount')}
                                                hintText={t('pos.page.noteAndAmount')} />
                                        </div>
                                    </div>
                                </div>
                            </DialogInput>

                            <DialogInput
                                title={<DialogHeaderWithClose style="pink" text={t('pos.page.cancelAllOpenOrders')} handleClose={() => this.closeCanelOpenOrdersDialog()} />}
                                actions={[
                                    <CustomButton
                                        key={1}
                                        name="closeOpenOrdersCancel"
                                        type="Button"
                                        className="corner_X"
                                        primary={false}
                                        onTouchTap={() => this.closeCanelOpenOrdersDialog()} />,
                                    <CustomButton
                                        key={2}
                                        className="pull-right space"
                                        name="closeOpenOrders"
                                        label={t('common.confirm')}
                                        primary={true}
                                        onTouchTap={() => this.cancelAllOpenOrders()} />]}
                                modal={true}
                                open={this.state.cancelOpenOrdersDialog}>
                                <div>
                                    <div className="row">
                                        <div className="col-s-12">
                                            <h5 className="alert alert-danger">
                                                {t('pos.page.confirmCancelAllOpenOrders')}
                                            </h5>
                                            {
                                                this.props.cancelOrderNeedApproval ? (
                                                    <div>
                                                        <h4>{t('common.credentialsTitle')}</h4>
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <TextInput name="POSOrderCancellationUserName"
                                                                    fullWidth={true}
                                                                    label={t('common.mgmtTeamUserName')}
                                                                    floatingLabelText={t('common.mgmtTeamUserName')}
                                                                    hintText={t('common.mgmtTeamUserName')} />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <TextInput name="POSOrderCancellationPassword"
                                                                    type="password"
                                                                    fullWidth={true}
                                                                    label={t('common.mgmtTeamPwd')}
                                                                    floatingLabelText={t('common.mgmtTeamPwd')}
                                                                    hintText={t('common.mgmtTeamPwd')} />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <h4>{t('pos.page.or')} {t('pos.page.by')} {t('common.pinCode')}</h4>
                                                            <div className="row">
                                                                <div className="col-lg-12">
                                                                    <TextInput name="POSOrderCancellationPinCode" hintText={t('common.password')} fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                    :
                                                    <div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </DialogInput>

                            <POSCashOut name="POSCashOut" show={s.dialogCloseRegister} onCancel={() => this.closeCloseRegisterDialog()} PadVersion={this.props.padVersion} openDrawer={() => this.openDrawerCount()} />

                            <POSCashIn name="POSCashIn" show={s.dialogCashIn} onCancel={() => this.closeDialogCashIn()} openDrawer={() => this.openDrawerCount()} />

                            <POSCashDrop name="POSCashDrop" show={s.dialogCashDrop} onCancel={() => this.closeDialogCashDrop()} PadVersion={this.props.padVersion} openDrawer={() => this.openDrawerCount()} />

                            <POSCloseOpenOrders name="POSCloseOpenOrders" show={s.oldOpenOrdersDialog} onCancel={() => this.closeOldOpenOrdersDialog()} onComfirm={() => this.confirmCloseOpenOrders()} title={t('pos.titles.closeOpenOrders')} message={t('pos.messages.closeOpenOrders')} />

                            <POSCloseOpenOrders name="POSCloseOpenOrders" show={s.oldOpenOnlineOrdersDialog} onCancel={() => this.closeOldOpenOnlineOrdersDialog()} onComfirm={() => this.confirmCloseOpenOnlineOrders()} title={t('pos.titles.closeOpenOnlineOrders')} message={t('pos.messages.closeOpenOnlineOrders')} />

                            <POSRefundAmount name="POSRefundAmount" show={s.openRefundAmount} refundAmount={s.refund} closeDilog={() => this.closeRefundAmountDialog()} />

                            <POSGiftCardInquiry name="POSGiftCardInquiry" show={s.openGiftCardInquiry} onCancel={() => this.closeGiftCardInquiry()} />

                            <POSGiftCardinitialization name="POSGiftCardinitialization" show={s.openGiftCardInit} onCancel={() => this.closeGiftCardInitDialog()} />

                            <POSGiftCardActivation name="POSGiftCardActivation" show={s.openGiftCardActivation} onCancel={() => this.closeGiftCardActivation()} activateOrderId={s.activateOrderId} />

                            <POSGiftCardDeactivation name="POSGiftCardDeactivation" show={s.openGiftCardDeactivation} onCancel={() => this.closeGiftCardDeactivation()} onComfirm={() => this.confirmCloseOpenOrders()} />

                            <POSGiftCardAddToOrder show={s.openSellGiftCard} onCancel={() => this.closeSellGiftCardDialog()} />

                            <POSGiftCardPurchase show={s.genericGiftCardDialog} onCancel={() => this.closeGenericGiftCardDialog()} />

                            <POSGiftCheckBalance show={s.openCheckBalanceDialog} onCancel={() => this.closeCheckBalanceDialog()} />

                            <PaystoneGiftCardCheckBalance name="PaystoneGiftCardCheckBalance" show={s.openPaystoneGiftCardCheckBalance} onCancel={() => this.closePaystoneGiftCardCheckBalanceDialog()} />

                            <PaystoneGiftCardActivation name="PaystoneGiftCardActivation" show={s.openPaystoneGiftCardActivation} onCancel={() => this.closePaystoneGiftCardActivationDialog()} paystoneActivationFromSale={s.paystoneActivationFromSale} />

                            <PaystoneGiftCardCancel name="PaystoneGiftCardCancel" show={s.openPaystoneGiftCardCancel} onCancel={() => this.closePaystoneGiftCardCancelDialog()} />

                            <BirchmountGiftCardCheckBalance name="BirchmountGiftCardCheckBalance" show={s.openBirchmountGiftCardCheckBalance} onCancel={() => this.closeBirchmountGiftCardCheckBalanceDialog()} />

                            <BirchmountGiftCardActivation name="BirchmountGiftCardActivation" show={s.openBirchmountGiftCardActivation} onCancel={() => this.closeBirchmountGiftCardActivationDialog()} birchmountActivationFromSale={s.birchmountActivationFromSale} />

                            <BirchmountGiftCardCancel name="BirchmountGiftCardCancel" show={s.openBirchmountGiftCardCancel} onCancel={() => this.closeBirchmountGiftCardCancelDialog()} />

                            <POSEmailReceiptDialog name="POSEmailReceiptDialog" show={s.openEmailReceiptDialog} onCancel={() => this.closeEmailReceiptDialog()} onComfirm={() => this.emailReceipt()} />

                            <POSEmailReceiptDialog name="POSEmailInvoiceDialog" show={s.openEmailInvoiceDialog} onCancel={() => this.closeEmailInvoiceDialog()} onComfirm={() => this.emailInvoice()} />

                            <POSSMSReceiptDialog name="POSSMSReceiptDialog" show={s.openSMSReceiptDialog} onCancel={() => this.closeSMSReceiptDialog()} onComfirm={() => this.SMSReceipt()} />

                            {/* Dialog to ask the lot number when a product is scanned */}
                            <POSProductDetails
                                title={`${t('pos.page.addToOrder')}${s.dialogProduct ? ' - ' + s.dialogProduct.name : ''} `}
                                open={s.openDialogAddProduct}
                                name={p.name + 'Details'}
                                product={s.dialogProduct}
                                webSocket={p.webSocket}
                                onCancel={() => this.closeAddProductDialog()} />

                            {s.addMoreProductDetail ? <POSAddMoreDialog
                                title={<DialogHeaderWithClose style="pink" text={`${t('pos.page.addMoreProdToOrder')}${s.addMoreProductDetail ? ' - ' + s.addMoreProductDetail.name : ''} `} handleClose={() => this.closeAddMoreProductDialog()} />}
                                open={s.addMoreProductDialog}
                                name={'AddMoreProductDetails'}
                                product={s.addMoreProductDetail}
                                onCancel={() => this.closeAddMoreProductDialog()} /> : null}

                            <POSProductSuggestion updateDialogProduct={this.updateDialogProduct} product={s.dialogProduct} addToOrder={this.addToOrder} isOpen={s.productSuggestionDialog} onClose={() => this.closeProductSuggestionDialog()} />

                            <POSVisitDiscountDialog name="POSVisitDiscountDialog" open={s.visitDiscountDialogOpen} onClose={() => this.closeVisitDiscountDialog()} />

                            <POSSpringbigOffersDialog name="POSSpringBigOffersDialog" open={s.springBigOffersDialogOpen} onClose={() => this.closeSpringBigOffersDialog()} />

                            <POSSpringbigRewardsDialog name="POSSpringBigRewardsDialog" open={s.springBigRewardsDialogOpen} onClose={() => this.closeSpringBigRewardsDialog()} />

                            <POSAlpineIQRewardsDialog name="POSAlpineIOQRewardsDialog" open={s.alpineIQRewardsDialogOpen} onClose={() => this.closeAlpineIQRewardsDialog()} />

                            <POSMonerisTipDialog name="POSMonerisTipDialog" open={s.monerisTipDialog} onClose={() => this.closeMonerisTipDialog()} onConfirm={() => this.setMonerisPinpad("T")} />

                            <POSOrderHistory isOpen={this.state.showOrderHistoryDialog} onCancel={() => this.closeOrderHistoryDialog()} />

                            <POSPatientSave isOpen={this.state.showPatientSaveDialog} onCancel={() => this.closePatientSaveDialog()} patientId={this.props.posOrder ? this.props.posOrder.patientId : null} />

                            <DialogInput
                                title={<DialogHeaderWithClose text={t('pos.page.addMember')} classicClass="posDialogClassic" classicClassFont="classicClassFont" handleClose={() => this.closeAddMemberDialog()} />}
                                modal={true}
                                open={this.state.addMemberOpenDialog}
                                autoScrollBodyContent={true}
                                handleClose={() => this.closeAddMemberDialog()}
                                contentStyle={addMemberStyle}
                                className="posAddMember"
                            >
                                <div className="no-crumb">
                                    <PatientSave patientId={0} isDialog={true} closeDialog={() => this.closeAddMemberDialog()} />
                                </div>
                            </DialogInput>
                            {(orderIsCompleted || orderIsCancelled) ? null : <POSProductListPage dialogProduct={s.dialogProduct} addToOrder={this.addToOrder} />}
                        </div>

                        {this.state.scrollButtonShow ? <div className="back-to-past-button" onClick={this.toTheTop}>
                            <DoubleArrow sx={{ minHeight: "0", minWidth: "0", padding: "0", width: "24px", height: "24px", color: "white" }} />
                            <h6 style={{ fontWeight: "bold", marginTop: 0, color: "white", fontFamily: "Plus Jakarta Sans" }}>{t('pos.page.top')}</h6>
                        </div> : null}

                        <DialogInput
                            open={this.state.showLastItemDialog}
                            title={<DialogHeaderWithClose handleClose={() => this.closeLastItemDialog()} />}
                        >
                            <div>{t('pos.page.followingOutOfStock')}: <br /><br /></div>
                            <ul>
                                {lastItems.map(x => { return (<li>{x.name}</li>) })}
                            </ul>
                        </DialogInput>

                        <DialogInput
                            title={t('pos.page.messageUpper')}
                            modal={true}
                            open={this.state.dialogVapeSale}>
                            <p className="pa-2 text-center">{t('pos.page.vapeSaleExchangePolicy')}</p>
                            <CustomButton
                                key={2}
                                name="buttonRemoveItem"
                                label={t('common.confirm')}
                                className="pull-right"
                                primary={true}
                                onTouchTap={() => this.handleVapeSaleDialog()}
                            />
                        </DialogInput>
                        <POSOpenDrawerPinDialog name="POSOpenDrawerPinDialog" open={s.dialogOpenDrawerPin} handleClose={() => this.openDrawerPinDialog(s.dialogOpenDrawerPin)} openDrawer={this.openDrawer} />
                        <DialogConfirm
                            title={t('pos.page.websocketError')}
                            isOpen={s.dialogWebSocketError && p.posFraudProtection}
                            message={t('pos.page.cannotConnectPrinter')}
                            onConfirm={() => this.setState({ dialogWebSocketError: false })}
                            onCancel={() => this.setState({ dialogWebSocketError: false })}
                        />
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        store: state.common.store,
        patient: state.form["POSPatientPatient"],
        posOrder: state.entity.posOrder,
        product: state.entity.productDetail,
        scannedProducts: state.entity.scannedProducts,
        posShowProductCount: state.common.applicationSettings.posShowProductCount,
        newProduct: state.form["posNewProductOrder"],
        newComboProduct: state.form["posNewComboProductOrder"],
        posOrderCancelled: state.form["posOrderCancelled"],
        posOrderCancelledAll: state.form["posOrderCancelledAll"],
        posOrderError: state.entity.posOrderError,
        cancellationCredentials: selectPOSCancellationCredentials(state),
        openOrdersCancellation: selectOpenOrdersCancellation(state),
        openOnlineOrdersCancellation: selectOpenOnlineOrdersCancellation(state),
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        updateDeviceIpSaveError: state.form.updateDeviceIpSaveError,
        orderIdOpenForRefund: state.form[`${ownProps.name}POSOrderOpenForRefund`],
        storeCredit: (state.entity.posOrder) ? state.entity.posOrder.storeCredit : [],
        posEmailReceiptSuccess: state.form["posEmailReceiptSuccess"],
        posSMSReceiptSuccess: state.form["posSMSReceiptSuccess"],
        usePinPad: state.common.applicationSettings.enablePinPasswordOnPOS,
        userPin: JSON.parse(sessionStorage.getItem('pinUser')) ? JSON.parse(sessionStorage.getItem('pinUser')) : state.entity.pin,
        isMedical: state.common.applicationSettings.isMedical,
        barcodeNotFound: state.entity.barcodeNotFound,
        hasWebMenu: state.common.applicationSettings.hasWebMenu,
        posFraudProtection: state.common.applicationSettings.posFraudProtection,
        numberOfCopies: state.common.applicationSettings.numberOfCopies,
        savedDevice: state.entity.SavedDevice ? state.entity.SavedDevice : null,
        cashInSavedTime: state.entity.cashInSavedTime ? state.entity.cashInSavedTime : null,
        cashDropSavedTime: state.entity.cashDropSavedTime ? state.entity.cashDropSavedTime : null,
        cashFlow: state.entity.cashFlow,
        oldOpenOrders: state.entity.oldOpenOrders,
        oldOpenOrderGotTime: state.entity.oldOpenOrderGotTime,
        oldOpenOnlineOrders: state.entity.oldOpenOnlineOrders,
        memberEnabled: state.common.applicationSettings.memberEnabled,
        cancelOrderNeedApproval: state.common.applicationSettings.cancelOrderNeedApproval,
        isShopNameDisplayed: state.common.applicationSettings.isShopNameDisplayed,
        idPopupEnabled: state.common.applicationSettings.idPopupEnabled,
        cashInEnabled: state.common.applicationSettings.cashInEnabled,
        userPinAuthenticated: state.entity.pin ? state.entity.pin.authenticated : null,
        padVersion: state.common.applicationSettings.padVersion,
        voidItemShowOnReceipt: state.common.applicationSettings.voidItemShowOnReceipt,
        buddiEnabled: state.common.applicationSettings.buddiEnabled,
        leaflyEnabled: state.common.applicationSettings.leaflyEnabled,
        monerisEnabled: state.common.applicationSettings.monerisEnabled,
        monerisReceiptsTime: state.entity.monerisReceiptsTime ? state.entity.monerisReceiptsTime : null,
        monerisReceipts: state.entity.monerisReceipts ? state.entity.monerisReceipts : null,
        fianlSaleTextShowOnReceipt: state.common.applicationSettings.fianlSaleTextShowOnReceipt,
        fulfillmentEnabled: state.common.applicationSettings.fulfillmentEnabled,
        fulfillmentPayFirst: state.common.applicationSettings.fulfillmentPayFirst,
        monerisCustomerCopyAutoPrinted: state.common.applicationSettings.monerisCustomerCopyAutoPrinted,
        monerisMerchantCopyAutoPrinted: state.common.applicationSettings.monerisMerchantCopyAutoPrinted,
        monerisReceiptType: state.entity.monerisReceiptType,
        sendToFulfillmentSuccess: state.entity.sendToFulfillmentSuccess,
        PosPaymentAmount: state.form.POSPaymentsAmount,
        onlyCashPaymentOpenDrawer: state.common.applicationSettings.onlyCashPaymentOpenDrawer,
        loading: (state.common.ajaxCallsInProgress > 0) || state.common.loading,
        openQueuedOrdersCount: state.entity.openQueuedOrdersCount,
        openBuddiOrdersCount: state.entity.openBuddiOrdersCount,
        openLeaflyOrdersCount: state.entity.openLeaflyOrdersCount,
        getOpenOnlineOrdersInterval: state.common.applicationSettings.getOpenOnlineOrdersInterval,
        getWordpressOrdersInterval: state.common.applicationSettings.getWordpressOrdersInterval,
        monerisGiftCardEnabled: state.common.applicationSettings.monerisGiftCardEnabled,
        giftCardInitializationTime: state.entity.giftCardInitializationTime || null,
        giftCardDatInquiryResponse: state.entity.giftCardDatInquiryResponse || null,
        giftCardDeactivationResponse: state.entity.giftCardDeactivationResponse || null,
        giftCardActivationResponse: state.entity.giftCardActivationResponse || null,
        giftCardPurchaseResponse: state.entity.giftCardPurchaseResponse || null,
        giftCardRefundReponse: state.entity.giftCardRefundReponse || null,
        giftCardPurchaseFailResponse: state.entity.giftCardPurchaseFailResponse || null,
        giftCardActivationFailResponse: state.entity.giftCardActivationFailResponse || null,
        posEmailReceiptDialogEmail: state.form["POSEmailReceiptDialogEmail"] || null,
        posEmailInvoiceDialogEmail: state.form["POSEmailInvoiceDialogEmail"] || null,
        posSMSReceiptDialogSMS: state.form["POSSMSReceiptDialogSMS"] || null,
        posEmailReceiptAddress: state.form["posEmailReceiptAddress"] || null,
        showAddMemberAfterSale: state.common.applicationSettings.showAddMemberAfterSale,
        logoutPinAfterSeconds: state.common.applicationSettings.logoutPinAfterSeconds,
        showRemoveFNTaxBtn: state.common.applicationSettings.showRemoveFNTaxBtn,
        wordpressEnabled: state.common.applicationSettings.wordpressEnabled,
        showEmployeeNameOnReceipt: state.common.applicationSettings.showEmployeeNameOnReceipt,
        posReceiptBottomText: state.common.applicationSettings.posReceiptBottomText,
        showOpenOnlineOrders: state.common.applicationSettings.showOpenOnlineOrders,
        showPOSBulkImport: state.common.applicationSettings.showPOSBulkImport,
        showOpenOrders: state.common.applicationSettings.showOpenOrders,
        inventoryFlags: state.entity.inventoryFlags,
        inventroyFlagGotTime: state.entity.inventroyFlagGotTime,
        paystoneGiftCardEnabled: state.common.applicationSettings.paystoneGiftCardEnabled,
        birchmountGiftCardEnabled: state.common.applicationSettings.birchmountGiftCardEnabled,
        visitCountsForDiscount: state.common.applicationSettings.visitCountsForDiscount,
        visitCountDiscount: state.common.applicationSettings.visitCountDiscount,
        paystoneGiftCardOperation: state.entity.paystoneGiftCardOperation || null,
        birchmountGiftCardOperation: state.entity.birchmountGiftCardOperation || null,
        combos: state.entity.comboList || [],
        springbigApiKey: state.common.applicationSettings.springbigApiKey || "",
        alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey || "",
        pinPadId: state.entity.pinPadId,
        hideRewards: state.common.applicationSettings.hideRewards || false,
        alpineIQwalletCode: state.common.applicationSettings.alpineIQwalletCode || "",
        showOriginalNonMemberPrice: state.common.applicationSettings.showOriginalNonMemberPrice,
        cashInNotes: state.form["POSCashInNote"] || "",
        wallet: state.entity.alpineIQwallet,
        alpineIQCheckInButton: state.common.applicationSettings.alpineIQCheckIn || false,
        springBigRewardsOff: state.common.applicationSettings.springBigRewardsOff || false,
        dutchieIsEnabled: state.common.applicationSettings.dutchieIsEnabled,
        inStoreTipEnabled: state.common.applicationSettings.inStoreTipEnabled,
        posMonerisTipDialogTipOption: state.form["POSMonerisTipDialogTipOption"] || null,
        receiptShowGSTNumber: state.common.applicationSettings.receiptShowGSTNumber,
        receiptShowTerminal: state.common.applicationSettings.receiptShowTerminal,
        receiptShowEmployeeFirstName: state.common.applicationSettings.receiptShowEmployeeFirstName,
        receiptShowEmployeeLastName: state.common.applicationSettings.receiptShowEmployeeLastName,
        receiptShowOrderNumber: state.common.applicationSettings.receiptShowOrderNumber,
        receiptShowMemberSavings: state.common.applicationSettings.receiptShowMemberSavings,
        receiptShowProductCount: state.common.applicationSettings.receiptShowProductCount,
        receiptShowMemberName: state.common.applicationSettings.receiptShowMemberName,
        receiptShowMemberPoints: state.common.applicationSettings.receiptShowMemberPoints,
        receiptShowVisitCount: state.common.applicationSettings.receiptShowVisitCount,
        receiptShowCreatedDate: state.common.applicationSettings.receiptShowCreatedDate,
        posCreated: state.entity.posCreated,
        showVapeProductSaleDialog: state.common.applicationSettings.showVapeProductSaleDialog,
        stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled,
        genericGiftCardEnabled: state.common.applicationSettings.genericGiftCardEnabled,
        generalAccessorySaleEnabled: state.common.applicationSettings.generalAccessorySaleEnabled,
        POSGenericGiftCardOrderSucessList: state.entity.POSGenericGiftCardOrderSucessList ? state.entity.POSGenericGiftCardOrderSucessList : [],
        sbOptInSpringBig: state.form["POSPagesbOptInSpringBig"] || false,
        sbPatientExists: state.form["POSPagesbPatientExists"] || false,
        taxExemptAllEnabled: state.common.applicationSettings.taxExemptAllEnabled,
        rewardAmount: state.form.Amount,
        rewardComment: state.form.Comment,
        rewardSuccess: state.entity.setReward,
        rewardError: state.form.RewardPointsError,
        rewardUserName: state.form.POSRewardUsername,
        rewardPassword: state.form.POSRewardPassword,
        rewardPinCode: state.form.POSRewardPinCode || "",
        patientIdType: state.form.POSPatientIdentificationType || "",
        patientIdNumber: state.form.POSPatientIdentificationNumber || "",
        fulfillmentMustScanAllForComplete: state.common.applicationSettings.fulfillmentMustScanAllForComplete,
        eliteMemberStartDate: state.entity.posOrder ? state.entity.posOrder.eliteMemberStartDate : null,
        eliteMemberEndDate: state.entity.posOrder ? state.entity.posOrder.eliteMemberEndDate : null,
        internalMessage: state.entity.internalMessage,
        bannerImageURL: state.entity.bannerImageURL,
        offlineProductScan: state.common.applicationSettings.offlineProductScan,
        cachingProducts: state.common.applicationSettings.cachingProducts,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired,
        httpPrintingEnabled: state.common.applicationSettings.httpPrintingEnabled,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        cleanProductDetail: () => dispatch(cleanProductDetail()),
        getSettings: (branchId, compName) => dispatch(getSettings(branchId, compName)),
        getProductByBarcode: (barcode, branchId) => dispatch(getProductByBarcode(barcode, branchId)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        formError: (name, error) => dispatch(formError(name, error)),
        saveOrder: (order) => dispatch(saveOrder(order)),
        clearPOSError: () => dispatch(clearPOSError()),
        voidItem: (orderId, productOrderId, deviceId, employeeId, branchId, removeProduct, modifiedDate) => dispatch(voidItem(orderId, productOrderId, deviceId, employeeId, branchId, removeProduct, modifiedDate)),
        voidOfflineItem: (orderId, productOrderId, deviceId, employeeId, branchId, removeProduct, modifiedDate, isInspired) => dispatch(voidOfflineItem(orderId, productOrderId, deviceId, employeeId, branchId, removeProduct, modifiedDate, isInspired)),
        saveOrderOffline: (posOrder, product, isInspired) => dispatch(saveOrderOffline(posOrder, product, isInspired)),
        updatePackageReference: (products, orderProductId) => dispatch(updatePackageReference(products, orderProductId)),
        getOrder: (orderId, branchId, deviceId) => dispatch(getOrder(orderId, branchId, deviceId)),
        cancelOrder: (orderId, model) => dispatch(cancelOrder(orderId, model)),
        initializeStorePOS: () => dispatch(initializeStorePOS()),
        clearPOSCancellationDialog: () => dispatch(clearPOSCancellation()),
        showError: (message) => dispatch(showError(message)),
        updateDeviceIp: (id, ip) => dispatch(updateDeviceIp(id, ip)),
        getPOS: (deviceId, branchId) => dispatch(getPOS(deviceId, branchId)),
        finalizeOrder: (model) => dispatch(finalizeOrder(model)),
        posEmailReceipt: (orderId) => dispatch(posEmailReceipt(orderId)),
        posSMSReceipt: (orderId) => dispatch(posSMSReceipt(orderId)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        addProductToPOSOder: (product) => dispatch(addProductToPOSOder(product)),
        addComboProductToPOSOrder: (comboProducts) => dispatch(addComboProductToPOSOrder(comboProducts)),
        setProductFilter: (productId) => dispatch(setProductFilter(productId)),
        lockPinPassword: () => dispatch(lockPinPassword()),
        setPinUserToStore: (PinUser) => dispatch(setPinUserToStore(PinUser)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getDeviceByIP: (ipAddress, branchId) => dispatch(getDeviceByIP(ipAddress, branchId)),
        getOldOpenOrders: (branchId) => dispatch(getOldOpenOrders(branchId)),
        cancelOpenOrders: (model) => dispatch(cancelOpenOrders(model)),
        cancelAllOpenOrders: (branchId, model) => dispatch(cancelAllOpenOrders(branchId, model)),
        cancelOpenOnlineOrders: (model) => dispatch(cancelOpenOnlineOrders(model)),
        getOpenOnlineOrdersCount: (branchId) => dispatch(getOpenOnlineOrdersCount(branchId)),
        getWordpressOrdersUpdate: (branchId) => dispatch(getWordpressOrdersUpdate(branchId)),
        getManualWordpressOrdersUpdate: (branchId) => dispatch(getManualWordpressOrdersUpdate(branchId)),
        cashInAmount: (amount, deviceId, branchId) => dispatch(cashInAmount(amount, deviceId, "POSCashIn", branchId)),
        trackingDrawerOpen: (model) => dispatch(trackingDrawerOpen(model)),
        getMonerisReceiptByOrderId: (model) => dispatch(getMonerisReceiptByOrderId(model)),
        getInventoryFlag: (branchId) => dispatch(getInventoryFlag(branchId)),
        getCombos: (model) => dispatch(getCombos(model)),
        getSpringbigOffers: (model) => dispatch(getSpringbigOffers(model)),
        getSpringbigRewards: (model) => dispatch(getSpringbigRewards(model)),
        getSpringbigMemberPoints: (model) => dispatch(getSpringbigMemberPoints(model)),
        alpineIQviewWallet: (model) => dispatch(alpineIQviewWallet(model)),
        alpineIQverifyWallet: (model) => dispatch(alpineIQverifyWallet(model)),
        clearAlpineIQ: () => dispatch(clearAlpineIQ()),
        cashFlowNotes: (notes, id, branchId) => dispatch(cashFlowNotes(notes, id, branchId)),
        alpineIQCheckIn: (model) => dispatch(alpineIQCheckIn(model)),
        sendOrderToFulFillment: (order) => dispatch(sendOrderToFulFillment(order)),
        getPatientOrders: (model) => dispatch(getPatientOrders(model)),
        patientSpringBigNotifications: (model) => dispatch(patientSpringBigNotifications(model)),
        setIDOrderHistory: (id) => dispatch(idOrderHistoryDialog(id)),
        cleanOrderDetail: (itemsPerPage) => dispatch(cleanOrderDetail(itemsPerPage)),
        clearPriceMatchRows: () => dispatch(clearPriceMatchRows()),
        getProducts: (filters) => dispatch(getSellableProducts(filters)),
        updateRewardPoint: (model, compName) => dispatch(updateRewardPoint(model, compName)),
        getOrderPatientReward: (id) => dispatch(getOrderPatientReward(id)),
        resetReward: () => dispatch(resetReward()),
        clearOfflineOrderError: (model) => dispatch(clearOfflineOrderError(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(withTranslation()(POSPage)))